/**
 * The en-US locale file.  This must contain all possible values for desktop
 */
export default Object.freeze({
    "docfinity": "DocFinity",
    "edit": "Edit",
    "open": "Open",
    "delete": "Delete",
    "export": "Export",
    "refresh": "Refresh",
    "reset": "Reset",
    "add.new": "Add New",
    "assign": "Assign",
    "run": "Run",
    "type": "Type",
    "join": "{0}, {1}",
    "joinLast": "{0}, and {1}",
    "joinTwo": "{0} and {1}",
    "joinTwoOr": "{0} or {1}",
    "joinLastOr": "{0}, or {1}",

    "try.again": "Try Again",
    "menu.logout": "Log Out of DocFinity",

    "content.loading": "Content Loading",
    "content.loaded": "Content Loaded",

    "None": "None",
    "yes": "Yes",
    "no": "No",
    "use": "Use",
    "do.not.use": "Do not use",
    "required": "Required",
    "not.required": "Not required",

    // element display names
    "paragraph": "Paragraph",
    "heading.1": "Heading 1",
    "heading.2": "Heading 2",
    "heading.3": "Heading 3",
    "heading.4": "Heading 4",

    // time
    "time.hour": "hour",
    "time.hours": "hours",
    "time.minutes": "minutes",
    "time.minutes.conditional.1": "minute",
    "time.second": "second",
    "time.seconds": "seconds",

    //Validation rules
    "date.invalid": "Date should be in the following format: {0}",

    // errors
    "error.javascript": "Please refresh your browser. A problem has occurred locally that can't be fixed without a browser refresh.",
    "urlapi.missing": "DocFinity URL API requires these parameters that were not specified or were invalid: {0}",
    "error.submit.invalid": "Please fix invalid fields before submitting.",
    "error.type.enterprise.search": "Enterprise Search Error",
    "error.type.version.major": "Version is not major",
    "error.type.enterprise.search.disabled": "Document Type Enterprise Search Disabled",
    "error.type.document.not.indexed": "Document not fully indexed",
    "error.type.ocr": "OCR call failure",
    "error.type.ocr.busy": "OCR server busy",
    "error.type.ocr.config": "OCR server setup failure",
    "error.type.license": "DocFinity license is missing",
    "error.type.file": "File access error",
    "error.type.pdf": "PDF conversion failure",
    "error.type.ocr.content": "Unsupported OCR content",
    "error.type.invalid": "Invalid file type",
    "error.type.ocr.connection": "OCR connection failure",
    "error.type.ocr.response": "OCR invalid response",
    "error.type.file.missing": "File not found",

    // session
    "session.expiring": "Session Expiring",
    "session.expire.warn": "Your session will expire soon. Do you want to remain logged in?",

    //Login screens
    "login": "Login",
    "login.loginHeader": "DocFinity Login",
    "login.logoutHeader": "DocFinity Logout",
    "login.error": "DocFinity Login Error",
    "login.password": "Password",
    "login.remember": "Remember Me",
    "login.rememberLabel": "Keep me logged in",
    "login.reset": "Password Reset",
    "login.resetHelp": "If you've forgotten your password, either ask an administrator for help or enter your username to set a new password that will be emailed to you.",
    "login.getNew": "Get New Password",
    "login.back": "&#8592; Back to Login",
    "login.helpHeader": "Password Help",
    "login.resetMessage": "Your password has been reset. A new password has been sent to your email",
    "login.changeMessage": "The password for your account is expired. Please enter a new password to continue.",
    "login.passwordMismatch": "The new passwords entered do not match.",
    "login.requiredField": "A required field is empty.",
    "login.old": "Current password",
    "login.new": "New password",
    "login.confirm": "Confirm new password",
    "login.genericError": "The credentials entered are incorrect.",
    "login.expired": "Your password must be changed before login can continue.",
    "login.continue": "Continue to Login",
    "login.fallback": "Go to DocFinity Administration Module",
    "login.logoutError": "You have been logged out.",
    "login.logout.external": "For security purposes, your session has expired. Please refresh your browser to access the form again.",
    "login.serviceError": "Login failed. {0}. Please try again.",
    "allow.access": "Allow Access",
    "login.selection.instructions": "Please choose how you would like to log in from the options below.",
    "login.btn": "{0} Log In",
    "logout.of": "Log Out of {0}",
    "login365.instructions": "In order to log in, DocFinity will open a new window.",

    "consent.query": "A desktop application would like access to your DocFinity account. Any linked application will be able to do all operations on your behalf. Is this ok? ",
    "remember.me": "Remember me for 30 days",
    "thank.you.close": "Thank you! You may close this window.",

    //Validation rules
    "validation.noSpace": "This field may not include any whitespace.",
    "validation.pattern": "This field is not valid.",
    "validation.generic.field": "This field",
    "validation.generic.min": "{0} must be greater than or equal to {1}.",
    "validation.generic.max": "{0} must be less than or equal to {1}.",
    "validation.regex": "Regular Expression is not valid.",
    "validation.regex.runtime": "The validator on {0} is not valid. Please have an administrator check the configuration.",
    "email.invalid": "The email address is not valid.",
    "email.details": "Email Details",
    "email.type.imap": "IMAP",

    //Forms
    "forms.edit": "Edit {0} - {1}",
    "forms.view": "View {0} - {1}",
    "form.done": "Form Submitted",

    //Widget
    "widget.missing.id": "{0} widget requires an ID.",

    //forms shared
    "main.forms.submit.success": "The form was successfully submitted.",
    "main.forms.error.close": "Return to the list of available forms",
    "main.forms.submit.fail": "The form was not able to be submitted.",
    "external.urlapi.missing": "There are parameters which were not specified or invalid: {0}",
    "main.forms.error.edit": "This form is missing the necessary security to edit.",
    "main.forms.error.view": "This form is missing the necessary security to view.",
    "main.forms.url": "Link could not be opened due to a pop-up blocker. Click to go to: <a href='{0}' target='_blank'>{0}</a>",
    "main.forms.url.begin": "Link could not be opened due to a pop-up blocker.",
    "main.forms.error.completed": "This form has already been marked as completed and can no longer be edited.",
    "external.forms.link": "Go to the link now:",

    // validation messages shared
    "main.index.mask.error": "{0} is incomplete.",
    "main.index.regexp.error": "{0}: {1}",
    "main.index.required": "{0} is required.",
    "main.index.required.dependencies": "{0} is required. Please fill out its associated fields: {1}.",
    "main.index.minLength": "{0} should be at least {1} characters.",
    "main.index.maxLength": "{0} should be no more than {1} characters.",
    "main.index.dateMin": "{0} must be on or after {1}.",
    "main.index.dateMax": "{0} must be on or before {1}.",
    "main.index.dateInvalid": "{0}: Enter a valid date in the format {1}.",

    // jobs shared
    "main.jobs.notCheckedOut": "This job has been checked in by another user.",
    "main.jobs.jobDoesNotExist": "This job no longer exists.",

    "admin.cluster.view": "Can communicate with",
    "admin.cluster.fail": "Cannot communicate with any node.",

    // user agent
    "user.agent.format.mobile": "{0} {1} ({2})",
    "user.agent.format.desktop": "{0} (Desktop)",
    "user.agent.os.ios": "iOS",
    "user.agent.os.android": "Android",
    "user.agent.device.tablet": "Tablet",
    "user.agent.device.mobile": "Mobile",
    "user.agent.browser.chrome": "Chrome",
    "user.agent.browser.safari": "Safari",
    "user.agent.browser.msie": "Internet Explorer",
    "user.agent.browser.edge": "Microsoft Edge",
    "user.agent.browser.mozilla": "Mozilla FireFox",

    /**
     * *******************General**********************
     */
    "required.missing": "Please fill out required fields.",
    "message.options.none": "None available",
    "message.options.none.selected": "None selected",
    "message.data.none": "no data available",
    "message.inputs.none": "No inputs available.",
    "message.inputs.typed.none": "No inputs of this data type available",
    "message.none.expected": "none expected",
    "message.grid.none": "No information available",
    "message.dismissFuture": "Do not show this message again.",
    "error.unknown": "An unrecognized error was received with status code {0} and type {1}",
    "error.malformed": "An unknown error occurred with status code {0}",
    "error.timeout": "The server is not available. You may have lost connection momentarily.",
    "error.title": "Error",
    "error.details.title": "Error Details",
    "error.handler.title": "Oops! Something went wrong.",
    "error.code.label": "Error Code:",
    "error.stack": "Stack Trace",
    "error.stack.view": "View Stack Trace",
    "error.license.revoked": "Your license has been revoked by an administrator.  Please log in again.",
    "error.session.expired": "Your session has ended.  Please log in again.",
    "error.session.title": "You've been logged out",
    "error.dashboard.unknown": "This dashboard no longer exists. Please refresh the page for the latest information.",
    "error.partial.append": "View more details here.",
    "error.report": "Report this Error",
    "error.reporting": "Reporting Error...",
    "error.report.result.success": "Error was successfully reported.",
    "error.report.result.fail": "Error could not be reported.",
    "validation.required": "Please fill out this field.",
    "validation.duplicate": "This field must be unique.",
    "validation.minLength": "This field must be at least {0} characters long.",
    "validation.maxLength": "This field must be no more than {0} characters long.",
    "validation.minDate": "Date must be after starting date",
    "validation.date.min": "Date must be on or after {0}.",
    "validation.date.max": "Date must be on or before {0}",
    "validation.future": "Date cannot be in the past.",
    "validation.validCss": "Value is not a valid CSS property value.",
    "validation.cleanUrl": "The URL can only contain lowercase letters, numbers and hyphens.",
    "validation.url.noQuery": '"?" character cannot be part of the URL. Please configure query parameters below.',
    "macro.invalid": "This macro is invalid",
    "length.min": "Minimum length",
    "length.max": "Maximum length",
    "aside": "({0})",
    "checked": "Checked",
    "unchecked": "Unchecked",
    "partially.checked.instructions": "Partially Checked. Press Ctrl+Space to toggle",
    "unchecked.instructions": "Unchecked. Toggle to check the row.",
    "checked.instructions": "Checked. Toggle to uncheck the row.",
    "checked.instructions.for.specific": "Checked. Toggle to uncheck row with {0} {1}",
    "unchecked.instructions.for.specific": "Unchecked. Toggle to check row with {0} {1}",
    "download.begin": "Requested download has been started.",

    "open.help": "Open Help",

    "mobile.site": "Mobile Site",

    "import": "Import...",
    "import.btn": "Import",
    "import.skipErrors": "Import Anyway",
    "import.file.type": "Import file type",
    "overwrite.proceed": "An existing item must be overwritten to proceed",

    "category": "Category",
    "categories": "Categories",
    "docType": "Document Type",
    "description": "Description",
    "description.placeholder": "Enter a description...",
    "displayName": "Display Name",
    "document.created": "Document created",
    "document.id.label": "Document ID",
    "form": "Form",
    "form.responsive": "Responsive Form",
    "unknown": "unknown",
    "embed": "Embed",
    "feedback": "Feedback",
    "other": "Other",

    "groups": "Groups",
    "group": "Group",
    "groups.assigned": "Groups Assigned",
    "groups.not.assigned": "Groups not assigned",

    "doNotShow": "Do not show this message again",
    "caution": "Caution",

    "save": "Save",
    "save.as": "Save as...",
    "save.as.title": "Save As",
    "overwrite": "Overwrite",
    "discard": "Discard changes",
    "save.continue": "Save and continue",
    "check.in.continue": "Check in and continue",
    "check.in": "Check In",

    "sort": "Sort",

    "all": "All",
    "more": "More",
    "and.more": "more",
    "viewAll": "view all",
    "specific": "Specific",

    "on.caps": "ON",
    "off.caps": "OFF",

    "filter": "Filter",
    "filters": "Filters",
    "clear": "Clear",
    "find": "Find",
    "search.for.text": "Search for text",

    "default": "Default",
    "dedicated": "Dedicated",
    "deleted": "Deleted",
    "begin": "Begin",
    "end": "End",
    "browse": "Browse",
    "choose.files": "Choose Files",
    "choose.file": "Choose File",
    "required.file": "Please choose a file.",
    "uploading": "uploading...",
    "drop.files": "drop files here to upload",
    "drop.files.upload": "Drop Files To Upload",
    "drop.file.upload": "Drop File To Upload",
    "drop.file": "drop file here to upload",
    "invalid.extension": "File does not have a valid extension. Please choose a valid file.",
    "invalid.filesize": "File is too large to upload. Please choose a file smaller than {0}.",
    "invalid.empty.file": "File is either empty or a folder. Please choose a valid file.",
    "upload": "Upload",
    "add": "Add",
    "add.context": "Add {0}",
    "update": "Update",
    "edit.cancelled": "Edit - Cancelled",
    "edit.adminCancelled": "Edit - Cancelled by admin",
    "edit.checkedIn": "Edit - Checked in",
    "edit.commit": "Edit - Commit",
    "edit.file.changed": "Edit - File changed",
    "remove": "Remove",
    "done": "Done",
    "return": "Return",
    "close": "Close",
    "close.notification": "Close notification",
    "value": "Value",
    "value.custom": "Custom Values",
    "label": "Label",
    "parameters": "Parameters",
    "parameter": "Parameter",
    "parameters.path": "Path Parameters",
    "parameters.query": "Query Parameters",
    "parameter.query.delete": "Delete Query Parameter",
    "parameter.form.delete": "Delete Form Parameter",
    "parameters.none": "None available. These can be set up by using variables in the Request URL.",
    "parameters.form": "x-www-form-urlencoded",
    "parameters.multipart": "multipart/form-data",
    "multipart.info": "Documents can be included by using the #DocumentReference() macro. Files will be sent without markup.",
    "parameters.text.plain": "text/plain",
    "parameters.json": "application/json",
    "inputs": "Inputs",
    "input": "Input",
    "input.param": "Input parameter",
    "cancel": "Cancel",
    "continue": "Continue",
    "back": "Back",
    "revoke": "Revoke",
    "release": "Release",
    "choose": "Choose",
    "change": "Change",
    "default.value": "Default value",
    "default.value.datasource": "(set by datasource)",
    "default.value.macro": "(set by macro)",
    "default.null": "default value is null",
    "trueText": "True",
    "falseText": "False",
    "select": "Select...",
    "select.value": "Please select a value",
    "select.something": "Please select a {0}",
    "select.type": "Type a user...",
    "select.added": "item added",
    "select.failed": "item previously added",
    "typeOrSelect": "Type or select...",
    "goToLogin": "Go to login page",
    "help": "Help",
    "reorder": "Reorder",
    "align": "Align",
    "align.left.tooltip": "Left Align Text",
    "align.center.tooltip": "Center Text",
    "align.right.tooltip": "Right Align Text",
    "align.top.input": "Top by Input",
    "align.left.input": "Left by Input",
    "align.right.input": "Right by Input",
    "align.bottom.input": "Bottom by Input",
    "space.vertical": "Vertically",
    "space.horizontal": "Horizontally",
    "pos.top": "Top",
    "pos.bottom": "Bottom",
    "pos.left.tooltip": "Left Position",
    "pos.right.tooltip": "Right Position",
    "pos.top.tooltip": "Top Position",
    "pos.bottom.tooltip": "Bottom Position",
    "match": "Match",
    "width": "Width",
    "height": "Height",
    "width.input": "Input Width",
    "height.input": "Input Height",
    "degrees.45": "45 degrees",
    "degrees.0": "0 degrees",
    "degrees.90": "90 degrees",
    "degrees.-45": "-45 degrees",
    "degrees.-90": "-90 degrees",
    "show": "Show",
    "hide": "Hide",
    "text.small": "Small Text",
    "text.medium": "Medium Text",
    "text.large": "Large Text",
    "processing": "Processing request",
    "prompt": "prompt",
    "Prompt": "Prompt",
    "static": "static",
    "Static": "Static",
    "State": "State",
    "on": "on",
    "off": "off",
    "asc": "ascending",
    "order.asc": "Ascending",
    "order.desc": "Descending",
    "order.none": "No specified order",
    "desc": "descending",
    "custom": "custom",
    "enable": "Enable",
    "disable": "Disable",
    "enabled": "enabled",
    "disabled": "disabled",
    "disabled.label": "Disabled",
    "filter.noData": "No items match your filter.",
    "view": "View",
    "view.label": "view",
    "edit.label": "edit",
    "used.in": "Used In",
    "show.less": "Show less",
    "include": "Include",
    "format": "Format",
    "minimize": "Minimize",
    "restore": "Restore",
    "preview": "Preview",
    "validator": "Validator",
    "icon": "Icon",
    "go.to": "Go to {0}",
    "share.links.open": "Share Links...",
    "share.manage": "Manage Sharing",
    "share.manage.launch": "Manage Sharing...",
    "share.with": "Share with",
    "via.gateway": "via Gateway",

    "view.records.conditional.1": "View 1 Record",
    "view.records": "View {0} Records",
    "view.markup.tool": "Markup View",

    "selected": "selected",
    "status": "Status",
    "stopped": "Stopped",
    "started": "Started",
    "running": "Running",
    "loading.progress": "Loading...",

    "detail.row.desc": "These are the details for the previous row",

    "name.full": "{0} {1}",
    "name": "Name",
    "name.prompt": "Enter name...",
    "none": "none",
    "empty": "empty",
    "explicit": "explicit",
    "sent": "sent",
    "valueLabel": "value",
    "pixels": "px",

    "of": "of",
    "percent.sign": "%",
    "percent.sign.value": "{0}%",

    "redactions": "Redactions",
    "markup": "Markup",
    "document.contains.markup": "This document contains one or more markups.",

    "kb": "KB",
    "mb": "MB",
    "gb": "GB",
    "bytes": "{0} bytes",
    "kbs": "{0} KB",
    "mbs": "{0} MB",
    "gbs": "{0} GB",

    "archive.cd": "700 MB (CD)",
    "archive.dvd": "4 GB (DVD)",
    "archive.ddvd": "8 GB (DVD)",
    "archive.bluray": "25 GB (Blu-ray)",
    "archive.other": "other",
    "current": "current",

    "single.pdf": "Combine into single PDF",
    "pdf": "PDF",
    "tiff": "TIFF",
    "pdfa": "PDF/A",
    "pdfa.create": "Create a PDF/A",
    "native": "Native",

    "pager.total.entries": "Total Entries: {0}",
    "pager.total": "Total Results: ",
    "pager.total.designs": "Total Designs: ",
    "pager.versions": "Versions: ",
    "pager.itemsPerPage": "items/page",
    "pager.page": "Page: ",
    "pager.display.precise": "{0} - {1} of {2}",
    "pager.display.imprecise": "{0} - {1} of many",

    "search.reset.success": "Search prompts are successfully reset.",

    "column.name.empty": "(No Column Name)",

    "404": "404",
    "403": "403",
    "access.view": "Can View",
    "access.edit": "Can Edit",
    "access.with.view": "View Access",
    "access.with.edit": "Edit Access",

    "column.settings": "Column Settings",
    "email.attachments": "Email Attachments",

    // system properties
    "ui": "User Interface",
    "versionhistory": "Version History",
    "importer": "Importer",

    //Module window titles
    "window.title.name": "{0} - DocFinity",
    "window.title.formLibrary": "Form Library - DocFinity",
    "window.title.processLibrary": "Process Library - DocFinity",
    "window.title.admin": "Administration - DocFinity",
    "dashboard.designer.window.title": "Dashboards Designer - DocFinity",
    "dashboard.viewer.title": "Dashboards - DocFinity",

    // top menus
    "menu.bpm": "Process Designer",
    "menu.forms": "Form Designer",
    "menu.about": "About",
    "menu.altText": "DocFinity Main Menu",
    "menu.preferences": "Preferences",
    "menu.pref.search": "Results Preferences",
    "menu.hotkeyReference": "Hot Key Reference",
    "do.not.show.tips": "Do not show hot key tips",
    "open.hotkeyReference": "Open hot key reference",
    "user.menu": "User Menu",
    "contact.support": "Contact Support",
    "contact.support.description": "Contact any of the admins below for support",
    "contact.support.none": "There are currently no support contacts configured. Please contact an administrator to set up support contacts.",

    //About window
    "about.line1": "Copyright 2024 Companion Data Services, LLC. All rights to possess, use, and permissions to use reserved.",
    "about.line2": "CONFIDENTIAL PROPERTY: The software making up the DocFinity product family and its documentation (or any portion thereof) may not be sublicensed, transferred, copied, or redistributed in any form or by any method without the prior written consent of Companion Data Services, LLC.",
    "companion.data.services": "Companion Data Services, LLC",
    "online.support": "Online Support",
    "about.line4": "This product includes the following third-party libraries/applications as part of its distribution, which are governed by various licenses as specified:",

    // login
    "login.concurrent.title": "Other Login Detected",
    "login.concurrent.message": "This user is logged into DocFinity elsewhere. Would you like to log out of the other locations listed below?",
    "login.concurrent.logout": "Log Out All Other Locations",

    // logout
    "logout.confirm.message": "You have at least one other DocFinity window or tab open.  Logging out will cause all other open windows to lose unsaved changes.",
    "logout.confirm.title": "Logout Confirmation",
    "logout": "Log Out",

    // about window
    "about.title": "About DocFinity",
    "about.version": "DocFinity version {0}",
    "about.company": "This instance is licensed to {0}",

    // change password window
    "changePassword.header": "Change your password.",

    //DatasourceSelect widget
    "datasource.select.load": "Load data",
    "datasource.select.refresh": "Refresh data",
    "datasource.select.optionLabel": "Select a datasource...",
    "datasource": "Datasource",

    //Super widget
    "variable": "Variable",
    "variables": "Variables",
    "macros": "Macros",
    "arguments": "Arguments",
    "args": "Args",
    "macro.display": "{0} (Args: {1})",
    "enter.variable": "Enter a new variable name or select one...",
    "enter.variable.name": "Variable name can't start with ${ and end with }",
    "macro.help": "macro help",

    //DFNumericTextBox
    "numerictextbox.range": "Enter a value between {0} and {1}",
    "numerictextbox.min": "Enter a value >= {0}",
    "numerictextbox.max": "Enter a value <= {0}",

    //Date time picker
    "enter.datetime": "Enter a date and time",

    // color picker
    "color.picker.label": "Current selected {0} is {1}",

    // Used In widget
    "usedIn.deleteMessage": "This item cannot be deleted because it is used in the areas listed below:",
    "processModel.usedIn": "This item is used in the areas listed below:",
    "workingAndActiveCopy": "Working and Active Copy",

    // Scheduler
    "scheduler.changeView": "Changing the frequency will result in the removal of the current schedule. Are you sure you want to proceed?",
    "scheduler.week": "Week",
    "scheduler.day": "Day",
    "scheduler.time": "Time",
    "scheduler.duration": "Duration",
    "scheduler.list.title": "Records Policy Schedule",
    "scheduler.list.dayPrefix": "Daily at",
    "scheduler.start.unique": "Start time must be unique.",
    "scheduler.add": "Add Scheduled Time",
    "scheduler.week.1": "Week 1",
    "scheduler.week.2": "Week 2",
    "scheduler.week.3": "Week 3",
    "scheduler.week.4": "Week 4",
    "scheduler.today": "Today",
    "scheduler.date": "Date",
    "scheduler.event": "Event",
    "scheduler.delete.title": "Delete event",
    "scheduler.empty": "Nothing has been scheduled.",
    "scheduler.complete": "until complete",
    "scheduler.year": "Year",
    "time.unit": "Time Unit",
    "policy.schedule": "Policy Schedule",

    // weeks
    "weekday.sunday": "Sunday",
    "weekday.monday": "Monday",
    "weekday.tuesday": "Tuesday",
    "weekday.wednesday": "Wednesday",
    "weekday.thursday": "Thursday",
    "weekday.friday": "Friday",
    "weekday.saturday": "Saturday",
    "weekdays.sunday": "Sundays",
    "weekdays.monday": "Mondays",
    "weekdays.tuesday": "Tuesdays",
    "weekdays.wednesday": "Wednesdays",
    "weekdays.thursday": "Thursdays",
    "weekdays.friday": "Fridays",
    "weekdays.saturday": "Saturdays",

    "schedule.readonly.WEEKLY.1": "Weekly - Sunday {0}",
    "schedule.readonly.WEEKLY.2": "Weekly - Monday {0}",
    "schedule.readonly.WEEKLY.3": "Weekly - Tuesday {0}",
    "schedule.readonly.WEEKLY.4": "Weekly - Wednesday {0}",
    "schedule.readonly.WEEKLY.5": "Weekly - Thursday {0}",
    "schedule.readonly.WEEKLY.6": "Weekly - Friday {0}",
    "schedule.readonly.WEEKLY.7": "Weekly - Saturday {0}",
    "schedule.readonly.DAILY": "Daily - {0}",
    "schedule.readonly.MONTHLY.1": "Monthly - Week {1} - Sunday {0}",
    "schedule.readonly.MONTHLY.2": "Monthly - Week {1} - Monday {0}",
    "schedule.readonly.MONTHLY.3": "Monthly - Week {1} - Tuesday {0}",
    "schedule.readonly.MONTHLY.4": "Monthly - Week {1} - Wednesday {0}",
    "schedule.readonly.MONTHLY.5": "Monthly - Week {1} - Thursday {0}",
    "schedule.readonly.MONTHLY.6": "Monthly - Week {1} - Friday {0}",
    "schedule.readonly.MONTHLY.7": "Monthly - Week {1} - Saturday {0}",

    /**
     * Data types
     */
    "data.type": "Data Type",
    "data.type.label": "Data type",
    "string": "string",
    "string.array": "string array",
    "date": "date",
    "date.array": "date array",
    "decimal": "decimal",
    "integer": "integer",
    "currency": "currency",
    "number.array": "number array",
    "boolean": "boolean",
    "boolean.array": "boolean array",
    "decimalPrecision": "Precision",
    "decimal.places": "Decimal places",

    /**
     * Comparators
     */
    "comparator": "Comparator",
    "equals": "equals",
    "have": "have",
    "notequals": "not equals",
    "notequals.date": "not on",
    "greaterthan": "greater than",
    "greaterthan.date": "after",
    "lessthan": "less than",
    "lessthan.date": "before",
    "greaterthanequal": "greater than or equal to",
    "greaterthanequal.date": "on or after",
    "lessthanequal": "less than or equal to",
    "lessthanequal.date": "on or before",
    "between.date": "between",
    "startswith": "starts with",
    "notstartswith": "does not start with",
    "endswith": "ends with",
    "notendswith": "does not end with",
    "contains": "contains",
    "contain": "contain",
    "notcontains": "does not contain",
    "containsregexp": "contains regular expression",
    "in": "in",
    "and": "AND",
    "and.lowercase": "and",
    "or": "OR",
    "in.sql": "in SQL",
    "after.compare": "{0} after {1}",

    "viewer.markup.save": "Save Markup Changes",
    "viewer.markup.cancel": "Cancel Markup Changes",
    "viewer.markup.discard.confirm": "Your unsaved changes to markup will be lost. Are you sure you want to continue?",
    "viewer.showMarkup": "Show Markup",
    "viewer.hideMarkup": "Hide Markup",
    "viewer.fitToWidth": "Fit to Width",
    "viewer.fitToWidth.page": "Fit Page to Width",
    "viewer.fitToHeight": "Fit to Height",
    "viewer.fitToHeight.page": "Fit Page to Height",
    "viewer.zoomToSelection": "Zoom to selection",
    "viewer.cancel": "Cancel markup/redaction",
    "viewer.create.docHistory": "Markup - create",
    "viewer.delete.docHistory": "Markup - delete",
    "viewer.redact": "Redact",
    "viewer.stamp": "Stamp",
    "viewer.footnote": "Footnote",
    "Footnotes": "Footnotes",
    "viewer.rectangle": "Rectangle",
    "viewer.highlight": "Highlight",
    "viewer.ellipse": "Ellipse",
    "viewer.arrow": "Arrow",
    "viewer.line": "Line",
    "viewer.freehand": "Freehand",
    "viewer.delete": "Delete the selected markup(s)",
    "viewer.editing.noEditQueue": "The document has been successfully added to your edit queue.",
    "viewer.stampLibrary.menu": "Stamp Library...",
    "viewer.stampLibrary": "Stamp Library",
    "viewer.stampLibrary.description": "Add, edit, or delete stamps that are available to all users who can apply stamps to documents.",
    "viewer.cancel.message": "Cancelling all changes will discard all changes that have been made to the markup and/or redactions on the current document from the last save.  Do you wish to continue?",
    "viewer.cancel.yes": "Yes, Discard Changes",
    "viewer.diffLastModDate.message": "These changes can not be saved because the document has been edited. The document has to be reloaded which will discard any changes.",
    "viewer.markup.delete": "Delete markup",
    "viewer.markup.saved": "Your markup changes were successfully saved.",
    "viewer.markup.place": "Place Markup",
    "viewer.empty": "Choose a document to view.",
    "viewer.preferences": "Viewer Preferences...",
    "viewer.toolbox.panel.fulltext.name": "Text Results ({0})",
    "viewer.toolbox.panel.fulltext.prev": "Previous Text Result",
    "viewer.toolbox.panel.fulltext.next": "Next Text Result",
    "editing.confirmCommitDelete": "You've removed all pages from these documents: {0}. Are you sure you want to delete these documents?",

    /**
     * **************Admin*******************
     */

    "confirm": "Are you sure?",
    "confirm.delete": "Are you sure you want to delete {0}?",
    "confirm.delete.conditional.": "Are you sure you want to delete the selected items?",
    "confirm.delete.title": "Delete Confirmation",
    "confirm.unsaved": "You have unsaved changes.  Do you wish to save or discard them?",
    "confirm.unsaved.specific": "You have unsaved changes on {0}. Do you wish to save or discard them?",
    "confirm.revoke.title": "Revoke Confirmation",
    "confirm.revokeLicenses": "Revoke licenses for selected users?",
    "close.confirm": "Close Confirmation",

    //Assign groups
    "assign.groups": "Assign groups",
    "assign.groups.cap": "Assign Groups",
    "assigned.groups": "Assigned Groups ",
    "assign.users": "Assign Users",
    "assign.members": "Assign Members",
    "assign.show": "Show all",
    "assign.hide": "Hide assigned",
    "assign.none": "No groups assigned",
    "assign.tooMany": "Only {0} items may be worked with at one time.",
    "assign.popup": "Assign...",
    "assign.groups.popup": "Assign Groups...",
    "assign.users.duplicate": "User is already assigned.",

    //Selection grid
    "assign.showSome": "{0} Selected",
    "filter.item": "Filter {0}",

    "filter.by": "Filter by {0}",
    "sort.asc": "Sort Ascending",
    "sort.desc": "Sort Descending",

    //Repository
    "repository.list": "Repository List",
    "repository.snapshot": "Repository Snapshot",
    "repository.file": "File storage level",
    "repository.all": "all conversions and renderings",
    "repository.pdf": "only PDF conversions",
    "writeable": "writeable",
    "repository.path": "Path",
    "repository.retrievalPriority": "Retrieval Priority",
    "repository.purge": "Purge Renderings",
    "repository.purge.message": "Renderings are being purged. This may take some time to complete.",
    "repository.purge.confirm": "Are you sure you want to purge all renderings from {0}?",
    "repository.delete.confirm": "Are you sure you want to delete repositories: {0}?",
    "repositories": "Repositories",
    "repository.intro": "Repositories are used to store DocFinity files.  Add and delete repositories; edit their properties; adjust retrieval priority; set which repository is used as the upload repository and which stores renderings.",
    "repository.writeable": "writable",
    "repository.renderings": "renderings",
    "repository.records": "PDF/As",
    "repository.uploadHeader": "Uploads Repository",
    "repository.recordsHeader": "Records Repository",
    "repository.renderingsHeader": "Renderings Repository",
    "repository.noRead": "Path not readable.",
    "repository.noWrite": "Path not writable.",
    "repository.noReadWrite": "Path not readable or writable.",
    "repository.uniqueName": "The name must be unique.",
    "repository.free": "Free space",
    "repository.total": "Total space",
    "repository.sizeSuffix": " GB",
    "repository.moveLabel": "existing renderings",
    "repository.moveOld": "Move",
    "repository.noMoveOld": "Do not move",
    "repository.first": "Add Your First Repository",
    "repository.moveWarning": "Document renderings with redactions are going to be purged. If these documents are rendered again, the redactions may slightly change their location on the document.",

    //Process Model Assignment
    "bpmAssign.noProcessModels": "No Process Models exist. They can be created using the Process Designer.",
    "bpmAssign.desc": "Edit the groups assigned to each Process Model.",
    "version": "Version",
    "version.latest": "Latest Version",
    "version.active": "Active Version",
    "general.info": "General Info",

    //System transfer
    "transfer.configFile": "Configuration File",
    "transfer.header": "System Transfer",
    "transfer.preamble": "Load system data from a configuration file; save system data for a system component to a configuration file.",
    "transfer.component": "System Component",
    "transfer.toExport": "{0} to export",
    "transfer.type.all": "All items",
    "transfer.limited": "Choose items",
    "transfer.security": "Document Types (Security)",
    "transfer.indexing": "Document Types (Indexing)",
    "Datasources": "Datasources",
    "transfer.confirmAll": "Are you sure that you want to export everything? This operation may take some time. ",
    "transfer.exportAll": "Export All",
    "validators": "Validators",
    "document.types": "Document Types",
    "transfer.components.required": "At least one item must be selected to export",
    "transfer.noneInProgress": "No system transfer import operations are currently in progress",
    "transfer.importProgress": "System transfer import progress",
    "transfer.importDropText": "Drop files here to import.",
    "metadata.assignment": "Metadata assignments to Document Types",
    "validator.assignment": "Validators assignment in indexing configuration",
    "group.assignment.info": "Group assignment information.",
    "scanSetting.assignment": "Scan Profiles assigned to Document Types",
    "datasource.search.config": "Search prompt datasource confirmation",
    "search.indexing.config": "Search Document Type indexing configuration",
    "transfer.results": "Import Results",
    "skipped": "Skipped",
    "transfer.successCount": "{0} configuration items successfully imported.",
    "transfer.successCount.conditional.1": "1 configuration item successfully imported.",
    "transfer.skipMessage": "Some configuration items were skipped during import.  They are listed below.  Check the log file for more details.",
    "configuration.item": "Configuration item",
    "role.assignments": "Role and Proxy assignments",
    "transfer.include.datasource": "Export will include selected datasources and all needed Database Connections and SOAP web services.",
    "transfer.include.indexing": "Export will include selected Document Types with indexing configuration and all needed Categories, metadata, datasources, Database Connections, and Validators.",
    "transfer.include.security": "Export will include selected Document Types with Security Access configuration and all needed categories, metadata, and groups (including Feature Right assignment).",
    "transfer.include.exportProfile": "Export will include selected Export Profiles and all needed groups (including members and Feature Right assignment).",
    "transfer.include.group": "Export will include selected groups and all group members and Feature Right assignment.",
    "transfer.include.user": "Export will include selected users.",
    "transfer.include.hsm": "Export will include selected HSM policies and all needed searches, Document Types, Categories, datasources, Database Connections, metadata, users, and groups (including Feature Right assignment).  Business Processes associated with the HSM Policy are not included.",
    "transfer.include.search": "Export will include selected searches and all needed Categories, Document Types, metadata, web services, datasources, Database Connections, and groups (including Feature Right assignment).",
    "transfer.include.scanProfile": "Export will include selected Scan Profiles and all needed Categories, Document Types (including Scan Profile setting), and groups (including members and Feature Right assignment).",
    "transfer.include.rm": "Export will include selected Retention Policies and all needed Folder Types, Categories, Document Types, and metadata.",
    "transfer.include.roles": "Export will include selected Roles and all needed users.",
    "transfer.include.validators": "Export will include selected Validators and all needed Database Connections and metadata.",
    "transfer.include.jobView": "Export will include selected Job Views and all needed Database Connections, datasources, metadata, and groups (including Feature Right assignment and membership information).",
    "transfer.include.themes": "Export will include selected Themes",
    "transfer.include.noteTypes": "The export will include all specified Note Types and group assignment.",
    "transfer.include.folderTypes": "The export will include all specified Folder Types and group assignment. Review Folder Types to see which metadata and datasources are required for a successful import.",
    "edit.here": "Edit Here",

    //Email
    "email.intro": "Configure an SMTP server and text used in password management emails.",
    "smtp.invalid": "Email failed to send.",

    // Metadata
    "metadata.desc": "Each Metadata Object defines a type of data available in the system, along with its properties. Create, edit, and delete Metadata Objects or select one to view its properties.",
    "metadata.addFirst": "Add Your First Metadata Object",
    "metadata.missing.helpless": "You do not have the necessary Feature Rights to add a Metadata Object.",
    "metadata.list": "Metadata Object List",
    "metadata.object": "Metadata Object",
    "metadata.object.ellipsis": "Metadata Object...",
    "metadata.snapshot": "Metadata Object Snapshot",
    "metadata.prompt": "Enter a metadata...",
    "metadata.unique": "Metadata Object name must be unique.",
    "metadata.name.startsWith": "This field cannot begin with yy_, yyf_, or yyd_.",
    "metadata.shortName": "Database table name",
    "metadata.shortName.unique": "The database table name must be unique.",
    "metadata.shortName.regex": "Database table name suffixes can only consist of letters, numbers, and underscores.",
    "metadata.isCurrency": "Is currency",
    "metadata.not.isCurrency": "Not currency",
    "metadata.isCollection.on": "Allow",
    "metadata.isCollection.off": "Do not allow",
    "metadata.isCollection": "Multiple Values",
    "metadata.isCollection.text": "multiple values to be stored for a single document",
    "metadata.multi.warning": "Once you switch this metadata to allow multiple values and index documents with this metadata, it will be difficult to reverse this setting. It will involve manually cleaning up data. Please be sure of this change.",
    "metadata.single.warning": "In order to cleanly switch this metadata back to allowing only single values, we recommend manually cleaning up data and adding a constraint at the database level.",
    "metadata.multi.disabled": "Multiple values are not allowed when the metadata object is used in a folder type.",
    "docTypes.assignment": "Document Type assignment",
    "metadata.deleteMessage": "Metadata Object cannot be deleted because it is in use.",
    "metadata.confirm.delete": "{0} documents use {1}. Deleting this will permanently remove all associated values; it will not be available for previous versions of documents.",
    "full.text.indexed": "Full Text Indexed",

    //Request status widget
    "request.success": "Success",
    "request.failed": "Failed",
    "request.loading": "Loading",
    "request.url": "Request URL",
    "request.body": "Request Body",

    //License File
    "license": "License",
    "license.key": "License Key",
    "license.expire": "Expiration Notification",
    "license.activate.new": "Activate New License",
    "license.activate.description": "Paste your new license key in the field below to activate your new DocFinity license.",
    "license.details": "License Details",
    "license.sendMessage": "How many days before license expiration would you like to be notified via system message?",
    "license.company": "Company",
    "license.issued": "Date Issued",
    "license.expiration": "Expiration Date",
    "license.purchased": "Licenses Purchased",
    "max.nodes": "Max Nodes",
    "population": "API Named Users",
    "maximum.monthly.gateway": "Maximum Monthly Gateway Users Allowed",
    "gateway.billing": "Gateway Billing",
    "usage.based": "Usage Based",
    "num.users": "Number of Users",
    "license.modules": "Modules",
    "custom.plugins": "Custom Plugins",
    "license.error": "The file you attempted to upload is not a valid license file.",
    "license.logout": "You must log out and back in to see the changes. ",
    "license.unlimited": "unlimited",
    "license.preamble": "View details of the current license; Load a new license; Configure options for notification prior to expiration.",
    "environment": "Environment",
    "licensed.version": "Licensed Version",
    "license.agreement": "I, {0}, acknowledge that this license is only used on the {1} {2} cluster. I am authorizing this license to be used in accordance with the terms agreed upon in the contract with Companion Data Services, LLC.",
    "Agree": "Agree",
    "license.agreement.title": "License Usage Acknowledgement",
    "license.expiration.none": "None, the license doesn't have an expiration date.",

    "gateway.warn.users": "Send a system message when Gateway usage exceeds a certain number of users?",
    "logins.this.month": "Logins this month",
    "actions.this.month": "Actions this month",
    "gateway.usage": "Gateway Usage",
    "gateway.usage.reporting": "Gateway Usage Reporting",
    "power.users": "Power Users",
    "casual.users": "Casual Users",
    "activate.user": "User has been marked active.",
    "deactivate.user": "User has been marked inactive.",
    "gateway.user.list": "Gateway User List",
    "gateway.user.snapshot": "Gateway User Snapshot",

    //Print/Fax admin
    "fax.header": "Faxes",
    "fax.desc": "Add, delete, or edit the fax servers that DocFinity uses to access fax services; set which fax services are available and assign them to groups.",
    "fax.servers.title": "Fax Servers",
    "fax.servers.snapshot": "Fax Server Snapshot",
    "fax.services.title": "Fax Services",
    "fax.services.snapshot": "Fax Service Snapshot",
    "fax.server": "Fax server",
    "fax.service": "Fax service name",
    "fax.service.unique": "Fax service name should be unique",
    "fax.service.plugin": "Fax service plugin",
    "fax.firstService": "Add Your First Fax Service",
    "fax.delete": "Are you sure you want to delete {0}? Deleting a fax server will also delete assigned fax services that are connected to it.",
    "fax.servers.missing": "You must add a fax server to set up a fax service.",
    "fax.servers.missing.helpless": "An administrator must add a fax server to set up a fax service.",
    "port": "Port",
    "printfax.firstServer": "Add Your First Server",
    "printfax.security": "Connection Security",
    "printfax.server.unique": "Server name must be unique.",
    "test.connection": "Test Connection",
    "printfax.name": "Server Name",
    "printers.desc": "Add, delete or edit the print servers that DocFinity uses to access printers; set which printers are available and assign them to groups.",
    "printers.title": "Printers",
    "printers.firstPrinter": "Add Your First Printer",
    "printers.server.unavailable": "The selected print server is unavailable.",
    "printers.servers.missing": "You must add a print server to set up a printer.",
    "printers.servers.missing.helpless": "An administrator must add a printer server to set up a printer.",
    "printers.printer.unavailable": "The selected printer was not found on the print server.",
    "printers.printerName": "Printer name",
    "printers.servers.title": "Print Servers",
    "printers.blackWhite": "Black and White",
    "printers.color": "Color",
    "printers.duplex": "Duplex",
    "printers.collated": "Collated",
    "printers.uncollated": "Uncollated",
    "printers.multipleCopies": "Multiple Copies",
    "printers.unique": "Printer display name must be unique.",
    "printers.delete": "Are you sure you want to delete {0}? Deleting a print server will also delete assigned printers that are connected to it.",

    "expand": "Expand",
    "collapse": "Collapse",

    // Hot Keys
    "hotkeys.header": "Hot Keys",
    "action": "Action",
    "hotkeys.keystroke": "Keystrokes",
    "hotkeys.separator": "+",
    "hotkeys.ctrl": "CTRL",
    "hotkeys.alt": "ALT",
    "hotkeys.shift": "SHIFT",
    "hotkeys.backspace": "Backspace",
    "hotkeys.enter": "Enter",
    "hotkeys.escape": "Escape",
    "hotkeys.tab": "Tab",
    "hotkeys.right": "Right Arrow",
    "hotkeys.left": "Left Arrow",
    "hotkeys.up": "Up Arrow",
    "hotkeys.down": "Down Arrow",
    "hotkeys.period": ".",
    "hotkeys.comma": ",",
    "hotkeys.gtThan": ">",
    "hotkeys.lsThan": "<",
    "hotkeys.slash": "/",
    "hotkeys.question": "?",
    "hotkeys.lftBracket": "[",
    "hotkeys.rgtBracket": "]",
    "hotkeys.lftBrace": "{",
    "hotkeys.rgtBrace": "}",
    "hotkeys.bpm": "BPM",
    "hotkeys.bpmMonitoring": "BPM Monitoring",
    "general": "General",
    "hotkeys.designer": "Designer",
    "indexing": "Indexing",

    // Groups
    "groups.desc": "Add, delete, and edit groups of users. Manage their members, Feature Rights, and Security Access.",
    "groups.list": "Group List",
    "groups.add": "Add A New Group",
    "groups.delete.external": "This is an external group which may be added back after an LDAP group sync.",
    "admin.groups.deleteMessage": "Group cannot be deleted because it is in use.",
    "groups.snapshot": "Group Snapshot",
    "groups.users": "Groups and Users",
    "members": "Members",
    "members.externalGroup.delete": "Some of the users you are removing are external and may be added back to this group if an LDAP group sync occurs. The users that could be affected are: {0}. Would you still like to remove them?",
    "members.externalGroup.add": "Some of the users you are adding are external and may be removed from this group if an LDAP group sync occurs. The users that could be affected are: {0}. Would you still like to add them?",
    "members.externalGroup.update": "Some of the users you are adding and removing could be changed if an LDAP group sync occurs. The users that could be affected are: {0}. Would you still like to make these changes?",
    "members.none": "No users assigned to this group.",
    "featureRights": "Feature Rights",
    "featureRights.none": "No Feature Rights assigned.",
    "featureRight": "Feature Right",
    "groups.security": "Security Access",
    "groups.security.edit": "Edit permissions",
    "groups.security.none": "Security Access has not been configured.",
    "groups.filterSecurity.header": "Configure Filters for {0}",
    "groups.filterSecurity.add": "Add a Filter",
    "filtered": "filtered",
    "groups.filter.copy": "Copy filter",
    "groups.filters.copy": "Copy filters from other permissions",
    "groups.filters.preview": "Preview: {0}",
    "groups.filters.noMdo": "In order to configure a filter, a Metadata Object must be associated with this Document Type.",
    "groups.filters.notSelected": "Permission must be assigned to be able to set up filters.",
    "docTypes.assigned": "Assigned Document Types",
    "docTypes.assign": "Assign Document Types",
    "docTypes.addFirst": "Add Your First Document Type",
    "permissions": "Permissions",
    "copy": "Copy",
    "cut": "Cut",
    "paste": "Paste",
    "duplicate": "Duplicate",
    "duplicate.dialog": "Duplicate...",
    "duplicate.open": "Duplicate to step...",
    "copy.from.group": "Copy from a group",
    "copy.members": "Copy members from a group",
    "copy.featureRights": "Copy Feature Rights from a group",
    "copy.select.something": "Please select something to copy.",
    "filter.connective": "Connective",
    "copy.members.success": "Assigned members were successfully copied.",

    /**
     * **************Dashboard Viewer***************
     */
    "dashboard.viewer.missing": "The given dashboard does not exist",
    "dashboard.viewer.promptErrors": "Dashboard cannot be loaded. Please contact an administrator to review this dashboard's configuration.",
    "dashboard.drillUp.tooltip": "Drill up",


    /**
     *********** Dashboard Designer****************
     */
    "dashboard.designer.refresh.dashboard": "Refresh Dashboard",
    "dashboard.designer.addInput": "Add Input",
    "dashboard.designer.addInput.title": "Add Dashboard Input {0}",
    "dashboard.designer.editInput.title": "Edit Dashboard Input {0}",
    "dashboard.designer.addPrompt": "Input {0}",
    "dashboard.designer.prompt.referenceName": "ReferenceName",
    "dashboard.designer.selectInput": "Select an input...",
    "dashboard.designer.refreshMessage": "Please first configure inputs by clicking \"Edit\".",

    "dashboard.designer.drilldown.add": "Add Drilldown",
    "dashboard.designer.drilldown.path": "Drilldown path",
    "dashboard.designer.drilldown.values": "Values passed",

    //Dashboard designer drilldown types
    "url": "URL",
    "url.open": "Open URL",

    // Dashboard Designer Drilldown Configuration
    "dashboard.drilldown.add.url.title": "Add Link to URL",
    "dashboard.drilldown.edit.url.title": "Edit Link to URL",
    "dashboard.drilldown.add.chart.title": "Add Link to Chart",
    "dashboard.drilldown.edit.chart.title": "Edit Link to Chart",
    "dashboard.drilldown.add.dashboard.title": "Add Link to Dashboard",
    "dashboard.drilldown.edit.dashboard.title": "Edit Link to Dashboard",

    // Dashboards Designer Drilldown Errors
    "dashboard.drilldown.invalid": "Invalid drilldowns with empty inputs are indicated below.",

    //Dashboard designer input config
    "dashboard.designer.chartSpacing": "Chart spacing:",
    "dashboard.designer.background": "Dashboard background:",
    "dashboard.designer.preview": "Preview Dashboard",
    "dashboard.designer.drilldown.count": "1 Drilldown",
    "dashboard.designer.drilldowns.count": "{0} Drilldowns",
    "charts.list": "Chart List",
    "charts.tooMany": "You have reached the maximum number of charts allowed on a dashboard.",

    //Dashboard chart config
    "dashboard.designer.return.library": "Return to Library",
    "dashboard.designer.library": "Library",

    //Chart config
    "dashboard.designer.chartDataName": "{0} Data",
    "dashboard.designer.editChartContinue": "Continue to Chart",
    "dashboard.designer.editChart": "View {0}",
    "dashboard.designer.editChartData": "Edit Data",
    "dashboard.designer.loadChartData": "Load Data",
    "dashboard.designer.pointerLabel": "Pointer value",
    "dashboard.designer.scaleRange": "Scale range",
    "dashboard.designer.chartTitle": "Chart title",
    "dashboard.designer.scaleTitle": "Scale Title",
    "dashboard.designer.centerAlign": "center",
    "dashboard.designer.leftAlign": "left-align",
    "dashboard.designer.rightAlign": "right-align",
    "dashboard.designer.border": "Chart border",
    "dashboard.designer.labelFormat": "Label format:",
    "dashboard.designer.labelPrecision": "Label precision",
    "dashboard.designer.selectData": "Select data...",
    "dashboard.designer.title.placeholder": "Enter a title, optionally referencing variables",
    "dashboard.designer.inCount": "In {0} Dashboards",
    "dashboard.designer.inCountOne": "In 1 Dashboard",
    "dashboard.designer.savAsOverwrite": "A chart with this name already exists. Please enter a unique name or overwrite the existing chart",
    "dashboard.designer.seriesLabels": "Series labels",
    "dashboard.designer.includeSeriesName": "include series name",
    "dashboard.designer.includeValue": "include value",
    "dashboard.designer.tooltips": "Tooltips",
    "dashboard.designer.legend": "Legend",
    "dashboard.designer.animate": "animate",
    "dashboard.designer.noAnimate": "do not animate",
    "center": "Center",
    "left": "Left",
    "right": "Right",
    "dashboard.designer.newChartType": "New {0}",
    "dashboard.designer.variablesInvalid": "Please fill in required prompts then hit refresh to view your chart.",
    "dashboard.designer.aliasMissing": "Column is missing an alias or contains invalid characters.",
    "returnTo": "Return to {0}",
    "dashboard.designer.noNumericData": "no numerical data available",
    "dashboard.designer.chartChanged": "The inputs associated with the datasource have changed. Please review and save this chart.",
    "dashboard.designer.typeProblem": "Inputs of different data types are sharing a variable. This may cause problems executing the datasource.",
    "dashboard.designer.chartInputs": "Chart inputs",

    //Pie chart
    "dashboard.designer.series": "Series",
    "dashboard.designer.values": "Values",
    "dashboard.designer.valueFormat": "Value format",
    "dashboard.designer.valuePrecision": "Value precision",
    "dashboard.designer.seriesTitle": "Series title",

    //Table charts
    "dashboard.designer.columns": "Columns displayed (left to right)",
    "dashboard.designer.columnName": "Column Name",
    "primary.columnName": "Primary Column Name",
    "primary": "(primary)",
    "dashboard.designer.count": "COUNT",
    "dashboard.designer.sum": "SUM",

    //Bar-line-area charts
    "dashboard.designer.xAxis.label": "X-axis configuration",
    "dashboard.designer.yAxis.label": "Y-axis configuration",
    "dashboard.designer.xAxisValues": "x-axis values",
    "dashboard.designer.yAxisValues": "y-axis values",
    "dashboard.designer.rangeAcross": "range across multiple data columns",
    "dashboard.designer.rangeOne": "come from one data column",
    "dashboard.designer.useY": "plot series using the y-axis values",
    "dashboard.designer.useColumn": "plot a series for each unique value in the data column",
    "dashboard.designer.showX": "show x-axis",
    "dashboard.designer.hideX": "hide x-axis",
    "dashboard.designer.showY": "show y-axis",
    "dashboard.designer.hideY": "hide y-axis",
    "dashboard.designer.majorTicks": "units between major ticks",
    "dashboard.designer.xLabel": "x-axis labels",
    "dashboard.designer.xLabelFormat": "x-axis label format",
    "dashboard.designer.labelTicks": "label spacing",
    "dashboard.designer.xTitle": "x-axis title",
    "dashboard.designer.yLabel": "y-axis labels",
    "dashboard.designer.yLabelFormat": "y-axis label format",
    "dashboard.designer.yPrecision": "y-axis label precision",
    "dashboard.designer.xPrecision": "x-axis label precision",
    "dashboard.designer.yTitle": "y-axis title",
    "dashboard.designer.vertical": "vertical",
    "dashboard.designer.horizontal": "horizontal",
    "dashboard.designer.labels": "Labels",
    "dashboard.designer.includeCrosshair": "include crosshair",
    "dashboard.designer.stack": "stack",
    "dashboard.designer.noStack": "do not stack",
    "dashboard.designer.colorAuto": "color automatically",
    "dashboard.designer.colorManual": "set color for specific series",
    "dashboard.designer.ticks.hide": "hide ticks",
    "dashboard.designer.ticks.show": "show ticks",
    "dashboard.designer.labels.all": "display all labels",
    "dashboard.designer.labels.some": "max labels to display",
    "dashboard.designer.minor.hide": "hide minor ticks",
    "dashboard.designer.minor.show": "show minor ticks",
    "dashboard.designer.preventColor": "Series color configuration is not available for date values.",

    //Text charts
    "dashboard.designer.alignment": "Alignment",
    "dashboard.designer.position": "Position",
    "dashboard.designer.positionTL": "top left",
    "dashboard.designer.positionTC": "top center",
    "dashboard.designer.positionTR": "top right",
    "dashboard.designer.positionML": "middle left",
    "dashboard.designer.positionMC": "middle center",
    "dashboard.designer.positionMR": "middle right",
    "dashboard.designer.positionBL": "bottom left",
    "dashboard.designer.positionBC": "bottom center",
    "dashboard.designer.positionBR": "bottom right",

    //Gauge chart config
    "dashboard.designer.scaleRanges": "Scale ranges",
    "dashboard.designer.scaleRangeConfigured": "Scale range configured:",
    "dashboard.designer.unit": "1 unit",
    "dashboard.designer.units": "{0} units",
    "dashboard.designer.rangeRequired": "Both fields are required",
    "dashboard.designer.rangeInvalid": "The left value must be less than the right value",


    // dashboard save as
    "dashboard.designer.dashboard.saveas.name.placeholder": "Name your dashboard...",
    "dashboard.designer.dashboard.saveas.category.placeholder": "Select or type new...",

    //Dashboard Designer input types
    "dashboard.input.macro": "Macro",
    "dashboard.input.checkbox": "Switch Prompt",
    "dashboard.input.date": "Date Prompt",
    "dashboard.input.drop": "Drop List Prompt",
    "dashboard.input.text": "Text Field Prompt",

    "dashboard.input.checkbox.valueTrue": "True label",
    "dashboard.input.checkbox.valueFalse": "False label",

    "input.drop.editable": "Allow user input",
    "dashboard.input.drop.noneditable": "Do not allow user input",
    "input.drop.first": "First item from datasource",
    "input.drop.specific": "Specific item from datasource",
    "dashboard.input.drop.prompt.placeholder": "Enter prompt text...",
    "input.drop.specific.label": "Specific value",
    "input.drop.specific.placeholder": "Enter a value...",

    "refName": "Reference name",
    "dashboard.input.refName.prompt": "Enter a unique reference name...",
    "dashboard.input.refName.unique": "This reference name is already in use.",
    "displayLabel": "Display label",
    "dashboard.input.displayLabel.prompt": "Enter the label shown to the user...",
    "dashboard.input.value.prompt": "Enter a datasource, macro or static value",
    "dashboard.input.circular.message": "Invalid inputs noted below contain circular dependencies.",

    "dashboard.designer.title": "Dashboards Designer",
    "dashboard.dashboards": "Dashboards",
    "choose.a.dashboard": "Choose a Dashboard",
    "dashboard.dashboard": "Dashboard",
    "dashboard.new": "New Dashboard",
    "dashboard.edit": "Edit Dashboard",
    "dashboard.charts": "Charts",
    "dashboard.chart": "Chart",
    "chart": "chart",
    "dashboard": "dashboard",
    "dashboard.chart.dropTarget": "Drag a chart here",
    "dashboard.in.dashboards": "In Dashboards",
    "dashboard.run.tooltip": "A window or tab has been opened for the Dashboards module.",
    "dashboard.delete.disabled": "Dashboard cannot be deleted when being used in a drilldown.",
    "dashboard.delete.disabled.checkedOut": "Check in dashboard to delete.",
    "dashboard.run.disabled": "Assign dashboard to your group in order to run.",
    "chart.delete.disabled": "Chart cannot be deleted when being used in a dashboard or a drilldown.",
    "chart.delete.disabled.checkedOut": "Check in chart to delete.",

    // Chart Types in different display formats
    "dashboard.chart.menu.area": "Area Graph",
    "dashboard.chart.menu.bar": "Bar Chart",
    "dashboard.chart.menu.gauge": "Gauge",
    "dashboard.chart.menu.line": "Line Graph",
    "dashboard.chart.menu.pie": "Pie Chart",
    "dashboard.chart.menu.text": "Text Chart",
    "dashboard.chart.menu.table": "Table Chart",

    "dashboard.chart.type.area": "area graph",
    "dashboard.chart.type.bar": "bar chart",
    "dashboard.chart.type.gauge": "gauge",
    "dashboard.chart.type.line": "line graph",
    "dashboard.chart.type.pie": "pie chart",
    "dashboard.chart.type.table": "table",
    "dashboard.chart.type.text": "text",

    // save dashboard as
    "dashboard.saveAs.overwrite": "A dashboard with this name already exists in this category.  Please enter a unique name, choose a different category, or overwrite the existing dashboard.",
    "dashboard.saveAs.overwrite.checkedOut": "A dashboard with this name and category is checked out by another user ({0}).  Please enter a different name or choose a different category.",

    // dashboard assign groups
    "dashboard.assign.message": "To run this dashboard, it must be assigned to a group.  To ensure you can view it, assign it to one of your groups.",
    "dashboard.assign.button": "Assign Dashboard",
    "dashboard.assign.title": "Assign Groups to View ", // followed by span with dashboard title, until we can bind data in Locale Widget
    "dashboard.assign.deleted": "The Dashboard to which you are assigning groups has been deleted.",

    // dashboard unsaved changes prompt
    "dashboard.unsaved.changes.title": "Leave without saving?",
    "dashboard.unsaved.changes.desc": "There are unsaved changes to {0}.",
    "dashboard.unsaved.changes.dashboard": "this dashboard",

    // dashbaord checked-in prompt
    "dashboard.checkedIn.desc": "This {0} has been checked in by another user. Would you like to save your changes in a new {0} or discard them?",
    "dashboard.deleted.desc": "This {0} has been deleted by another user. Would you like to save your changes in a new {0} or discard them?",
    "dashboard.checkedIn.open": "opened",
    "dashboard.checkedIn.delete": "deleted",

    // dashboard/chart delete prompt
    "dashboard.deletePrompt": "Are you sure that you want to delete {0}?  This action cannot be undone.",

    //dashboard checked-in delete prompt
    "dashboard.checkInDelete.desc": "{0} is in use by {1}. It must be checked in before it can be {2} by another user.  Would you like to check in this {3}, which will discard any unsaved changes this user may have?",

    // dashboard check in prompt
    "dashboard.checkIn.title": "Check In Dashboard",
    "dashboard.checkIn.desc": "CAUTION: {0} is in use by {1}, it must be checked in before it can be opened by another user.  Would you like to check in this dashboard, which will discard any unsaved changes this user may have?",
    "dashboard.unlock.desc": "Checking in {0} will discard any unsaved changes {1} may have.",

    // chart check in prompt
    "dashboard.chart.checkIn.desc": "CAUTION: {0} is in use by {1}, it must be checked in before it can be opened by another user.  Would you like to check in this chart, which will discard any unsaved changes this user may have?",

    // Specialized Dashboard validation messages
    "dashboard.drill.choose.dashboard": "Hit 'Choose' to continue adding a link to a dashboard.",
    "dashboard.drill.choose.chart": "Hit 'Choose' to continue adding a link to a chart.",

    // General dashboard rendering messages
    "dashboard.designer.chart.error": "An error occurred while loading your chart. Try adjusting inputs and refreshing your dashboard.",
    "dashboard.viewer.chart.error": "An error occurred while loading your chart.",
    "dashboard.viewer.dashboard.error": "An error occurred while loading your dashboard.",
    "dashboard.viewer.dashboard.unassigned": "You do not have access to this dashboard. To view, please contact an administrator to assign this dashboard to you.",
    "dashboard.viewer.noDashboardsInCategory": "You do not have access to any dashboards in this category.",

    "dashboard.drill.dashboardInput": "{0} [dashboard]",
    "dashboard.drill.parentInput": "{0} [parent]",
    "dashboard.drill.label": "label",
    "dashboard.drill.targetColumnLabel": "target column label",
    "dashboard.drill.targetCellValue": "target cell value",
    "dashboard.drill.xValue": "x value",
    "dashboard.drill.yValue": "y value",
    "dashboard.drill.seriesName": "data series name",
    "dashboard.drill.axisLabel": "axis label",


    /*
     * ADMIN
     */
    "admin.title": "DocFinity Administration",
    "admin": "Administration",

    "searches": "Searches",
    "search.saved.run": "Run Saved Search",
    "search.saved": "Saved Search",
    "datastores": "Datastores",
    "export.profiles": "Export Profiles",
    "form.designs": "Form Designs",
    "hsm.policies": "HSM Policies",
    "importers": "Importers",
    "job.views": "Job Views",
    "process.models": "Process Models",
    "process.model": "Process Model",
    "processes": "Processes",
    "retention.policies": "Retention Policies",
    "retention.policy": "Retention Policy",
    "scan.profiles": "Scan Profiles",
    "scan.profile": "Scan Profile",
    "wsdl.urls": "Wsdl URLs",

    "unsaved.changes.prompt": "You may have unsaved changes.  Leaving the page may cause them to be lost.",
    "unsaved.changes.continue": "You may have unsaved changed. You must save them to continue.",
    "unsaved.changes.title": "Unsaved Changes",

    "admin.menu.system": "System",
    "admin.menu.enterpriseSearch": "Enterprise Search",
    "admin.menu.fullText": "Enterprise Search Processing",
    "admin.menu.logging": "Logging",
    "admin.menu.systemProperties": "System Properties",
    "admin.menu.auditing": "Auditing",
    "admin.menu.themes": "Themes",

    "performance.title": "System Performance",
    "admin.performance.desc": "Functional clustering distributes workload across servers. View clustering details across the system.",
    "nodes": "Nodes",
    "update.last": "Last Updated: {0}",
    "memory.physical": "Physical Memory",
    "memory.heap": "Heap Memory",
    "processors": "Processors",
    "load.cpu": "System CPU Load",
    "load.cpu.process": "DocFinity CPU Load",
    "node.conn.max": "Maximum",
    "node.conn.total": "Total",

    "input.toggle": "Toggle",

    "admin.menu.userManagement": "User Management",
    "admin.menu.ldap": "LDAP",
    "admin.menu.passwords": "Passwords",
    "admin.menu.users": "Users",
    "users.all": "All users",

    "admin.menu.gatewayUsers": "Gateway Users",
    "gateway.user": "Gateway User",
    "gatewayUsers.desc": "Manage all users that only have access to the Gateway.",
    "force.logout": "Force Logout",
    "force.logout.success": "User has been logged out. ",
    "no.gateway.users": "No gateway users exist.",

    "admin.menu.documents": "Documents",
    "metadata": "Metadata",
    "admin.menu.documentClassification": "Document Classification",
    "admin.menu.searching": "Searching",
    "admin.menu.scanning": "Scanning",
    "admin.menu.importing": "Importing",
    "admin.menu.exporting": "Exporting",
    "batches": "Batches",
    "batch": "Batch",
    "admin.menu.hsm": "HSM",
    "admin.menu.deletedDocuments": "Deleted Documents",
    "admin.menu.editing": "Editing",

    "admin.menu.dataSetup": "Data Setup",
    "admin.menu.databaseConnections": "Database Connections",
    "admin.menu.webServices": "SOAP Web Services",

    "admin.menu.eForms": "eForms",
    "admin.menu.formLibrary": "Form Management",

    "admin.menu.licensing": "Licensing",
    "admin.menu.licensePools": "License Pools",
    "admin.menu.licenseUsage": "License Usage",
    "api.actions": "API Actions",
    "api.actions.month": "API Actions per Month",
    "api.actions.record.none": "No API actions have been recorded.",
    "api.actions.notify.toggle": "Send a system message when API usage exceeds a certain percentage of actions?",
    "api.actions.notify.percent": "Notify when usage exceeds threshold",

    "businessProcesses": "Business Processes",
    "admin.menu.rolesProxies": "Roles and Proxies",
    "roles": "Roles",
    "admin.menu.businessSchedule": "Business Schedule",
    "admin.menu.shifts": "Shifts",
    "admin.menu.processModelAssignment": "Process Model Assignment",

    "admin.restDocs": "REST Web Services API",
    "admin.restDocs.desc": "Below are all the REST Web Service API calls that DocFinity makes available for third-party integration.",
    "API": "API",

    "admin.urlApiAssistant": "URL API Assistant",
    "admin.urlApiAssistant.desc": "Easily generate your DocFinity URL API request.",
    "admin.urlApiAssistant.link.destination": "Where should the link take the user?",
    "link.destination": "Link Destination",
    "all.batches": "All Batches",
    "specific.batch": "Specific Batch",
    "Trusted": "Trusted",
    "document.display": "Document Display",
    "docfinity.searching.workspace": "DocFinity Searching Workspace",
    "workspaces.no.menu": "Workspaces (hide DocFinity menu)",
    "external.panel": "Separate window",
    "readonly.panel": "Read-only mode",
    "docfinity.menu": "DocFinity Menu",
    "add.metadata": "Add Metadata",
    "directview.no": "Hide Viewer",
    "directview.first": "First document from results",
    "directview.max": "First document from results in full-screen",
    "search.panel": "Search Panel",
    "view.options": "View Options",
    "copy.url": "Copy URL",
    "copy.url.success": "URL is copied",
    "url.preview.invalid": "Configure your link above to generate a URL",
    "scramble.url": "Scramble URL",
    "docfinity.folder.workspace": "DocFinity Folder Workspace",

    "admin.auth": "Authentication",
    "admin.auth.desc": "Configure connection settings for Kerberos and OpenID Connect.  Sync OpenID Connect users and view information about past synchronizations.",
    "admin.auth.timeout": "Inactive Session Timeout",
    "kerberos": "Kerberos",
    "kerberos.domain": "Allowed LDAP Domain",
    "kerberos.command.instr": "The following command must be run on every server that should support kerberos authentication",
    "kerberos.command": "setspn -A HTTP/servername.example.com [Account running DocFinity service]",
    "oidc": "OpenID Connect",
    "issuer": "Issuer",
    "client.id": "Client ID",
    "client.secret": "Client Secret",
    "sync.openid.users": "Sync OpenID Connect Users",
    "default.auth": "Default Authentication Method",
    "authentication.settings": "Authentication Settings",
    "auth.providers": "Authentication Providers",
    "oidc.providers": "OpenID Connect Providers",
    "default.provider": "Default Provider",
    "oidc.snapshot": "OpenID Connect Provider Snapshot",
    "add.first.oidc": "Add First OpenID Connect Provider",
    "group.claim": "Group Claim",
    "array": "Array",
    "csv": "CSV",
    "portal": "Portal",
    "gateway": "Gateway",
    "external": "External",
    "scopes": "Scopes",
    "claim": "Claim",
    "user.attribute": "User Attribute",
    "user.attributes": "User Attributes",
    "user.attribute.name": "User Attribute Name",
    "resource": "Resource",
    "test.issuer": "Test Issuer Field",
    "test.issuer.success": "The Issuer URL is valid.",
    "group.config": "Group Configuration",
    "auth.provider": "Auth Provider",
    "assign.all.to.what": "Assign all users to what group?",
    "group.config.desc": "Where is group assignment configured?",
    "default.group": "Default Group",
    "groups.allowed": "Groups Allowed",
    "groups.specific": "Certain groups",
    "access": "Access",
    "user.source": "How will users be managed?",
    "gateway.only": "Gateway Only",
    "oidc.provider": "OpenID Connect Provider",
    "logout.url": "Logout URL",
    "oidc.accounts": "OpenID Connect Accounts",
    "allow.duplicate.email": "Allow multiple accounts to be created per email address",
    "group.claim.value": "Group Claim Value",
    "add.group.claim.mapping": "Add Group Claim Mapping",
    "map.claim.values": "Map Claim Values",


    // admin, no rights
    "admin.noRights": "You do not have rights to any screens in Administration.  An administrator can assign Feature Rights to you.",

    // admin enterprise search
    "admin.enterpriseSearch.preamble": "Configure the locations of the servers used for Enterprise Search.",
    "server": "Server",
    "extraction.server.status": "OCR Server status",
    "admin.enterpriseSearch.ocr": "OCR Server URL",
    "admin.enterpriseSearch.highlight": "Highlight Properties",
    "admin.enterpriseSearch.highlight.show": "Highlight the text hit",
    "admin.enterpriseSearch.highlight.frag": "Number of characters returned in a hit",
    "admin.enterpriseSearch.orphan": "Orphan Properties",
    "admin.enterpriseSearch.orphan.order": "Processing order of orphaned documents",
    "admin.enterpriseSearch.orphan.window": "Maximum number of orphan results returned",
    "admin.enterpriseSearch.url.invalid": "Please enter a valid URL in correct syntax.",
    "admin.enterpriseSearch.settings": "Enterprise Search Settings",
    "extraction.server.settings": "OCR Server Settings",
    "fulltext.stats": "Processing Statistics",
    "docs.processing.now": "Documents Processing Now:",
    "docs.processed.title.DATE": "Documents Processed By Date",
    "docs.processed.title.ERROR": "Documents Processed By Error",
    "docs.processed.title.DOC_TYPE": "Documents Processed By Document Type",
    "docs.failed": "Documents Failed",
    "docs.succeeded": "Documents Succeeded",
    "docs.reprocess.desc": "Reprocess failed documents by the criteria below.",
    "docs.reprocess.label": "Reprocess by",

    "admin.fullText.desc": "Review the documents recently processed through OCR and reprocess documents that failed.",
    "admin.fullText.process.header": "Process Documents",
    "admin.fullText.process.unknown.button": "Process Failed Documents",
    "admin.fullText.process.button": "Process {0} Failed Documents",
    "admin.fullText.process.success": "Documents successfully sent for reprocessing.",
    "admin.num.docs": "Number of Documents",
    "admin.fullText.timezone.info": "The additional day's data is displayed due to the server being in a different timezone than you are in.",
    "admin.fullText.count.estimate": "The number of documents is approximate due to current processing behind the scenes.",
    "admin.fullText.notInstalled": "The database does not have Full Text installed.  Please install the component on the database so that Enterprise Search can function properly.",

    "admin.certs": "TLS Certificates",
    "admin.cert.title": "TLS Certificate Management",
    "admin.cert.desc": "Manage and view information about how DocFinity handles TLS certificates. This includes DocFinity’s HTTPS certificate and trusting external systems like LDAP.",
    "admin.cert.tls.title": "TLS Certificate List",
    "admin.cert.tls.snapshot": "TLS Certificate Snapshot",
    "admin.cert.update.desc": "Import your TLS certificate for DocFinity HTTPS.  Please update when there is minimal usage of the system by end users. If installing a TLS certificate for the first time, DocFinity will need to restart before TLS will be enabled.",
    "cert.props.cn": "Common Name",
    "cert.props.ou": "Organizational Unit",
    "cert.props.o": "Organization",
    "cert.props.l": "Locality",
    "cert.props.st": "State Name",
    "cert.props.s": "State or Province Name",
    "cert.props.c": "Country Name",
    "cert.subject.alt": "Subject Alternative Name",
    "date.begin": "Beginning Date",
    "cert.title": "TLS Certificate for DocFinity HTTPS",
    "cert.restart.warning": "Your connection is not secure. Please restart DocFinity to enable TLS.",
    "cert.upload.done": "Now that your TLS certificate for DocFinity HTTPS is uploaded, please restart DocFinity to enable TLS. This step is only required once when first setting up TLS.",
    "cert.upload.done.title": "Final Step - Please Restart",
    "cert.import": "Import TLS Certificate for DocFinity HTTPS",
    "cert.tls.importFirst": "Enable TLS",
    "cert.upload.success": "The TLS certificate for DocFinity HTTPS is successfully applied.",
    "admin.cert.default.set": "Set TLS certificate as the default?",
    "admin.cert.default.switch.on": "Set as default",
    "admin.cert.default.switch.off": "Do not set as default",
    "admin.cert.default.desc": "The default is the certificate that we use when Server Name Indication is not used.",
    "admin.cert.delete.one": "This certificate cannot be deleted because there must be one certificate in the system.",
    "admin.cert.delete.default": "This certificate cannot be deleted because it is set as the default certificate.",
    "issued.by": "Issued By",
    "issued.to": "Issued To",
    "thumbprint": "Thumbprint",
    "trust.store": "Trust Store",
    "trust.store.snapshot": "Trust Store Certificate Snapshot",
    "approved": "Approved",
    "approve": "Approve",
    "pending": "Pending",
    "notRoot.warning": "This certificate does not appear to be a root certificate.",

    // admin shifts
    "admin.shifts.intro": "Add, delete, and modify shifts used to distribute Business Processes that use shifts.",
    "admin.shifts.grid": "Shifts List",
    "admin.shifts.addFirst": "Add Your First Shift",
    "admin.shifts.snapshot": "Shift Snapshot",
    "admin.shifts.deleteMessage": "Shift cannot be deleted because it is in use.",
    "admin.shifts.workingHours": "Working Hours",
    "admin.shifts.shiftMembers": "Shift Members",
    "admin.shifts.unique": "Shift name must be unique.",
    "admin.shifts.ends.at": "Ends at {0}",
    "admin.shifts.ends.on": "Ends {0} at {1}",
    "admin.shifts.no.assignments": "No users assigned to this shift.",
    "admin.shifts.no.workhours": "Working hours have not been configured.",

    // admin document exporting
    "admin.exporters.addFirst": "Add Your First Export Profile",
    "admin.exporters.server": "Export Server",
    "admin.exporters.intro": "Compress documents into output files that are stored in the upload repository.",
    "admin.export.snapshot": "Export Snapshot",
    "admin.export.fileType": "File type",
    "file.type.colon": "File type:",
    "admin.export.nameFormat": "Document Name Format",
    "admin.export.archiveSize": "Maximum archive size",
    "admin.export.outputStructure": "Output Directory Structure",
    "admin.exporters.unique": "Export Profile name must be unique.",
    "admin.export.showNone": "No markup or redactions",
    "admin.export.useSSL": "Secure connection (https)",
    "admin.export.clusterNode": "Cluster node",

    // admin system properties
    "systemproperties.intro": "View and edit system properties, grouped by category. Default values can be restored for one or more system properties.",
    "systemproperties.module.title": "System Property List",
    "systemproperties.propertyName": "Property Name",
    "systemproperties.subcategory": "Sub-category",
    "systemproperties.resetAll": "Reset All System Properties",
    "systemproperties.snapshot": "System Property Snapshot",
    "systemproperties.resetOneConfirm": "Are you sure you want to reset {0} to {1}?",
    "systemproperties.resetEmptyConfirm": "Are you sure you want to reset {0} to an empty default value?",
    "systemproperties.changeWarning": "Changes to this System Property may not take effect until the system is restarted or until users log out and log in again.",

    // admin smtp server configuration and email settings
    "admin.emailSettings.hostname": "Host / IP",
    "admin.emailSettings.security": "TLS / STARTTLS",
    "admin.emailSettings.testSmtp": "Send me a test email",
    "admin.emailSettings.smtpTitle": "SMTP Configuration",
    "admin.emailSettings.smtpPreamble": "Set the server, user account, and credentials used for outgoing email.",
    "admin.emailSettings.stringsTitle": "Email Properties",
    "admin.emailSettings.stringsPreamble": "Set text used in emails.",
    "admin.emailSettings.maxFileSize": "Maximum file size allowed for email attachments",
    "admin.emailSettings.emailSubject": "Email subject",
    "admin.emailSettings.generatePassword": "Generate Password",
    "admin.emailSettings.forgotPassword": "Forgot Password",
    "admin.emailSettings.forceChangeFirst": "Force change first",
    "admin.emailSettings.forceChangeNext": "Force change next",
    "admin.emailSettings.introOne": "Intro one",
    "admin.emailSettings.introTwo": "Intro two",
    "admin.emailSettings.optFirst": "Optional first",
    "admin.emailSettings.optNext": "Optional next",
    "admin.emailSettings.forgotPassIntro": "Forgot password intro",
    "admin.emailSettings.forgotPassEnd": "Forgot password end",
    "from.address": "From Address",

    // admin logging
    "admin.logging.desc": "Set the level of detail logged for individual DocFinity modules and view log files.",
    "admin.logging.modules.title": "Logging Levels",
    "admin.logging.clear.label": "Start New Log File",
    "admin.logging.set.all.label": "Set all log levels to",
    "admin.logging.set.all.button": "Set All",
    "admin.logging.level.fatal": "fatal",
    "admin.logging.level.error": "error",
    "admin.logging.level.warn": "warn",
    "admin.logging.level.info": "info",
    "admin.logging.level.debug": "debug",
    "admin.logging.level.trace": "trace",
    "admin.logging.module.header": "Module",
    "admin.logging.level.header": "Log level",
    "admin.logging.additional": "To see additional logging, please",
    "admin.logging.additional.download": "download the log file here.",
    "log.files": "Log Files",
    "log.download.item": "Download {0} Log",
    "log.download.popup": "Download Log...",
    "log.download.description": "Choose the day from which you would like the log.",
    "log.clear.description": "Start a new log file for which node?",
    "log.date": "Date of log",
    "nodes.all": "All Nodes",
    "node.specific": "{0} Node",
    "node.current": "Your current node",
    "nodeDown.error": "We could not connect to this node.  Please check the connection and try again once you've verified it is running.",

    "config.advanced": "Advanced Configuration",

    // admin auditing
    "admin.audit.desc": "Manage auditing categories and audit types.",
    "audit.type": "Audit Type",
    "audit.types": "Audit Types",
    "audit.alerts": "Alerts",
    "audit.batch": "Batch Actions",
    "audit.bpm": "BPM Actions",
    "audit.advanced.models": "Audited Process Models",
    "audit.advanced.description": "Turn on and off auditing of BPM audits per Process Model.",
    "audit.doc.action": "Document Actions",
    "audit.doc.change": "Document Changes",
    "audit.doc.view": "Document Viewing",
    "rm.title": "Records Management",
    "audit.security": "Security Changes",
    "audit.in.doc.history": " only included in document history",
    "audit.in.records.search": " only included in records search",
    "audit.in.doc.records": " included in document history and records search",
    "audit.in.on": " audit types that are turned on",
    "audit.in.off": " audit types that are turned off",
    "audit.in.both.onOff": " on and off audit types",
    "bpm.models.none": "There are no Process Models created.",
    "bpm.models.audited.none": "Currently, there are no Process Models being audited",
    "audit.bpm.none": "There are no BPM Audits turned on.",
    "audit.save.turnedOff.confirm": "You are turning off auditing for certain audit types. Future actions associated with these audit types will no longer be audited.",
    "audit.save.turnedOff.doc.confirm": "Some of these audit types are used by document history.  Document history will not show future actions associated with these audit types.",
    "audit.save.turnedOff.record.confirm": "Some of these audit types are used by records search.  Records search will not show future actions associated with these audit types.",
    "audit.save.turnedOff.doc.record.confirm": "Some of these audit types are used by document history and records search.  Document history and records search will not show future actions associated with these audit types.",
    "audit.save.confirm.title": "Save anyway?",
    "audit.save.success": "Auditing successfully updated.",

    // admin themes
    "admin.themes.desc": "Create customized themes that can be applied to Forms and Gateways.",
    "admin.themes.addFirst": "Add Your First Theme",
    "admin.themes.snapshot": "Theme Snapshot",
    "admin.themes.grid": "Themes List",
    "admin.themes.deleteMessage": "Theme cannot be deleted because it is in use.",
    "admin.themes.unique": "Theme name must be unique.",
    "admin.themes.editingDescription": "These are the CSS values that will be used to generate a stylesheet for your theme. Default values have been provided as examples of valid CSS property values.",

    "admin.themes.customFont": "Custom Font",
    "admin.themes.customFont.description": "DocFinity can reference a custom font through the fields below. Specify the URL in the font source field and name your font to be referenced in other areas.",
    "admin.themes.customFont.preview": "Custom Font Preview",

    "admin.themes.headerBar": "Gateway Header Bar",
    "admin.themes.body": "Gateway Body",
    "admin.themes.breadcrumbs": "Gateway Breadcrumbs",
    "admin.themes.sections": "Gateway Sections",
    "admin.themes.gatewayLinks": "Gateway Links",
    "admin.themes.feedback": "Gateway Feedback",

    "admin.themes.pageTitlePreview": "Page Title Preview",
    "admin.themes.gatewayTitlePreview": "Gateway Title Preview",
    "admin.themes.gatewaySectionHeaderPreview": "Section Header Preview",
    "admin.themes.gatewaySectionDescriptionPreview": "Section Description Preview",

    "gateway.components": "Gateway Components",
    "components": "Components",
    "component": "Component",
    "admin.themes.general.header": "General Theme Styles",

    "admin.themes.warning": "Modifying the theme will not visually affect any Forms and Form designs until they are refreshed.",

    "admin.themes.subgroup.border": "Border",
    "admin.themes.subgroup.layout": "Layout",
    "admin.themes.subgroup.success": "Success Feedback",
    "admin.themes.subgroup.failure": "Failure Feedback",
    "admin.themes.subgroup.primaryColumns": "Primary Columns",

    "admin.themes.preview.failure": "Preview Failure",
    "admin.themes.preview.success": "Preview Success",
    "admin.themes.preview.focus.prefix": "Focus on",
    "admin.themes.preview.focus.suffix": "to preview the focus color in contrast to the background color.",
    "admin.themes.preview.link": "this link",
    "admin.themes.preview.primaryColumnLink": "Preview Primary Column Link",
    "admin.themes.preview.secondaryColumn": "Preview Secondary Column",
    "admin.themes.preview.primaryColumnSpan": "Preview Primary Column Disabled Link",
    "preview.1": "One",
    "preview.2": "Two",
    "preview.3": "Three",
    "preview.4": "Four",

    "admin.themes.props": "Theme Properties",

    "admin.general.disclaimer": "These general styles will apply to elements that do not have theme properties configured.",

    // admin Notes
    "note": "Note",
    "note.type": "Note Type",
    "note.types": "Note Types",
    "notes": "Notes",
    "notes.desc": "Manage types of notes your users can add to documents.",
    "admin.notes.snapshot": "Note Type Snapshot",
    "admin.notes.addFirst": "Add First Note Type",
    "admin.notes.unique": "Note Type name must be unique.",
    "admin.notes.grid": "Note Type List",
    "temporarily": "Temporarily",
    "time.limit": "Time Limit",
    "user.permissions": "User Permissions",
    "deletable": "Deletable",
    "creatable": "Creatable",
    "notes.add": "Add Note",
    "note.add.to": "Add note to",
    "notes.view": "View Notes",
    "notes.view.document": "View Document Notes",
    "notes.view.folder": "View Folder Notes",
    "notes.edit": "Edit Note",
    "note.delete": "Delete Note",
    "notes.delete": "Delete Notes",
    "notes.delete.confirm": "Are you sure you want to delete this note?",
    "notes.author": "Author",
    "notes.content": "Content",
    "notes.content.lower": "content",
    "note.author": "Note author",
    "note.content": "Note content",
    "notes.filtered": "No notes match your filter.",
    "note.audit.create": "Note - Create",
    "note.audit.edit": "Note - Edit",
    "note.audit.delete": "Note - Delete",
    "notes.sort.asc": "Sort notes ascending",
    "notes.sort.desc": "Sort notes descending",
    "note.type.delete.in.use": "This Note Type cannot be deleted because it is in use.",
    "note.type.delete.has.notes": "This Note Type cannot be deleted because there are documents in the system using notes of this type.",
    "notes.delete.from": "Delete notes from",
    "notes.of.folder": "Folder's notes",
    "notes.of.folder.documents": "Documents' notes",
    "editable.temp.snapshot": "(up to {0} hours)",

    // admin BPM - Roles and Proxies
    "admin.roles.desc": "Create and manage the roles used for distributing jobs to specific types of users.",
    "admin.roles.list": "Roles List",
    "admin.roles.snapshot": "Roles Snapshot",
    "admin.roles.name": "Role Name",
    "admin.roles.ordinal": "Proxy order",
    "admin.roles.proxy0": "Role Holder",
    "admin.roles.proxy": "Proxy",
    "admin.roles.deleteMessage": "Role cannot be deleted because it is in use.",
    "admin.roles.addFirst": "Add Your First Role",
    "admin.roles.missingUser": "Please assign a user",
    "admin.roles.assignFirst": "Make Role Holder",

    // admin license usage
    "admin.licenseUsageTotalLicenses": "Total licenses in use: {0}",
    "admin.licenseUsageThreshold": "{0} a system message if the license usage threshold exceeds {1}{2}",
    "admin.licenseUsageThresholdDisabled": "{0} a license usage system message",
    "license.usageIntro": "View details about which licenses are currently in use; revoke licenses that should not be used; and configure options for notification about license usage.",
    "license.usageRevoke": "Revoke License",
    "license.usageSnapshot": "Usage Snapshot",
    "license.usageNotification": "Usage Notification",
    "license.usageReport": "Report usage {0}",
    "license.usageDoNotSend": "Do not send",
    "license.usageSend": "Send",
    "admin.licenseRevoked": "Revoke license(s) complete.",
    "admin.licenseRevokeFailed": "A license was not able to be revoked. Please select the license in use and try again.",
    "admin.dedicatedAvailable": "Dedicated available",
    "admin.dedicatedAvailable.context": "Dedicated available: {0}",
    "admin.dedicatedUsed": "Dedicated used",
    "admin.dedicatedUsed.context": "Dedicated used: {0}",
    "admin.groupAvailable": "Group available",
    "admin.groupAvailable.context": "Group available: {0}",
    "admin.groupUsed": "Group used",
    "admin.groupUsed.context": "Group used: {0}",
    "admin.floatingAvailable": "Floating available",
    "admin.floatingAvailable.context": "Floating available: {0}",
    "admin.floatingUsed": "Floating used",
    "admin.floatingUsed.context": "Floating used: {0}",
    "userAgent": "User agent",
    "clientKey": "IP address",
    "lastAccess": "Last access",
    "lastAccess.time": "Last access time",
    "NEVER": "Never",
    "DAILY": "Daily",
    "WEEKLY": "Weekly",
    "MONTHLY": "Monthly",
    "forever": "Forever",

    // admin license pools
    "admin.license.pools.desc": "Assign a user a dedicated license or add a group license pool to share among members of the group.",
    "admin.license.pools.user.title": "Dedicated User Licenses",
    "admin.license.pools.user.desc": "Users assigned a dedicated license are guaranteed a license at all times.",
    "admin.license.pools.user.add.desc": "Select available users and assign them dedicated licenses.",
    "admin.license.pools.group.title": "Group License Pools",
    "admin.license.pools.group.desc": "Group license pools specify the number of licenses reserved to share among members of each group.",
    "admin.license.pools.group.add": "Add group license pool",
    "admin.license.pools.group.add.desc": "Choose a group and assign the number of licenses to be shared by group members.",
    "username": "Username",
    "firstName": "First name",
    "lastName": "Last name",
    "admin.license.pools.number": "# Licenses",
    "admin.license.pools.total": "Total licenses available {0}",
    "admin.license.pools.user.first": "Add First Dedicated User License",
    "admin.license.pools.group.first": "Add First Group License Pool",
    "admin.license.pools.reserved": "All licenses are reserved.",
    "admin.license.pools.totalCount": "Total reserved: {0}",

    // users / groups
    "admin.users.available": "Available Users",
    "admin.users.filter.group": "Filter users by group",
    "admin.groups.available": "Available Groups",
    "available.none": "There are no available {0}.",
    "admin.groups.placeholder": "Type a group name...",
    "users": "users",
    "user": "user",

    "users.desc": "Add, delete, and edit users. Select a user to view his/her properties, edit information, or reset the password.",
    "users.list": "User List",
    "users.username": "User",
    "users.username.value": "User: {0}",
    "users.firstName": "First",
    "users.lastName": "Last",
    "users.snapshot": "User Snapshot",
    "users.middleName": "Middle name",
    "email": "Email",
    "phone": "Phone",
    "users.manual": "Manual",
    "users.generate": "Generate",
    "users.status": "User status",
    "copy.api.key": "Copy API Key",
    "active": "Active",
    "inactive": "Inactive",
    "users.requireChange": "Should the user be forced to change the password on next login?",
    "users.emailPassword": "Should the password be sent to the user?",
    "users.canNotDelete": "You cannot delete yourself.",
    "users.userNameUnique": "Username must be unique.",
    "users.passwordMatch": "Passwords must match.",
    "users.passwordShort": "Password is not long enough.",
    "users.passwordUpperCase": "Password does not contain enough upper case letters.",
    "users.passwordLowerCase": "Password does not contain enough lower case letters.",
    "users.passwordSpecial": "Password does not contain enough special characters.",
    "users.passwordNumber": "Password does not contain enough numbers.",
    "users.passwordWhitespace": "Password should not start or end with whitespace.",
    "users.copyUser": "Copy groups from user",
    "users.copyHint": "Type a user name, first name, or last name...",
    "users.changePasswords.conditional.1": "Change Password",
    "users.changePasswords": "Change Passwords",
    "users.setPasswords.conditional.1": "Set Password",
    "users.setPasswords": "Set Passwords",
    "users.noLogin": "The generated password has not been emailed.  User will not be able to login until another password is set.",
    "users.assignGroups": "Change Group Membership",
    "users.noGroups": "{0} is not a member of any groups.",
    "users.fromGroup": "Feature Right is granted by: {0}",
    "users.passwordExpiration": "Password expiration",
    "users.expiration.conditional.1": "Yes, password expires after 1 day",
    "users.expiration": "Yes, password expires after {0} days",
    "users.expiresAfter": "Expires after",
    "days": "days",
    "days.conditional.1": "day",
    "weeks": "weeks",
    "weeks.conditional.1": "week",
    "months": "months",
    "months.conditional.1": "month",
    "years": "years",
    "years.conditional.1": "year",
    "days.count": "{0} days",
    "days.count.conditional.1": "{0} day",
    "weeks.count": "{0} weeks",
    "weeks.count.conditional.1": "{0} week",
    "months.count": "{0} months",
    "months.count.conditional.1": "{0} month",
    "years.count": "{0} years",
    "years.count.conditional.1": "{0} year",
    "items.offPage": "You have selected items on other pages.",
    "users.security.noPermissions": "No permissions",
    "users.groupsCopied": "{0} groups added",
    "users.groupsCopied.conditional.1": "1 group added",
    "users.groupsCopied.conditional.-1": "User does not exist",
    "users.noPermissions": "The selected user does not have any Feature Rights assigned.",
    "users.noSecurity": "The selected user does not have access to any documents.",
    "user.middleName.invalid": "This field contains invalid characters.",
    "change.auth.method": "Change Authentication Method",
    "change.auth.method.docfinity": "This user's authentication method will be changed to DocFinity. Continue?",
    "change.auth.method.oidc": "This user's authentication method will be changed to be included in the CSV configuration of an OpenID Connect. Continue?",
    "auth.method": "Authentication Method",
    "auth.gateway.not.needed": "Authentication is handled by the Gateway.",
    "auth.urlapi.need.destination": "Configure the link destination before choosing the authentication method.",
    "users.setUpcoming": "Set Upcoming Login Authentication",
    "upcoming.login.authentication": "Upcoming Login Authentication",
    "current.auth.method.selected": "Current Authentication Method for the selected users",

    "admin.scanProfiles.intro": "A Scan Profile is a group of pre-set options that are applied when scanning. Configure a new Scan Profile or select an existing one to view its properties, edit, assign access to groups, or delete.",
    "scan.profiles.list": "Scan Profile List",
    "scan.profiles.snapshot": "Scan Profile Snapshot",
    "file.type": "File Type",
    "grayscale": "Grayscale",
    "resolution": "Resolution",
    "dpi": "dpi",
    "scan.deleteDefault": "The default Scan Profile can't be deleted.",
    "paging": "Paging",
    "scan.duplex": "duplex",
    "scan.multipage": "multiple-page documents",
    "scan.barcode": "use barcode page to separate documents",
    "scan.deleteBack": "delete page created by back of barcode separator page",
    "scan.combine": "combine front and back into 2-page documents",
    "scan.unique": "Scan setting name must be unique.",
    "scan.scanTo": "Scan to",
    "local.directory": "Local Directory",
    "server.directory": "Server Directory",
    "directory.path": "Directory Path",
    "scanning.port": "Scanning Port",
    "scanning.port.confirm": "This value affects every installation of DocFinity Desktop, requiring an update to each client if a change is made.",

    "passwords.desc": "View and modify rules for acceptable passwords. ",
    "passwords.constraints": "Password Constraints",
    "passwords.must": "Must contain",
    "passwords.lowerCase": "lower case characters",
    "passwords.lowerCase.conditional.1": "lower case character",
    "passwords.upperCase": "upper case characters",
    "passwords.upperCase.conditional.1": "upper case character",
    "passwords.special": "special characters",
    "passwords.special.conditional.1": "special character",
    "passwords.minLengthValidation": "Minimum length must be greater than the sum of lowercase characters, uppercase characters, special characters, and numbers.",
    "passwords.forceChange": "Would you like to require password change for all users the next time they log in?",
    "passwords.retention": "Retention Count",
    "passwords.previous": "previous passwords",
    "passwords.previous.conditional.1": "previous password",
    "numbers": "numbers",
    "numbers.conditional.1": "number",
    "characters": "characters",
    "characters.conditional.1": "character",
    "passwords.confirmChange": "All users will be required to change their password on next log in.",

    "permission.list": "List",
    "permission.overrideRedactions": "Override Redactions",
    "permission.viewMarkup": "View Markup",

    "searchType.template": "Template",
    "search.searchType.template": "Template Search",
    "search.searchType.gateway": "Gateway Search",
    "searchType.storedProcedure": "Stored Procedure",
    "search.searchType.storedProcedure": "Stored Procedure Search",
    "searchType.checklist": "Checklist",
    "search.searchType.checklist": "Checklist Search",
    "search.results.save": "You've changed the order of this search's display columns.  Do you want to enforce this new column order on all users?  This would reset all user settings on this search.",
    "jobViews.results.save": "You've changed the order of this Job View's display columns.  Do you want to enforce this new column order on all users?  This would reset all user settings on this Job View.",
    "folderTypes.results.save": "You've changed the order of this Folder Type's display columns.  Do you want to enforce this new column order on all users?  This would reset all user settings on this Folder Type.",
    "usersettings.reset": "Reset user settings",
    "usersettings.keep": "Retain user settings",

    "gateway.search.result.limit": "You can define up to 5 display result columns in a Gateway Search.",
    "results.max.exceeded": "There are too many results to display. A selection of 5000 results is shown below.",

    // admin LDAP
    "admin.ldap.disable.title": "Confirmation",
    "admin.ldap.disable.config": "LDAP users will not be able to use DocFinity. Are you sure you want to disable LDAP?",
    "admin.ldap.disable.groups": "Groups will no longer be updated between LDAP and DocFinity. Would you still like to turn off Group Functionality?",
    "admin.ldap.disable.sched": "Turning the LDAP Scheduler off will stop all scheduled synchronizations. Would you still like to turn off the scheduler?",
    "admin.ldap.disable.edit": "To enable editing, please save edits in other panels.",
    "admin.ldap.disable.selection": "Please configure the LDAP Group Mapping to be able to select LDAP groups.",
    "admin.ldap.notConfigured": "Please configure and turn on LDAP to allow for LDAP group configuration.",
    "admin.ldap.notConfigured.scheduler": "Please configure and turn on LDAP to be able to schedule LDAP synchronizations.",
    "admin.ldap.config.title": "Configure LDAP",
    "admin.ldap.desc": "Users and groups can be managed externally through LDAP. Configure a connection and synchronize users and groups with an LDAP directory.",
    "admin.ldap.config.invalid": "LDAP configuration must be completed for a successful synchronization.",
    "admin.ldap.config.test.conn.fail.conn": "Failed connecting to server.",
    "admin.ldap.config.test.conn.fail.auth": "Failed authenticating to server.",
    "admin.ldap.config.test.config": "Test Configuration",
    "admin.ldap.config.test.config.fail": "Failed testing configuration.",
    "admin.ldap.config.conn": "LDAP Server Connection",
    "admin.ldap.config.conn.type": "LDAP server type",
    "admin.ldap.config.conn.type.ad": "Active Directory",
    "admin.ldap.config.conn.type.ldap": "Standard LDAP",
    "admin.ldap.config.conn.server": "Server IP address or name",
    "admin.ldap.config.conn.ssl": "Connect to LDAP",
    "admin.ldap.config.conn.ssl.on": "using SSL",
    "admin.ldap.config.conn.ssl.off": "without SSL",
    "admin.ldap.config.auth": "Server Authentication",
    "admin.ldap.config.auth.baseDn": "Base Distinguished Name",
    "admin.ldap.config.auth.userDn": "User Distinguished Name",
    "admin.ldap.config.dn.useBase": "Starting node",
    "admin.ldap.config.dn.useBase.on": "Use Base DN",
    "admin.ldap.config.dn.useBase.off": "Specify",
    "admin.ldap.config.mapping": "DocFinity - LDAP Mapping",
    "admin.ldap.config.mapping.phone": "Phone number",
    "admin.ldap.config.mapping.email": "Email address",
    "admin.ldap.config.mapping.ref": "External reference",
    "admin.ldap.config.mapping.lastmod": "Date last modified",
    "admin.ldap.config.results": "Mapping Configuration Test Results",
    "admin.ldap.groups.title": "Configure LDAP groups",
    "admin.ldap.groups.invalid": "LDAP group configuration must be completed for a successful synchronization.",
    "admin.ldap.groups.mapping": "DocFinity - LDAP Group Mapping",
    "admin.ldap.groups.selection": "DocFinity - LDAP Group Selection",
    "admin.ldap.groups.filter": "Group filter",
    "admin.ldap.groups.filter.placeholder": "Click to type the group filter...",
    "admin.ldap.groups.name": "Group name",
    "admin.ldap.groups.name.placeholder": "Click to type the group name...",
    "admin.ldap.groups.memberOf": "Group Membership",
    "admin.ldap.groups.memberOf.placeholder": "Click to map group membership...",
    "admin.ldap.groups.description": "Group description",
    "groups.all": "All groups",
    "admin.ldap.groups.all.off": "Choose groups",
    "admin.ldap.groups.load": "Load LDAP groups",
    "admin.ldap.groups.group.name": "Group Name",
    "admin.ldap.groups.chosen": "LDAP groups selected for syncing",
    "admin.ldap.sched.title": "LDAP Synchronization Scheduler",
    "admin.ldap.sched.invalid": "The scheduler is on, but there are no scheduled synchronizations.",
    "admin.ldap.sched.editorTitle": "Add a scheduled LDAP sync",
    "admin.ldap.sched.addButton": "Add Scheduled Sync",
    "admin.ldap.sync.summary": "Summary of Last Synchronization",
    "admin.ldap.sync.summary.time": "Time Elapsed",
    "admin.ldap.sync.summary.usersAdded": "Users added",
    "admin.ldap.sync.summary.usersModified": "Users modified",
    "admin.ldap.sync.summary.usersDeleted": "Users deleted",
    "admin.ldap.sync.summary.groupsAdded": "Groups added",
    "admin.ldap.sync.summary.groupsModified": "Groups modified",
    "admin.ldap.sync.summary.groupsDeleted": "Groups deleted",
    "admin.ldap.sync.summary.errorCount": "Errors",
    "view.details": "View Details",
    "hide.details": "Hide Details",
    "admin.ldap.sync.manual": "Manual Synchronization",
    "admin.ldap.sync.manual.button": "Synchronize",
    "admin.ldap.sync.errors.objectName": "LDAP user or group",
    "admin.ldap.sync.errors.fieldName": "Field Name",
    "admin.ldap.sync.errors.message": "Error Message",
    "admin.ldap.sync.details": "Last Synchronization Details",
    "admin.ldap.sync.details.lastSyncAction": "Last Sync Action",
    "date.modify": "Date Modified",
    "admin.ldap.summaryHeader": "LDAP Summary and Details",
    "max.results.per.page": "Maximum results per page",
    "parameter.chunk.size": "Parameter chunk size",
    "follow.referrals": "Follow referrals",

    //Dashboards admin screen
    "dash.preamble": "Import and manage Dashboards.",
    "category.name": "Category Name",
    "dashboard.firstCategory": "Add Your First Dashboard Category",
    "import.dashboard": "Import Dashboard",
    "dashboard.snapshot": "Dashboard Snapshot",
    "last.edited": "Last Edited",
    "no.charts": "No charts assigned to this dashboard",
    "dashboard.drilldown": "Dashboard Drilldown",
    "dashboard.drillDownCountPrevent": "Dashboards used in a drilldown can't be deleted.",
    "dashboard.isLockedPrevent": "Dashboards that are checked out can't be deleted.",
    "dashboard.bothPrevent": "Dashboard used in a drilldown and Dashboards that are checked out can't be deleted.",
    "dashboard.deleteDashboard": "Delete Dashboards only",
    "dashboard.deleteCategory": "Delete all",
    "dashboard.combinedMessage": "Are you sure you want to delete these Dashboards: {0}, as well as these categories: {1}?",
    "edit.in.designer": "Edit in Designer",
    "dashboard.category.hasItems": "Categories with Dashboards in them can't be deleted.",
    "dashboards.assignInstructions": "Check the Dashboards on the left that you'd like to assign to groups.  Then click the Assign Groups button.",
    "dashboard.prompts.none": "No Dashboard prompts for configuration.",

    //Charts admin screen
    "chart.preamble": "Import and manage charts.",
    "chart.inUsePrevent": "Charts used in a dashboard can't be deleted.",
    "chart.isLockedPrevent": "Charts that are checked out can't be deleted.",
    "chart.bothPrevent": "Charts used in a dashboard and charts that are checked out can't be deleted.",
    "chart.import": "Import Chart",
    "chart.import.first": "Import Your First Chart",
    "chart.snapshot": "Chart Snapshot",
    "chart.xAxis": "X Axis",
    "chart.yAxis": "Y Axis",
    "charts.none": "There are no charts in the system.",

    //Document classification admin screen
    "doc.preamble": "Add, edit, and delete document Categories and Document Types.",
    "category.unique": "Category name must be unique.",
    "add.category": "Add Category",
    "add.docType": "Add Document Type",
    "category.snapshot": "Category Snapshot",
    "docType.snapshot": "Document Type Snapshot",
    "docType.unique": "Document Type name must be unique.",
    "category.noDelete": "A Category with Document Types can't be deleted.",
    "category.internal": "Default Category can't be edited.",
    "docType.noDelete": "The default Document Type can't be deleted.",
    "versioning": "Versioning",
    "versioning.required": "Enabled by Records Management",
    "business.process": "Business Process",
    "overlays": "Overlays",
    "overlay": "Overlay",
    "expected.doc.width": "Expected Document Width",
    "expected.doc.height": "Expected Document Height",
    "doc.noMetadata": "Prompts have not been configured.",
    "copy.settings": "Copy Settings",
    "configure.scratch": "Configure From Scratch",
    "indexing.configuration": "Indexing Configuration",
    "indexing.properties": "Indexing Properties",
    "indexing.plugin": "Indexing Plugin",
    "indexing.plugin.placeholder": "Plugin name...",
    "indexing.plugin.addNew": "Add plugin...",
    "indexing.plugin.add.title": "Add Indexing Plugin",
    "indexing.plugin.unique": "Plugin name must be unique.",
    "displayValue": "(Display Value)",
    "doc.setDisplayValue": "Set as Display Value",
    "doc.metadata.notSaved": "Indexing configuration is being edited. Do you wish to discard those changes to save?",
    "metadata.assignFirst.helpless": "An administrator must add metadata before indexing can be configured.",
    "metadata.and.indexing": "Metadata and Indexing Configuration",
    "initialFocus": "(Initial Focus)",
    "displayValueFocus": "(Display Value and Initial Focus)",
    "doc.setFocus": "Set To Have Initial Focus",
    "dependant.metadata": "Dependent metadata",
    "doc.editable.help": "This controls whether the field may be changed at all.",
    "doc.retain": "Retain value",
    "doc.retain.help": "Preserve the value for this field from the previously indexed document.",
    "doc.blind": "Blind entry",
    "doc.blind.help": "Use a double-blind control, which masks input with asterisks and requires double entry to confirm input. Blind entry is not possible if a datasource is configured, or if the field is not editable.",
    "doc.override": "Override errors",
    "doc.override.help": "Allow users to override validation errors that may be encountered during data entry.",
    "doc.use.datasource": "Use datasource",
    "doc.use.datasource.help": "Set value based off of a datasource. Configuring a datasource is not possible if a blind entry is enabled.",
    "doc.use.datasource.help.prompt": "Set value based off of a datasource. Configuring a datasource is not possible if a blind entry is enabled. This will be used in indexing and in document information.",
    "doc.ds.editable.help": "This determines if a value may be typed in the field.",
    "doc.ds.displayValueOrder": "Display Value order",
    "doc.ds.reindex": "When a value exists",
    "doc.ds.reindex.help": "Run datasource if the field already has a value.",
    "doc.ds.reindex.yes": "Run datasource",
    "doc.ds.reindex.no": "Do not run datasource",
    "doc.ds.reindex.initial": "Initial reindex value",
    "doc.ds.reindex.initial.help": "This datasource will set the initial value for the unindexed prompt to drive metadata when reindexing a document.",
    "as.is": "As is",
    "doc.metadata.dependent.help": "Check the Metadata Objects on  which this Metadata Object depends.",
    "doc.metadata.dependent.none": "This Metadata Object does not depend on other Metadata Objects.",
    "metadata.depends.on": "Dependent On",
    "dependent": "Dependent",
    "doc.noValidators": "No available Validators that are compatible with the Metadata Object.",
    "doc.noValidatorsConfigured": "No Validators are configured for this Metadata Object.",
    "doc.metadata.dependent.noneEditable": "No other Metadata Objects are configured that this Metadata Object may depend on.",
    "preview.indexing": "Preview Indexing",
    "category.space": "Category already has the maximum number of Document Types.",
    "details": "Details",
    "details.value": "Details:\n{0}",
    "add.validator": "Create New Validator",
    "add.datasource": "Create a datasource",
    "add.datasource.header": "Create New Datasource",
    "x.offset": "X Offset",
    "y.offset": "Y Offset",
    "overlays.label.default": "Display overlay",
    "overlay.page.range": "Page range",
    "overlay.otherDefault": "Only one overlay can be the default overlay for a Document Type.",
    "overlay.range.invalid": "Range must be in form of #-#, #, *, or #-* where # is a number.",
    "overlay.range.overlap": "Overlay ranges can not overlap at any point.",
    "overlay.preview.instr": "Upload a document to preview how your overlay will appear on that document.",
    "overlay.range.example": "Ex: 1,2-5,6-*",
    "page.change": "Change page",
    "page": "Page",
    "page.column": "Pg.",
    "metadata.overMax": "A maximum of 250 metadata can be assigned to a Document Type.",
    "package.name.select": "Package Item name...",

    //Job Views screen
    "view.desc": "Job Views determine how jobs are filtered, sorted, and displayed in users' Job Queues. Add, delete, and edit the available job views, and assign them to groups.",
    "view.list": "Job Views List",
    "job.view": "Job View",
    "view.snapshot": "Job View Snapshot",
    "view.default.noDelete": "Can't delete default Job Views.",
    "workable": "workable",
    "releasable": "releasable",
    "personal": "personal",
    "common": "common",
    "job.type": "Job Type",
    "job.dist.type": "Job Distribution Type",
    "display": "Display",
    "Sorts": "Sorts",
    "sort.result.by": "Sort result by",
    "sort.by.header": "Sorted by",
    "forced.column": "{0}(Forced)",
    "auto.checkout": "Auto-checkout",
    "user.prompts": "User Prompts",
    "job.dist.filter": "Job Distribution Filter",
    "users.of.groups": "Users of groups",
    "logged.in.user": "logged in user",
    "all.groups": "all groups",
    "all.users": "all users",
    "selected.groups": "selected groups",
    "users.in.selected": "users in selected groups",
    "logged.in.user.groups": "groups of logged in user",
    "other.filters": "Other Filters",
    "add.first.column": "Add Your First Column",
    "Data": "Data",
    "job.property": "job property",
    "Job.Property": "Job Property",
    "job.properties": "Job Properties",
    "piv": "Process Instance variable",
    "pi.id": "Process Instance ID",
    "pip": "Package Item property",
    "PIV": "Process Instance Variable",
    "package.item.property": "Package Item Property",
    "columnVariable.maxLength": "Package Item and Package Item property combined must have a length less than 254 characters.",
    "Package.item.type": "Package Item type",
    "noPackage.validate": "Package Item can't be 'PACKAGE'",
    "Forced": "Forced",
    "spoon.feed": "Should jobs auto-checkout?",
    "spoon.feed.no": "Auto-checkout for jobs is only available when at least one sort is forced and the job type is workable.",
    "field.type": "Field Type",
    "text.field": "text field",
    "dropdown": "drop-down",
    "prompts.uniqueName": "Prompts must have a unique name.",
    "process.required": "A Process Model must be selected.",
    "views.dist.help.conditional.COMMON": "You are configuring your job distribution filter for the common job distribution type.",
    "views.dist.help.conditional.PERSONAL": "You are configuring your job distribution filter for the personal job distribution type.",
    "view.unique": "Job View name must be unique.",
    "item.required": "At least one item must be selected.",
    "custom.filters": "Custom Filters",
    "job.property.display": "{0} (job property)",
    "piv.display": "{0} (Process Instance variable)",
    "pip.display": "{0} (Package Item property)",
    "prompt.display": "{0} (prompt)",
    "like": "like",
    "not.like": "not like",
    "job.filter.invalid": "Custom filter must compare a column to either a prompt or a static value.",
    "filters.needColumns": "Columns must be configured in order to add filters. ",
    "job.filter.first": "Add Your First Custom Filter",
    "job.columns.required": "Must have at least one column.",
    "personal.hint": "all non-common distributions",
    "specific.item": "Specific item",


    //Searching Admin screens
    "type.lower": "type",
    "searches.name.unique": "Name must be unique across searches and HSM policies.",
    "searches.desc": "Add a new document search or select an existing one to view its properties, edit, assign access to groups, or delete.",
    "searches.list": "Search List",
    "searches.snapshot": "Search Snapshot",
    "searches.type": "Search type",
    "searches.edit": "Editing {0} search",
    "searches.add": "Adding new {0} Search",
    "searches.form": "Displayed form",
    "searches.form.off": "Turn displayed form on to choose a form that will display along with your results, when the search is run. Use this to display additional information that is not easily shown through document metadata in the search result columns, or that is common among all search results.",
    "value.passed": "Value passed",
    "control.name": "Entry control name",
    "input.hidden": "hidden input",
    "hidden": "hidden",
    "conditional.property": "conditional",
    "conditional.required": "Conditionally Required",
    "conditional.enabled": "Conditionally Enabled",
    "conditional.visible": "Conditionally Visible",
    "allowed": "allowed",
    "notAllowed": "not allowed",
    "multi.select": "allow multiple selection",
    "searches.indexing.off": "Turn on indexing for the Checklist Search, to allow Checklist Searches to be saved with prompt values, as Checklist documents. Needed to use Checklist Searches in BPM with hold nodes.",
    "searches.checklist.criteria": "Sub-searches",
    "searches.checklist.criteria.add": "Add Sub-search",
    "searches.checklist.criteria.addFirst": "Add Your First Sub-search",
    "searches.checklist.subsearch.required": "Should at least one result be required for this sub-search to be released from hold if configured to do so?",
    "searches.checklist.subsearch.name.invalid": "Name can be any combination of letters, numbers, spaces and dashes.",
    "prompts": "Prompts",
    "promptsWithModelName": "{0} Prompts",
    "prompts.addFirst": "Add Your First Prompt",
    "prompt.lookuplist": "lookup list prompt",
    "prompt.value.lookuplist": "Use lookup list",
    "prompt.lookuplist.type": "Lookup Type",
    "prompt.text": "text field prompt",
    "prompt.delete.checklist": "This prompt was used in sub-search criteria parameters and indexing metadata. The corresponding items have also been deleted or cleared.",
    "prompt.delete.subSearch.param": "This prompt was used in sub-search criteria parameters. The corresponding sub-search and criteria parameters have also been deleted.",
    "prompt.delete.subSearch.mdo": "This prompt was used in a sub-search criteria parameter and an indexing metadata. The corresponding sub-search has been deleted and metadata configuration has been cleared.",
    "prompt.delete.subSearch": "This prompt was used in a sub-search criteria parameter. The corresponding sub-search has also been deleted.",
    "prompt.delete.param.mdo": "This prompt was used in a sub-search criteria parameter and an indexing metadata. The corresponding items have also been deleted or cleared.",
    "prompt.delete.param": "This prompt was used in a sub-search criteria parameter. The corresponding sub-search criteria parameter has also been deleted.",
    "prompt.delete.mdo": "This prompt was used in an indexing metadata. The corresponding metadata configuration has been cleared.",
    "prompt.delete.criteria": "This prompt was used in a criteria parameter. The corresponding criteria parameter has also been deleted.",
    "searches.prompts.hidden.override": "URL API input should override datasource",
    "category.default": "Default Category",
    "docType.default": "Default Document Type",
    "docTypes.filter": "Filter Document Types by",
    "metadata.filter": "Filter metadata by",
    "metadata.select": "Type a metadata...",
    "input.typed": "Use typed input",
    "target": "Target",
    "ocr": "OCR",
    "enterprise.search.source": "Enterprise Search Source",
    "dynamic.extraction": "Dynamic Extraction",
    "attribute.doc": "Document attribute",
    "attribute.file": "File attribute",
    "datasource.static": "static datasource",
    "datasource.result.empty": "The datasource ran successfully, but did not return a value.",
    "searches.results": "Displayed Results",
    "searches.results.columns": "Output columns",
    "searches.results.linked": "Linked Output column",
    "searches.results.linked.sql": "SQL Linked Output Column",
    "searches.results.linked.rest": "REST Linked Output Column",
    "searches.tree": "Tree Hierarchy",
    "searches.tree.addFirst": "Add Your First Tree Filter",
    "criteria": "Criteria",
    "criteria.add": "Add Criteria",
    "criteria.addFirst": "Add Your First Criteria Parameter",
    "sql.prompt": "Enter SQL...",
    "add.parameter": "Add parameter",
    "paren.adding": "Adding ()",
    "paren.removing": "Removing ()",
    "paren.incomplete": "Please complete the parenthesis before saving.",
    "sort.order": "Sort order",
    "sort.label": "Default Sort Label",
    "default.sort": "Default Sort",
    "sort.default.desc": "If a sort order is not specified, the default sort order will be based on the primary result column.",
    "sorts.orders": "Sort orders",
    "sort.display": "{0} ({1})",
    "storedProc.inputs": "Stored procedure inputs",
    "searches.results.addFirst": "Add Your First Result Column",
    "indexed.by": "Indexed by",
    "indexed.date": "Indexed date",
    "viewed.last": "Last viewed",
    "file.size": "File size",
    "sortOrder.addFirst": "Add Your First Sort Order",
    "sortOrder.type": "Sort item type",
    "sortOrder.name": "Sort item name",
    "sortOrder.method": "Sort method",
    "view.sql": "View SQL",
    "stored.procedure.inOutWarning": "This IN/OUT parameter will be treated as an input parameter.",
    "or.this.criteria.warning": "Picking OR as a connective method might compromise the search performance.",
    "or.any.criteria.warning": "Having an OR connective parameter in the search criteria might compromise the search performance.",

    //admin process screen
    "bpm.admin.name": "Process Management",
    "bpm.admin.desc": "View all Process Models and the number of instances currently running. Select a Process Model to manage it.",
    "bpm.admin.versions.desc": "View all versions of this Process Model and their status. Select a version to manage its instances.",
    "admin.processModels.none": "There are no process models in the system.",
    "admin.processModels.importFirst": "Import Your First Process Model",
    "process.versions.none": "No versions of the process currently exist.  The working copy must be activated to create one.",
    "process.model.delete": "Delete process model",
    "admin.processModels.deletePrevented": "Process model can't be deleted while the working copy is checked out.",
    "processModel.status.changed": "Process model status successfully updated.",
    "processModel.checkIn.confirm": "Are you sure you want to check in this process model? This could cause another user's unsaved changes to be lost.",
    "admin.processInstances.desc": "View the instances of this Process Model. Select an instance to manage it.",
    "process.instances": "Process Instances",
    "process.model.versions": "Process Model Versions",
    "versions.name": "{0} Versions",
    "versions.instances.name": "Version {0} Instances",
    "instance.details": "Instance Details",
    "process.instances.none": "This process model version does not have any process instances.",
    "process.jobView": "Process/Job View",
    "processInstance.skipDelete": "Some selected process instances have parents and so will not be deleted. ",
    "processInstance.slowDelete": "Deleting this many process instances at once can take a while. ",
    "processInstance.confirmDelete": "Are you sure you want to delete {0} instances?",
    "specific.process.instance": "{0}: Instance {1}",
    "specific.process.instance.completed": "{0}: Instance {1} (Completed)",
    "process.instances.title": "{0} (Version {1}, {2})",
    "specific.process.instance.desc": "View details about this instance. If necessary, edit variable values or move the process forward from a current point of execution.",
    "current.points": "Current Points of Execution",
    "view.child.instance": "View Child Instance",
    "view.parent.instance": "View Parent Instance",
    "view.subprocess": "View Subprocess",
    "edit.variable": "Edit Variable",
    "instances.started": "Process instances started successfully.",
    "delete.unused.versions": "Delete Unused Versions",
    "delete.unused.versions.confirm": "This will delete all inactive versions that have no current process instances.  Are you sure?",
    "confirm.deactivate": "This process model is in use. Are you sure you want to deactivate it?",
    "confirm.deactivate.title": "Confirm Deactivate",
    "deactivate": "Deactivate",
    "job.id": "Job ID",
    "distributed.to": "Distributed To",
    "distribution.date": "Distribution Date",
    "bpm.instance.jump": "Find Process Instance",
    "bpm.details.error": "This Process Instance ID does not exist. Please try a different Process Instance ID.",

    "nodeType.START": "Start Node",
    "nodeType.USER": "User Node",
    "nodeType.SERVER": "Server Node",
    "nodeType.HOLD": "Hold Node",
    "nodeType.DECISION": "Decision Node",
    "nodeType.FORK": "Fork Node",
    "nodeType.JOIN": "Join Node",
    "nodeType.END": "End Node",
    "nodeType.SUB_PROCESS": "Subprocess Node",
    "nodeType.UNKNOWN": "Unknown node type",

    "Reexecute": "Re-execute",


    //admin Forms screen
    "form.library.desc": "Manage all Form Designs and Form Instances.",
    "form.instance": "Form Instance",
    "form.versionsOf": "Versions of {0}",
    "form.instancesOf": "Instances of version {0}",
    "activate.working": "Activate Working Copy",
    "activate.working.confirm": "Are you sure? This will create a new, active version and deactivate any currently active version.",
    "activate.confirm.title": "Confirm Activation",
    "instances": "Instances",
    "activate": "Activate",
    "activated": "Activated",
    "item.version.conditional.-1": "Working Copy",
    "form.checkIn.confirm": "Are you sure you want to check in this form? This could cause another user's unsaved changes to be lost.",
    "item.version": "Version {0}",
    "item.version.active": "Version {0} (Active)",
    "checked.out.by": "Checked Out By",
    "checked.out.by.who": "Currently checked out by {0}",
    "form.versions.none": "No versions of the form currently exist.  The working copy must be activated to create one.",
    "form.delete": "Delete form",
    "form.delete.capital": "Delete Form",
    "export.version.conditional.-1": "Export Working Copy",
    "export.version": "Export version {0}",
    "form.view": "View form",
    "share": "Share",
    "created.date": "Created Date",
    "created.by": "Created By",
    "last.edited.by": "Last Edited By",
    "after": "From",
    "after.label": "After",
    "before": "To",
    "form.instance.delete": "Are you sure you want to delete {0} instances of {1} form?",
    "form.instance.delete.conditional.1": "Are you sure want to delete an instance of {1} form?",
    "form.edit": "Edit Form",
    "form.instances.none": "There are no instances of this form.",
    "form.design": "Form Design",
    "overwrite.working": "Do you want to overwrite the working copy?",
    "admin.forms.deletePrevented": "Form can't be deleted while the working copy is checked out.",
    "admin.forms.none": "There are no forms in the system.",
    "admin.forms.importFirst": "Import Your First Form",
    "form.status.changed": "Form status successfully updated.",
    "form.upload.delete.confirm": "Are you sure you want to delete {0}? This will delete it from DocFinity and remove its association with this form.",
    "form.link.missing": "There was a problem generating the URL associated with the link.",
    "form.new.start": "Start New Form",
    "form.loading": "Loading Form...",
    "form.submitting": "Submitting Form...",
    "form.new.start.confirm": "Starting a new form will discard your current progress. Are you sure you want to start a new form?",
    "form.new": "New Form",
    "form.existing": "Existing Form",
    "form.document": "Form Document",
    "form.external": "External Form",
    "form.type.of": "Type of Form",
    "form.mode.label": "Form Mode",
    "form.version": "Form Version",
    "form.add.value": "Add Form Value",
    "form.fields.none": "No form fields to configure.",
    "form.field": "Form Field",
    "form.field.value": "Field Value",

    "version.range": "{0} - {1}",
    "versions.hidden": "{0} versions",
    "versions.label": "Versions: {0}",
    "versions": "Versions",

    //admin validators
    "admin.validators.addFirst": "Add Your First Validator",
    "admin.validators.grid": "Validator List",
    "admin.validators.snapshot": "Validator Snapshot",
    "admin.validators.intro": "Validators are used to verify appropriate input when applied to various entry controls throughout DocFinity.",
    "admin.validators.unique": "Validator names must be unique.",
    "validators.type.date": "Date Compare",
    "validators.type.decimal": "Decimal Compare",
    "validators.type.mask": "Mask Formatter",
    "validators.type.integer": "Integer Compare",
    "validators.type.regex": "Regular Expression",
    "validators.type.sql": "SQL",
    "validators.type.string": "String Compare",
    "error.level": "Error level",
    "warning": "Warning",
    "admin.validators.message": "Validation Message",
    "admin.validators.regexTest": "Test regular expression",
    "admin.validators.mask": "Mask Format",
    "admin.validators.maskTest": "Test Mask Format",
    "example": "Example",
    "admin.validators.mask.intro": "Enter a mask format to use for validation. The following are valid masks:",
    "admin.validators.mask.escape": "Any other character will equal itself. In order to use a mask character as its literal value, you must escape it using the \\ character",
    "admin.validators.mask.number": "Number",
    "admin.validators.mask.alpha": "Alphabetic Character",
    "admin.validators.mask.alpha.btn": "C or @",
    "admin.validators.mask.upper": "Uppercase Character",
    "admin.validators.mask.lower": "Lowercase Character",
    "admin.validators.mask.any": "Any character or number",
    "admin.validators.mask.wild": "Anything",
    "admin.validators.mask.wild.btn": "? or *",
    "admin.validators.sql.valid": "When value exists in column",
    "admin.validators.sql.exists": "Valid",
    "admin.validators.sql.notExists": "Invalid",
    "admin.validators.sql.test": "Test SQL Validator",
    "admin.validators.sql.error": "Please make sure necessary fields are valid before testing.",
    "admin.validators.sql.config": "Configuration",
    "admin.validators.sql.simple": "Simple",
    "advanced": "Advanced",
    "basic": "Basic",
    "test": "Test",
    "admin.validators.compareType": "Compare Type",
    "admin.validators.compareValue": "Value to compare",
    "case.sensitive": "Case sensitive",
    "case.insensitive": "Not case sensitive",
    "case.sensitivity": "Case Sensitivity",
    "admin.validators.deleteBlocked": "Validator can't be deleted because it is in use.",
    "admin.validators.whenValid": "When is value valid?",


    // admin datastores
    "admin.datastores.intro": "A datastore allows you to send data from DocFinity to an external database.",
    "admin.datastores.addFirst": "Add Your First Datastore",
    "admin.datastores.unique": "Datastore name must be unique.",
    "admin.datastores.grid": "Datastore List",
    "admin.datastores.snapshot": "Datastore Snapshot",
    "admin.datastores.deleteMessage": "Datastore cannot be deleted because it is in use.",
    "admin.datastores.dbconn": "Database Connection",
    "admin.datastores.dbschema": "Schema",
    "admin.datastores.dbtable": "Table Name",
    "admin.datastores.column": "Column",
    "admin.datastores.insert": "Insert",
    "admin.datastores.where": "Where",
    "admin.datastores.key": "Key",
    "admin.datastores.columns": "Columns",
    "admin.datastores.sql.insert": "Insert SQL",
    "admin.datastores.sql.update": "Update SQL",
    "admin.datastores.no.tables": "no columns selected",
    "admin.datastores.no.columns": "No columns available",
    "admin.datastores.selectone": "One or more columns are required.",
    "database.connection.type": "Database Connection Type",
    "database.connection.configured": "Configured Database Connection",
    "tls": "TLS",

    // admin DB connections
    "admin.dbconn.intro": "Add, delete, or edit the connection settings to other databases.",
    "admin.dbconn.addFirst": "Add Your First Database Connection",
    "admin.dbconn.unique": "Database Connection name must be unique.",
    "admin.dbconn.type": "Database Type",
    "admin.dbconn.urlType": "Database URL",
    "admin.dbconn.standard": "Standard",
    "admin.dbconn.custom": "Custom",
    "admin.dbconn.dbname": "Database Name",
    "admin.dbconn.maxPoolMessage": "Maximum Pool Size must be between Minimum Pool Size and 10000.",
    "admin.dbconn.maxPool": "Maximum Pool Size",
    "admin.dbconn.grid": "Database Connections List",
    "admin.dbconn.snapshot": "Database Connection Snapshot",
    "admin.dbconn.deleteMessage": "Database Connection cannot be deleted because it is in use.",
    "sid": "SID",
    "service.name": "Service Name",
    "connection.method": "Connection Method",

    "admin.webservices.intro": "Add, delete, or edit the SOAP web services available to use in datasources or BPM.  SOAP web services in DocFinity or for external applications may be configured.",
    "admin.webservices.addFirst": "Add First SOAP Web Service",
    "admin.webservices.grid": "SOAP Web Service List",
    "admin.webservices.snapshot": "SOAP Web Service Snapshot",
    "admin.webservices.deleteMessage": "Web service cannot be deleted because it is in use.",
    "admin.webservices.unique": "Web service name must be unique.",
    "admin.webservices.wsdl": "WSDL",
    "admin.webservices.test": "Test WSDL",
    "admin.webservices.missing.helpless": "You do not have the necessary Feature Rights to add a web service.",

    "admin.featureRights.desc": "Manage the Feature Rights of multiple groups at a time.",
    "admin.featureRights.grid": "Feature Rights List",
    "admin.featureRights.snapshot": "Feature Right Snapshot",
    "admin.featureRights.warning": "Modifying the Feature Rights for this group will not affect any currently logged in users until they log out and log in again.",

    "admin.datasources.desc": "Datasources define sources of data that can be used throughout DocFinity, mainly to populate inputs and display data.",
    "admin.datasources.grid": "Datasource List",
    "admin.datasources.snapshot": "Datasource Snapshot",
    "admin.datasources.addFirst": "Add Your First Datasource",
    "admin.datasources.unique": "Datasource name must be unique.",
    "admin.datasources.type": "Datasource type",
    "admin.datasources.test": "Test Datasource",
    "admin.datasources.deleteMessage": "Datasource cannot be deleted because it is in use.",
    "admin.datasources.macro.macroString": "Macro string",
    "admin.datasources.indexing": "Indexing field",
    "admin.datasources.editable": "Editable",
    "admin.datasources.nonEditable": "Non-editable",
    "admin.datasources.sql.query": "SQL Query",
    "admin.datasources.indexintegration.plugin": "Plugin name",
    "admin.datasources.indexintegration.notRunning": "Could not connect to DocFinity Desktop. Please ensure it is running.",
    "admin.datasources.staticstring.values": "String Values",
    "admin.datasources.staticstring.id": " Reference ID",
    "admin.datasources.staticstring.required": "You must configure at least one Label or Reference ID.",
    "admin.datasources.staticstring.required.single": "You must configure a Label if you only have 1 item.",
    "admin.datasources.webservice.webservice": "SOAP web service",
    "admin.datasources.webservice.method": "Method",
    "admin.datasources.webservice.output": "Output",
    "output.format": "Output format",
    "admin.datasources.webservice.output.none": "The selected method does not return data.",
    "admin.datasources.webservice.input.unsupported": "The selected method requires input that is not supported by DocFinity.",
    "admin.datasources.webservice.service.invalid": "Unable to connect to the selected web service.",
    "admin.datasources.coreDB": "DocFinity Core Database Connection",
    "admin.datasources.usage": "Usage",
    "admin.datasources.usage.single": "For use in a text field or drop-down list",
    "admin.datasources.usage.multiple": "For use in an eForm table or Dashboards chart",
    "admin.datasources.usage.single.toggle": "Single Column",
    "admin.datasources.usage.multiple.toggle": "Multiple Columns",
    "admin.datasources.usage.linked.output": "For use in a search result linked output column",
    "admin.datasources.usage.multiple.fields": "For use in multiple text fields and drop-down lists",
    "admin.datasources.test.noResults": "The datasource ran successfully, but did not return any results.",
    "admin.datasources.storedProcedure.paramsDirty": "One or more parameters in the stored procedure have been updated. Please save this datasource for the changes to take effect in DocFinity.",
    "admin.datasources.rest.headers.df": "Headers are automatically configured for DocFinity Web Services.",
    "admin.datasources.test.linked.output.trim": "If this result set is large, DocFinity could trim the results to prevent impact on performance.",
    "universal.web.service": "Universal Web Service",
    "aws.web.service": "AWS Web Service",
    "Service": "Service",
    "Region": "Region",
    "Access.Key.ID": "Access Key ID",
    "Secret.Access.Key": "Secret Access Key",

    "admin.businessSchedule.preamble": "Manage business hours and holidays for your company.  Both can be applied to calculating Business Process due dates.",
    "admin.businessSchedule.hours": "Business Hours",
    "admin.businessSchedule.greaterThan": "Close time must be after open time",
    "admin.businessSchedule.holidays": "Holidays",
    "admin.businessSchedule.holiday.month": "Month",
    "admin.businessSchedule.holiday.agenda": "Agenda",
    "admin.businessSchedule.holiday.add": "Add Holiday",
    "admin.businessSchedule.holiday.add.first": "Add Your First Holiday",
    "admin.businessSchedule.holiday.edit.title": "Add a Holiday",
    "admin.businessSchedule.holiday.edit.name": "Holiday Name",
    "admin.businessSchedule.holiday.edit.start": "Start Date",
    "admin.businessSchedule.holiday.edit.end": "End Date",
    "admin.businessSchedule.holiday.edit.end.compare": "End date should be greater than or equal to the start date",

    "admin.deletedDocuments.desc": "Restore or purge documents that have been deleted by users.",
    "admin.deletedDocuments.none": "There are no deleted documents in the system.",
    "purge": "Purge",
    "admin.deletedDocuments.purge.confirm": "Are you sure you want to permanently delete {0}?",
    "admin.deletedDocuments.purge.confirm.title": "Purge Confirmation",
    "display.value": "Display Value",
    "admin.deletedDocuments.deletedBy": "Deleted by",
    "admin.deletedDocuments.dateDeleted": "Date deleted",
    "admin.deletedDocuments.purge.success": "{0} Documents were successfully purged.",
    "admin.deletedDocuments.purge.success.conditional.1": "{0} Document was successfully purged.",
    "admin.deletedDocuments.purge.async": "{0} documents were successfully submitted for purging. When it is completed, you will receive a message through My Desktop in Workspaces.",
    "admin.deletedDocuments.purge.async.conditional.1": "{0} document was successfully submitted for purging. When it is completed, you will receive a message through My Desktop in Workspaces.",
    "admin.deletedDocuments.restore.success": "{0} Documents were successfully restored.",
    "admin.deletedDocuments.restore.success.conditional.1": "{0} Document was successfully restored.",

    "admin.hsm.preamble": "HSM Policies help manage storage space.  Define which files or data to copy, move or purge; preview the file set; and schedule when to run each policy.",
    "admin.hsm.addFirst": "Add Your First HSM Policy",
    "admin.hsm.general": "HSM Policy Snapshot",
    "admin.hsm.rules": "Rules",
    "admin.hsm.sorts": "Sort Order",
    "admin.hsm.schedule": "Schedule",
    "admin.hsm.preview": "Preview Results",
    "admin.hsm.preview.total": "Total Results: {0}",
    "admin.hsm.preview.hasMore": "More results not displayed",
    "admin.hsm.processModel": "Start Business Process",
    "admin.hsm.unique": "HSM Policy names must be unique.",
    "admin.hsm.var": "Document variable",
    "admin.hsm.var.prompt": "Enter a document variable...",
    "admin.hsm.var.name": "Document variable name",
    "admin.hsm.var.value": "Document variable value",
    "admin.hsm.sched.editorTitle": "Add a scheduled execution",
    "admin.hsm.sched.addButton": "Add scheduled execution",
    "admin.hsm.sched.listTitle": "Scheduled Executions",
    "admin.hsm.sched.empty": "No scheduled executions have been configured.",
    "admin.hsm.sched.enable": "The scheduler is:",
    "admin.hsm.sched.enabled": "The scheduler is enabled.",
    "admin.hsm.sched.disabled": "The scheduler is disabled.",
    "admin.hsm.sort.none": "No sorts configured",
    "hsm.processInvalid": "The currently configured Process Model is not valid",
    "hsm.preview.count": "Total count of audits: {0}",
    "hsm.none": "There are no HSM policies in the system.",

    "admin.importers.desc": "Configure importers to automatically capture documents.",
    "admin.importers.addFirst": "Add Your First Importer",
    "admin.importers.missing.helpless": "You do not have the necessary Feature Rights to add an importer.",
    "admin.importers.grid": "Importer List",
    "admin.importers.snapshot": "Importer Snapshot - {0}",
    "admin.importers.new": "Adding new {0} Importer",
    "admin.importers.existing": "Editing {0} importer",
    "admin.importers.unique": "Importer name must be unique.",
    "admin.importers.add": "{0} Importer",
    "fields.fix.invalid": "Please fix invalid fields.",
    "admin.importers.save.invalid": "Please fix invalid fields before saving.",
    "admin.importers.delete.disabled": "You cannot delete a default importer.",
    "admin.importers.start.disabled": "You cannot start a default importer.",
    "admin.importers.object": "Object",
    "admin.importers.index": "Index",
    "index.context": "Index - {0}",
    "admin.importers.cold": "COLD",
    "admin.importers.cloud": "Remote File Transfer",
    "admin.importers.cloud.index": "Remote File Transfer Index",
    "admin.importers.cloud.object": "Remote File Transfer Object",
    "start": "Start",
    "admin.importers.stop": "Stop",
    "admin.importers.polling": "Polling frequency",
    "admin.importers.polling.units": "Polling frequency units",
    "admin.importers.polling.message": "Polling frequency must be at least 5 seconds.",
    "admin.importers.cluster": "Limit to cluster servers",
    "admin.importers.cluster.placeholder": "Select or type a cluster node identifier...",
    "admin.importers.plugin": "Importer plugin",
    "admin.importers.plugin.none": "No importer plugins are configured for your system.",
    "admin.importers.email.whiteList": "White list",
    "admin.importers.email.blackList": "Black list",
    "admin.importers.email.toAddress": "Email address to monitor",
    "admin.importers.email.hostName": "Host name",
    "admin.importers.email.folder": "Folder",
    "admin.importers.email.itemsToImport": "Items to import",
    "admin.importers.email.itemsToImport.message": "message",
    "admin.importers.email.itemsToImport.both": "message and attachments",
    "admin.importers.email.deleteMethod": "Delete method",
    "admin.importers.email.deleteMethod.onImport": "on import",
    "admin.importers.email.deleteMethod.always": "always",
    "admin.importers.email.deleteMethod.never": "never",
    "admin.importers.verify.missing": "Missing information in required fields.",
    "admin.importers.serial": "Serial processing",
    "admin.importers.serial.on": "import in order",
    "admin.importers.serial.off": "import quickly",
    "admin.importers.path": "Directory path",
    "admin.importers.path.invalid": "Problem connecting to the directory. Check the path and try again.",
    "admin.importers.fileFilter": "File filter",
    "admin.importers.index.importMethod": "Import method",
    "admin.importers.index.importMethod.move": "move",
    "admin.importers.index.importMethod.inPlace": "in place",
    "admin.importers.index.importMethod.external": "external",
    "admin.importers.index.delimiter": "Delimiter",
    "admin.importers.index.filePathField": "File path field",
    "admin.importers.index.externalRepository": "External repository",
    "admin.importers.calculatedProperties": "Calculated Properties",
    "admin.importers.calculatedProperty": "Calculated Property",
    "admin.importers.indexProperty": "Property",
    "admin.importers.ruleSets": "Rule Sets",
    "admin.importers.ruleSet": "Rule Set",
    "admin.importers.index.properties": "Properties",
    "admin.importers.cold.scripts": "Scripts",
    "admin.importers.status.starting": "Starting",
    "admin.importers.status.stopping": "Stopping",
    "admin.importers.status.processing": "Running - Processing",
    "admin.importers.status.idle": "Running - Idle",
    "admin.importers.snapshot.none": "No {0} have been configured.",
    "admin.importers.snapshot.addFirst": "Add Your First {0}",
    "admin.importers.properties.unique": "Property name must be unique.",
    "admin.importers.property.field": "Field",
    "admin.importers.property.case": "Character case",
    "admin.importers.property.trim": "Trim whitespace",
    "admin.importers.property.trim.on": "Trim",
    "admin.importers.property.trim.off": "Do not trim",
    "character.case.normal": "Normal",
    "character.case.upper": "UPPER",
    "character.case.lower": "lower",
    "admin.importers.ruleSet.documents.all": "create a batch, including all documents",
    "admin.importers.ruleSet.documents.unindexed": "create a batch, including only unindexed documents",
    "admin.importers.ruleSet.documents.bpm": "start a Business Process with each document",
    "batchName": "Batch name",
    "admin.importers.ruleSet.batchAccess": "Batch access",
    "admin.importers.ruleSet.batchAccess.required": "You must assign batch access to at least one group.",
    "admin.importers.ruleSet.batchCount": "Preferred number of documents",
    "admin.importers.ruleSet.processModel.placeholder": "Select a Process Model...",
    "admin.importers.ruleSet.processModel.packageItemName": "Package Item name",
    "admin.importers.ruleSet.processModel.packageItem": "Package Item",
    "admin.importers.ruleSet.processModel.document": "Document",
    "admin.importers.ruleSet.processModel.unmanaged": "Unmanaged Document",
    "admin.importers.ruleSet.processModel.vars": "Process variables",
    "admin.importers.ruleSets.unique": "Rule Set name must be unique.",
    "admin.importers.ruleSets.noDocument": "This importer will not produce a DocFinity Document.",
    "admin.importers.ruleSets.assignment.add": "Add Assignment",
    "admin.importers.ruleSets.condition.add": "Add Condition",
    "admin.importers.conditions": "Conditions",
    "admin.importers.cold.script": "Script",
    "admin.importers.coldScripts.unique": "Script name must be unique.",
    "admin.importers.coldScripts.verify": "Verify",
    "admin.importers.coldScripts.rawFilePath": "Raw File Path",
    "admin.importers.coldScripts.rawFilePath.placeholder": "Enter server relative path...",
    "admin.importers.cold.rawFilePath.required": "Please enter a server relative path.",
    "admin.importers.coldScripts.test": "Test Script",
    "admin.importers.schedule.title": "Importing Scheduler",
    "admin.importers.schedule.invalid": "The scheduler is on, but there are no scheduled imports.",
    "admin.importers.schedule.editorTitle": "Add a scheduled import",
    "admin.importers.schedule.addButton": "Add Scheduled Import",
    "admin.importers.scheduler.list.title": "Scheduled Imports",
    "admin.importers.scheduler.empty": "No scheduled imports have been configured.",
    "admin.importers.ruleSet.condition.calculated.property.deleted": "This calculated property was used in a rule set.  The corresponding rule set has also been removed.",
    "admin.importers.ruleSet.condition.property.deleted": "This property was used in a rule set.  The corresponding rule set has also been removed.",
    "importer.schedule": "Importer Schedule",
    "importers.none": "There are no importers in the system.",
    "exclude.small.images": "Exclude small images",

    "admin.editing.desc": "Cancel documents that are being edited by users.",
    "admin.editing.none": "There are no documents being edited in the system.",
    "admin.editing.cancel": "Cancel Edit",
    "admin.editing.cancel.confirm": "Are you sure you want to cancel edits for {0}?",
    "admin.editing.cancel.confirm.title": "Cancel Edit Confirmation",
    "admin.editing.editedBy": "Edited by",
    "edited": "Edited",
    "date.checkedOut": "Date checked out",
    "admin.editing.cancel.success": "{0} Document Edits were successfully cancelled.",
    "admin.editing.cancel.success.conditional.1": "{0} Document Edit was successfully cancelled.",

    "admin.batches.desc": "Manage existing batches, create new batches from unindexed files, and configure the batch name format.",
    "admin.batches.none": "There are no batches in the system.",
    "admin.batches.unindexed.none": "There are no unindexed files in the system.",
    "admin.batches.unindexed.create": "Create Batch",
    "admin.batches.created": "Date Created",
    "admin.batches.delete.tooltip": "You cannot delete a batch that is checked out.",
    "admin.batches.unindexed": "Unindexed Files",
    "unindexed.prompt": "Unindexed Prompt",
    "admin.batches.naming": "Batch Naming",
    "admin.batches.naming.desc": "Configure the format used when naming batches.",
    "admin.batches.naming.format": "Format for Batch Names:",
    "admin.batches.groups.required": "Batches must have at least one group assigned.",
    "file.name": "File Name",
    "admin.batches.checkIn.message": "Forcibly checking in a batch will prevent the user from saving any indexing data.",
    "admin.batches.create.message": "Your batch has been successfully created.",
    "admin.batches.naming.static.placeholder": "Type static text here...",

    "admin.overlays.intro": "Manage the images used for document overlays.  These overlay images can be used to highlight, mark up or mask off portions of a document.",
    "admin.overlays.addFirst": "Add Your First Overlay",
    "admin.overlays.grid": "Overlays List",
    "admin.overlays.snapshot": "Overlay Snapshot",
    "admin.overlays.deleteMessage": "Overlay cannot be deleted because it is in use.",
    "admin.overlays.unique": "Overlay name must be unique.",
    "file": "File",
    "file.download": "File(s) to download",
    "admin.overlays.file.upload": "Upload file",
    "admin.overlays.dropTarget": "Drop a PNG, JPEG, TIFF, or BMP file here...",
    "admin.overlays.save.tooltip": "An upload operation is pending.",
    "admin.overlays.file.invalid": "Selected file was not a PNG, JPEG, TIFF or BMP file.",

    "main.workspace.title": "Workspaces",
    "workspace": "Workspace",
    "workspace.navigation": "Workspace Navigation",
    "main.workspace.empty": "Open a workspace or panel.",
    "main.workspace.jobAssignments": "Job Assignments",
    "main.workspace.custom.new": "Add Custom",
    "main.workspace.save": "Save Workspace As...",
    "main.workspace.save.title": "Save Workspace As",
    "main.workspace.delete": "Delete Custom Workspace...",
    "main.workspace.delete.title": "Delete Custom Workspace",
    "main.workspace.restore": "Reset to Default Workspaces",
    "main.workspace.restore.confirm": "Restoring default workspaces will remove all custom workspaces, and restore the default workspaces to their default layout.",

    "main.workspace.save.description": "Save the current workspace configuration. This will save the panels, layout, and mode of the Viewer. If you choose a custom workspace, you can give it a meaningful name.",
    "main.workspace.save.rename": "Rename",
    "main.workspace.save.invalid": "Please enter only alphabetic and/or numeric characters.",
    "main.workspace.save.duplicate": "Workspace names must be unique.",

    "main.workspace.delete.description": "Delete a custom workspace.  This will permanently remove it from the workspace menu.  Fields marked with an * are required. ",

    "main.panels.title": "Panels",
    "main.panels.closeAll": "Close all panels",

    "Search": "Search",
    "reset.to.defaults": "Reset to Defaults",
    "result.tree": "Result Tree",
    "filter.documents": "Filter Documents",
    "filter.your.documents": "Filter Your Documents",
    "filter.menu.title": "Show items that {0} {1}",

    "main.searchResults.noRecords": "Search did not match any documents.",
    "main.searchResults.flags": "Flags",
    "main.searchResults.subSearchName": "SubSearch Name",
    "main.searchResults.empty": "Run a search to view results.",
    "checklist.status": "Checklist fulfilled:",
    "fulfilled": "Fulfilled",
    "unfulfilled": "Unfulfilled",
    "pointers.view": "View Pointers",
    "pointers.create": "Create Pointer",
    "bpm.package.add": "Add to Package",
    "bpm.start.popup": "Start Business Process...",
    "bpm.start.iconText": "Start a Process",
    "docs.email": "Email Document(s)...",
    "docs.email.count": "Email {0} Documents...",
    "docs.email.count.conditional.1": "Email Document...",
    "docs.email.count.conditional.0": "Email Documents...",
    "docInfo.view": "View document info",
    "view.info": "View Information",
    "view.info.folder": "View Folder Information",
    "edit.cancel": "Cancel edit",
    "export.docs": "Export documents",
    "export.all.records": "Export All Records",
    "save.doc": "Save document",
    "subSearch.add": "Add sub-search",
    "copyRows": "Copy rows",
    "view.thumbs": "View thumbnails",
    "view.text": "View text",
    "checklist.addSubSearch": "Add Sub-search to Checklist Document",
    "document.draggable": "Drag Document Handle",
    "dragged.document": "Dragged Document",

    "download.ready.body": "Your requested file is ready to be downloaded.",
    "download.ready.title": "Download Ready",

    "docs.docfinity": "DocFinity Document",
    "docs.print": "Print Document(s)",
    "docs.print.popup": "Print Document(s)...",
    "docs.print.popup.count": "Print {0} Documents...",
    "docs.print.popup.count.conditional.1": "Print Document...",
    "docs.print.popup.count.conditional.0": "Print Documents...",
    "docs.print.iconText": "Print",
    "docs.print.cancelled": "Print - Cancelled",
    "print.desc": "Select printing options. Fields marked with an * are required.",
    "print.printer": "Printer",
    "print.copies": "Number of copies",
    "print.orientation": "Page orientation",
    "orientation.portrait": "portrait",
    "orientation.landscape": "landscape",
    "position": "Positioning",
    "position.center": "center on page",
    "print.cover": "Cover sheet",
    "print.cover.use": "use at the beginning of print job",
    "print.partial": "{0} out of {1} documents cannot be printed. They are either missing the necessary security to print or are not documents.",
    "print.unavailable": "Unable to communicate with the configured print server.",
    "server.printing": "Server printing",
    "local.printing": "Local printing",
    "printing.method": "Printing method",

    "download.export": "Download Export Job",

    "show.thumbnails": "Show Toolbox",
    "hide.thumbnails": "Hide Toolbox",

    "docs.fax.popup": "Fax Document(s)...",
    "docs.fax.popup.count": "Fax {0} Documents...",
    "docs.fax.popup.count.conditional.1": "Fax Document...",
    "docs.fax.popup.count.conditional.0": "Fax Documents...",
    "docs.fax.cancelled": "Fax - Cancelled",
    "docs.export.popup": "Export Document(s)...",
    "docs.export.popup.count": "Export {0} Documents...",
    "docs.export.popup.count.conditional.1": "Export Document...",
    "docs.export.popup.count.conditional.0": "Export Documents...",
    "docs.export.all.popup": "Export All Documents...",
    "docs.export.all.success": "Documents were successfully submitted for exporting.   When it is completed, you will receive a message through My Desktop.",
    "folder.export.success": "{0} folder was successfully submitted for exporting. When it is completed, you will receive a message through My Desktop.",
    "docs.delete": "Delete Document(s)",
    "docs.delete.count": "Delete {0} Documents...",
    "docs.delete.count.conditional.1": "Delete Document...",
    "docs.delete.count.conditional.0": "Delete Documents...",
    "doc.delete": "Delete Document",
    "docs.delete.confirm.conditional.1": "Are you sure you want to delete this document?",
    "docs.delete.confirm": "Are you sure you want to delete these {0} documents?",
    "docs.delete.pointer.confirm": "{1} of {0} documents share their file with other Pointers, which will not be deleted unless they are part of this selection.  Are you sure you want to delete these documents?",
    "docs.delete.pointer.confirm.conditional.1": "This document shares its file with other Pointers, which will not be deleted.  Are you sure you want to delete this document?",
    "docs.download": "Download {0} Documents",
    "docs.download.conditional.1": "Download Document",
    "docs.download.conditional.0": "Download Documents",
    "doc.replace": "Replace Document...",
    "doc.replace.df": "Replace DocFinity Document",
    "doc.edit.multiple": "Edit Document(s)",
    "doc.edit.multiple.count": "Edit {0} Documents",
    "doc.edit.multiple.count.conditional.1": "Edit Document",
    "doc.edit.multiple.count.conditional.0": "Edit Documents",
    "search.saveAsDoc": "Save Search as Document",
    "search.addSubSearch": "Add Sub-search...",
    "search.placeOnLegalHold": "Place on Legal Hold...",
    "place.on.legal.hold": "Place on Legal Hold",
    "search.placeOnLegalHold.count": "Place {0} Documents on Legal Hold...",
    "search.placeOnLegalHold.count.conditional.1": "Place Document on Legal Hold...",
    "search.placeOnLegalHold.count.conditional.0": "Place Documents on Legal Hold...",
    "search.placeOnLegalHold.all": "Place All Records on Legal Hold...",
    "search.releaseLegalHold": "Release Legal Hold...",
    "folder.releaseLegalHold": "Release Folder from Legal Hold...",
    "search.releaseLegalHold.count": "Release {0} Documents from Legal Hold...",
    "search.releaseLegalHold.count.conditional.1": "Release Document from Legal Hold...",
    "search.releaseLegalHold.count.conditional.0": "Release Documents from Legal Hold...",
    "search.saveAsDoc.success": "Search has been saved as a document with file type 'Checklist'.",
    "copy.rows": "Copy All Rows",
    "copy.rows.success": "All displayed rows copied to clipboard.",
    "export.rows": "Export Results to Spreadsheet",
    "export.spreadsheet.all": "Export All Records to Spreadsheet",
    "export.spreadsheet.warning": "This file may contain sensitive information. By exporting this file, you will be fully responsible for the information in the file and purging the file when your work is done. The file will be available to download for only 24 hours in the My Desktop panel.",
    "export.rows.success": "These results have been sent to the server for processing; when it is finished, you will receive a user message, listed in the My Desktop panel.",
    "refresh.results": "Refresh Results",
    "results.details": "Display as Details",
    "results.thumbs": "Display as Thumbnails",
    "results.fullText": "Display as Text",
    "results.noColumns": "No columns defined for this search. Please enable the file type search preference or switch to thumbnail view to see documents.",
    "refresh.preview": "Refresh Preview",

    "existing.document.id": "Existing Document ID",
    "file.path": "File path",
    "replacement.file.path": "Replacement File Path",
    "replacement.document.id": "Replacement Document ID",
    "replace.with": "Replace with",

    "folder.legalHold.success": "Folder successfully placed on legal hold.",
    "folder.export.menu": "Export Folder...",
    "folder.export": "Export Folder",
    "folder.export.includeDocs": "Include documents' notes in the exported PDF",

    "copy.document.links.count": "Copy {0} Document Links",
    "copy.document.links.count.conditional.1": "Copy Document Link",
    "copy.document.links.count.conditional.0": "Copy Document Links",
    "copy.document.links.success": "Document links successfully copied.",
    "outlook.clip.history": "Clipboard - Add",

    "upload.index": "Upload and Index Files",
    "upload.quick.close.confirm": "Your work will be lost if you close. Do you want to continue?",
    "upload.quick.success.notify": "{0} documents were committed successfully.",
    "upload.quick.success.notify.conditional.1": "{0} document was committed successfully.",
    "upload.success.notify": "{0} documents were uploaded successfully.",
    "upload.success.notify.conditional.1": "{0} document was uploaded successfully.",
    "index.files": "Index Files",
    "object.files": "Object Files",
    "index.quick.desc": "Add files by browsing or dragging and dropping them. Then, add indexing information to the files. Committing the files will make them searchable in DocFinity.",
    "index.reindex": "Re-index",
    "index.save.success": "The indexing for documents in your batch is successfully saved.",
    "reindex.doc.count": "Re-index {0} Documents",
    "reindex.doc.count.conditional.1": "Re-index Document",
    "reindex.doc.count.conditional.0": "Re-index Documents",
    "index.doc": "Index Document",
    "reindex.folder": "Re-index Folder",
    "reindex.folder.desc": "Re-Index the folder and its contents by changing the value below.",
    "reindex.folder.success": "Re-indexing {0} folder and its contents is in progress. Once it is done, you will receive a message in My Desktop.",
    "reindex.header": "Re-Indexing",
    "reindex.admin.allow": "Allow Re-Indexing",
    "reindex.success": "The document is successfully re-indexed.",
    "reindex.bulk": "Bulk Re-index",
    "reindex.bulk.desc": "Select the metadata that you want to change their values and then edit and save the new metadata values for all the selected documents. Metadata that are not displayed for re-indexing will keep their initial value. Fields marked with an * are required.",
    "reindex.bulk.confirm": "This action will Re-index {0} documents with the new value changes.",
    "reindex.bulk.success": "Documents were successfully re-indexed.",

    "required.message": "Fields marked with an * are required.",

    "main.panel.tooltip": "Panel Menu",
    "menu": "Menu",
    "menu.contextual": "{0} Menu",

    "main.viewer.title": "Viewer",
    "main.viewer.title.editing": "Viewer - Editing",
    "main.viewer.title.specific": "Viewer - {1} - page {0}",
    "main.viewer.title.specific.conditional.0": "Viewer - {1}",
    "main.viewer.title.specific.version": "Viewer - {1} - page {0} - version {2}",
    "main.viewer.title.specific.version.conditional.0": "Viewer - {1} - version {2}",
    "main.viewer.deleted": "{0} [deleted]",
    "main.viewer.readonly": "{0} [read-only]",
    "doc.view": "View Document",
    "viewer.view.form.error": "The viewer can't be used to view a form document.",
    "viewer.view.checklist.error": "The viewer can't be used to view a checklist document.",
    "viewer.view.unsupported.error": "The document is not supported by the Viewer.",
    "viewer.view.error": "The document can't be viewed.",
    "viewer.view.internal.error": "Cannot view checklists or forms at a specified version.",
    "viewer.view.permission.error": "You do not have permission to view this document.",
    "viewer.view.pendingEditing.error": "This document has pending edits that are currently processing.",
    "viewer.view.previousRedactedVersion": "The document you are trying to view has redactions on the latest version. You cannot view previous versions without permission to override redactions.",
    "viewer.view.original.dpi": "View Document at Highest Quality",
    "viewer.view.original.dpi.caution": "This will change the rendering of the document to a different resolution and may cause shifting of markup and redactions. Are you sure you want to continue?",
    "viewer.view.original.dpi.caution.unsaved": "This will change the rendering of the document to a different resolution and may cause shifting of markup and redactions. Additionally, your unsaved changes to markup will be lost. Are you sure you want to continue?",
    "open.duplicate": "Open a Duplicate",
    "open.doc.duplicate": "Open Document as Duplicate",
    "open.as.pdf": "Open as PDF",
    "open.doc.as.pdf": "Open Document as PDF",
    "open.in.native": "Open in Native Application",
    "Thumbnails": "Thumbnails",
    "match.case": "match case",
    "result": "Result",
    "Results": "Results",
    "Markup.Styles": "Markup Styles",
    "Font.size": "Font size",
    "Font.style": "Font style",
    "text.style": "Text style",
    "font.family": "Font family",
    "bold": "bold",
    "italic": "italic",
    "px": "{0} px",
    "Font.color": "Font color",
    "Fill.color": "Fill color",
    "Line.color": "Line color",
    "Opacity": "Opacity",
    "opacity.adjust": "Adjust Opacity",
    "dashed": "dashed",
    "Line.thickness": "Line thickness",
    "inline.failure.start": "Your browser does not support viewing this file in DocFinity. Please choose a different browser or ",
    "inline.failure.link": "download the file",

    "delete.page.confirm": "Are you sure that you want to delete the selected pages?",

    "main.notes.open": "Open Notes",
    "main.docInfo.dirty": "You are currently adding a note and have not saved it. Do you want to save or discard your note?",
    "editedBy": "edited by",

    "main.documentInformation.title": "Information",
    "main.documentInformation.title.specific": "Information - {0}",
    "main.documentInformation.details": "Document Details",
    "doc.info.view": "View Document Information",
    "main.documentInformation.metadata.panelBar": "Details{0}",
    "main.documentInformation": "",
    "main.documentInformation.noViewSecurity": "You do not have permission to view this document's information.",
    "main.documentInformation.created": "Created",
    "main.documentInformation.markupCreated": "created",
    "main.documentInformation.markupUpdated": "updated",
    "main.documentInformation.create.printTo": "Created - PrintTo",
    "main.documentInformation.create.sendTo": "Created - SendTo",
    "main.documentInformation.create.scanTo": "Created - ScanTo",
    "main.documentInformation.create.scan": "Created - Scan",
    "main.documentInformation.create.import": "Created - Import",
    "main.documentInformation.create.bpm": "Created - BPM",
    "main.documentInformation.create.office": "Created - Office",
    "main.documentInformation.create.form": "Created - Form",
    "main.documentInformation.create.form.upload": "Created - Form Upload",
    "main.documentInformation.create.checklist": "Created - Checklist",
    "main.documentInformation.create.editing": "Created - From editing parent",
    "main.documentInformation.hsm.copy": "HSM - Copy",
    "main.documentInformation.hsm.move": "HSM - Move",
    "main.documentInformation.retention.override": "Retention policy - Override",
    "main.documentInformation.retention.override.cancel": "Retention policy - Cancel override",
    "main.documentInformation.viewer.pageRotation": "Page rotated",
    "main.documentInformation.redaction.created": "Redaction - Created",
    "main.documentInformation.redaction.updated": "Redaction - Updated",
    "main.documentInformation.redaction.deleted": "Redaction - Deleted",

    "main.documentInformation.arrow.created": "Markup - Arrow created",
    "main.documentInformation.ellipse.created": "Markup - Ellipse created",
    "main.documentInformation.footnote.created": "Markup - Footnote created",
    "main.documentInformation.freehand.created": "Markup - Freehand created",
    "main.documentInformation.highlight.created": "Markup - Highlight created",
    "main.documentInformation.line.created": "Markup - Line created",
    "main.documentInformation.rectangle.created": "Markup - Rectangle created",
    "main.documentInformation.stamp.created": "Markup - Stamp created",
    "main.documentInformation.text.created": "Markup - Text created",

    "main.documentInformation.arrow.updated": "Markup - Arrow updated",
    "main.documentInformation.ellipse.updated": "Markup - Ellipse updated",
    "main.documentInformation.footnote.updated": "Markup - Footnote updated",
    "main.documentInformation.freehand.updated": "Markup - Freehand updated",
    "main.documentInformation.highlight.updated": "Markup - Highlight updated",
    "main.documentInformation.line.updated": "Markup - Line updated",
    "main.documentInformation.rectangle.updated": "Markup - Rectangle updated",
    "main.documentInformation.stamp.updated": "Markup - Stamp updated",
    "main.documentInformation.text.updated": "Markup - Text updated",

    "main.documentInformation.arrow.deleted": "Markup - Arrow deleted",
    "main.documentInformation.ellipse.deleted": "Markup - Ellipse deleted",
    "main.documentInformation.footnote.deleted": "Markup - Footnote deleted",
    "main.documentInformation.freehand.deleted": "Markup - Freehand deleted",
    "main.documentInformation.highlight.deleted": "Markup - Highlight deleted",
    "main.documentInformation.line.deleted": "Markup - Line deleted",
    "main.documentInformation.rectangle.deleted": "Markup - Rectangle deleted",
    "main.documentInformation.stamp.deleted": "Markup - Stamp deleted",
    "main.documentInformation.text.deleted": "Markup - Text deleted",
    "main.documentInformation.checklist.executed": "Checklist Search Execution",

    "main.forms.title": "Forms",
    "main.forms.title.specific": "{0} - Forms",
    "main.forms.close.unsaved": "There are unsaved changes in this form. Do you want to save or discard your changes?",
    "main.forms.openDoc.unsaved": "You are currently editing a different form. Before loading this form document, do you want to save or discard your changes?",
    "main.forms.openForm.unsaved": "You are currently editing a different form. Before loading this form, do you want to save or discard your changes?",
    "main.forms.submit": "Submit",
    "main.forms.saved": "Saved Forms",
    "main.forms.new": "New Forms",
    "main.forms.none": "No available forms.",
    "main.forms.delete.confirm": "Are you sure you want to delete the form: {0}, last modified on {1}?",
    "date.modified": "Date Last Modified",
    "view.form": "View Form",
    "close.form": "Close Form",
    "save.form": "Save Form",
    "save.progress": "Save Progress",
    "saving.progress": "Saving Progress...",
    "save.progress.done": "Progress saved.",
    "form.saveOtherUser.error": "Another user has made changes to this form. Please close the form and try again.",

    "main.jobs.title": "Jobs",
    "main.jobs.titleWithName": "Jobs: {0}",
    "main.jobs.completed": "Jobs completed by {0} since login: {1}",
    "main.jobs.queue.title": "Job Queue",
    "main.jobs.queue.title.workable": "Job Queue - Workable",
    "main.jobs.queue.title.releasable": "Job Queue - Releasable",
    "main.jobs.queue.description": "Run a Job View to see the Job Queue.",
    "main.jobs.queue.empty": "No jobs available",
    "main.jobs.checkOut": "Check Out Job",
    "main.jobs.checkOut.inUse": "This job is already checked out by another user. Would you like to browse it in read-only mode?",
    "main.jobs.complete": "Complete Job",
    "main.jobs.return": "Return Job",
    "main.jobs.release": "Release Hold",
    "main.jobs.release.prompt": "Are you sure you want to release pending job?",
    "main.jobs.setPriority": "Set Job Priority...",
    "main.jobs.redistribute": "Redistribute Job",
    "main.jobs.redistribute.prompt": "Redistributing may remove job(s) from this queue. Would you like to continue?",
    "main.jobs.redistribute.action": "Redistribute",
    "main.jobs.redistribute.inUse": "This job is currently in use. Please clear current user before attempting to redistribute job.",
    "main.jobs.redistribute.success": "Job(s) were successfully redistributed.",
    "main.jobs.move": "Move Job...",
    "main.jobs.moveDialog.title": "Move Job",
    "main.jobs.moveDialog.assignTo": "Assign job to a:",
    "main.jobs.moveDialog.groupGrid": "Group:",
    "main.jobs.moveDialog.userGrid": "User:",
    "main.jobs.clearUser": "Clear Current User",
    "main.jobs.clearUser.prompt": "Would you like to clear the current user, which will discard any unsaved changes and return the job(s)?",
    "main.jobs.deleteProcessInstance": "Delete Process Instance",
    "main.jobs.deleteProcessInstance.prompt": "Are you sure you want to delete {0} jobs from process instance {1}?",
    "main.jobs.user": "{0} ({1} {2})",
    "main.jobs.priorityDialog.title": "Set Job Priority",
    "main.jobs.priorityDialog.success": "Job priority was changed successfully.",
    "main.jobs.priorityDialog.desc": "Job Priority:",
    "main.jobs.clearUser.success": "Current user has been cleared.",
    "main.jobs.noneAvailable": "There are no available jobs at this time. Please refresh shortly for updated results.",
    "main.jobs.moved.successful": "Job(s) were successfully moved.",
    "main.jobs.move.toGroup": "Move this job by reassigning it to a different group.",
    "main.jobs.move.toUser": "Move this job by reassigning it to a different user. ",
    "main.jobs.tasks.title": "Tasks",
    "main.jobs.tasks.preamble": "Work through the tasks for this job. When all required tasks (*) are complete, the job can be completed; otherwise, you can return the job.",
    "main.jobs.tasks.complete": "Complete",
    "main.jobs.tasks.complete.checked": "Checked, press enter to run",
    "main.jobs.tasks.complete.unchecked": "Unchecked, press enter to run",
    "main.jobs.tasks.description": "Task description",
    "main.jobs.tasks.empty": "No tasks available",
    "main.jobs.tasks.rm.noFR": "One of the following Feature Rights are required for this action: Approve Retention Policies, Records Search.",
    "main.jobs.tasks.reindex.noFR": "You do not have the necessary rights to reindex a document.",
    "main.jobs.tasks.forms.noFR": "You do not have the necessary rights to access forms.",
    "main.jobs.tasks.viewDoc.noFR": "You do not have the necessary rights to view a document.",
    "main.jobs.tasks.notes.noFR": "You do not have the necessary rights to access notes.",
    "main.jobs.tasks.savedSearch.noFR": "You do not have the necessary rights to run a search.",
    "main.jobs.tasks.folder.noFR": "You do not have the necessary rights to access folders.",
    "main.jobs.tasks.quickIndex.noFR": "You do not have the necessary rights to upload and/or index a document.",
    "main.jobs.tasks.savedSearch.cannotRun": "Configured search cannot be viewed.",
    "main.jobs.task.customUser": "Custom User Task",
    "main.jobs.task.dueDate": "Change Job Due Date",
    "main.jobs.task.dueDate.label": "Job due date",
    "main.jobs.task.dueDate.cannotChange": "The due date cannot be changed.",
    "main.jobs.packageItems.description": "Any documents, searches, and files associated with the checked-out job.",
    "main.jobs.packageItems.empty": "No package items available",
    "main.jobs.jobProperties.description": "Job properties and information.",
    "main.jobs.jobProperties.empty": "No job properties available",
    "main.jobs.dueDate.future": "Due date and time cannot be in the past.",
    "main.jobs.emailUnmanaged": "Email as Attachment",
    "main.jobs.email.success": "The document was successfully emailed.",
    "main.jobs.complete.success": "Job was successfully completed.",
    "main.jobs.release.success": "Hold is successfully released.",
    "main.jobs.returned.success": "Job is successfully returned.",

    "main.myDesktop.title": "My Desktop",

    "main.scan.title": "Scan",
    "docfinity.scanning": "DocFinity Scanning",
    "scan.noProfiles": "There are no available Scan Profiles.  An administrator can assign Scan Profiles to you.",
    "desktop.unavailable": "We couldn't connect to DocFinity Desktop. Please check the connection and try again.",

    "main.showIconText": "Show Button Text",

    "scanner.settings": "Scan Settings",
    "scanner.settings.desc": "Configure the scan settings here before scanning documents. Fields marked with an * are required.",
    "scanner.settings.launch": "Scan Settings...",
    "scan.stats": "{0} pages in {1} documents scanned. {2} blank/barcode pages removed.",
    "document.viewer.scanning": "Viewer - Scanning",

    "main.startProcess": "Start Process",
    "main.startProcess.descriptionText": "Select a process model to view its requested package items. Package items are assigned names below before starting a process instance.",
    "main.startProcess.success": "Process Instance started successfully.",
    "main.startProcess.adHocDescription.fromPanel": "Select a process model to start a process instance.",
    "main.startProcess.adHocDescription.fromMain": "Select a process model to start a process instance. To attach folders or documents as package items, access Start Process through a panel.",
    "main.startProcess.continue": "Continue to Prompts",

    "main.jobs.packageItemGrid.header": "Package Items",

    "process.flowing": "Currently flowing in at least 1 BPM process instance",
    "process.allow.start": "Allow Starting a Process",
    "process.action.add": "Add Start Process Action",

    "main.attendance": "Attendance",

    "main.preferences.documentView": "Document View",
    "main.preferences.messages": "Messages",
    "main.preferences.general.descriptionText.title": "Set your preference whether description text displays beneath headings and window titles throughout the application.",
    "main.preferences.general.descriptionText.label": "Display description text",
    "main.preferences.general.wordWrap.title": "Set your preference whether the text should wrap in Searches and Jobs tables.",
    "main.preferences.general.wordWrap.label": "Enable word wrap",
    "main.preferences.general.descriptionText.hotkey": "Set your preference for the key that will start off all hotkey combinations.  Browser must be refreshed for this change to take effect.",
    "main.preferences.general.accessibility.label": "Enable simplified screen reader mode",
    "main.preferences.general.accessibility": "Set your preference to whether features should be simplified to improve screen reader experience.",
    "main.preferences.general.notifications.title": "Set times when notifications are hidden automatically.",
    "main.preferences.general.notifications.success.label": "Length of time success and information notifications should appear:",
    "main.preferences.general.notifications.error.label": "Length of time error notifications should appear:",
    "main.preferences.viewer.title": "Set your preference for the default method used to view documents.",
    "main.preferences.viewer.label": "Open documents in:",
    "main.preferences.viewer.pdf": "PDF Reader",
    "main.preferences.viewer.inline": "Document Viewer",
    "main.preferences.viewer.native": "Native Application",
    "main.preferences.indexing.title": "Set your preference for indexing behaviors.",
    "main.preferences.indexing.moveAfterTab": "Move to the next document after Tab or Enter on last field",
    "main.preferences.indexing.moveAfterSave": "Move to the next document after saving",
    "main.preferences.indexing.retain": "Retain values for Category and Document Type",
    "main.preferences.indexing.saveOnCheckIn": "Save values when checking in a batch",
    "main.preferences.indexing.checkOutOnCommit": "Check out next batch after a batch is committed",
    "main.preferences.indexing.predictTab": "Enable predictive tabbing",
    "main.preferences.indexing.focusOnBatchDocSelect": "Jump to the Index panel after selecting a document in the Batches panel",
    "main.preferences.search.title": "Set whether additional information displays in your results.",
    "main.preferences.search.fileType": "Show file type",
    "main.preferences.search.flags": "Display document flags for:",
    "main.preferences.search.pointer": "pointers",
    "main.preferences.search.notes": "notes",
    "main.preferences.search.editing": "checked-out for editing",
    "main.preferences.search.locked": "locked for editing",
    "main.preferences.messages.title": "Select whether to be notified via email when there are new messages (also displayed in the My Desktop panel).",
    "main.preferences.messages.origin": "Origin",
    "main.preferences.messages.user": "Email new user messages with priority {0}:",
    "main.preferences.messages.server": "Email new server messages with priority {0}:",
    "main.preferences.messages.errorOnly": "only send emails for error level messages",
    "main.preferences.messages.gateway": "send emails for Gateway error reports",
    "main.preferences.messages.info": "Info",

    // main > records management
    "main.rm.search.context": "Search Context",
    "main.rm.disposition.context": "Disposition Queue",
    "main.rm.disposition.context.view": "View Disposition Queue",
    "main.rm.search.no.results": "No results returned.",
    "main.rm.disposition.queue.complete": "Disposition queue review complete. Please ensure that associated tasks / jobs are marked complete.",
    "main.rm.records": "Records",
    "main.rm.records.description": "To view records, choose a search context and optionally enter more criteria based on document properties.",
    "main.rm.filePlan": "File Plan",
    "main.rm.filePlan.description": "Assign Retention Policies or export the File Plan.",
    "main.rm.retentionPlan": "Retention Plan",
    "main.rm.retentionPlan.description": "Retention Policies govern the length of time records are retained, the method of disposition, when the retention period expires, and the custodians who are accountable for the assigned records.",
    "main.rm.retentionPlan.schedule.description": "The disposition schedule sets when all Retention Policies run. At the scheduled time, each Retention Policy identifies records for which its retention period has expired and queues these records for disposition.",
    "main.rm.legalCase": "Legal Case",
    "main.rm.legalCases": "Legal Cases",
    "main.rm.legalCases.description": "Legal Cases are used to relate records; when custodians place relevant records on Legal Hold, they are associated with a Legal Case.",
    "main.rm.close.legal.case.confirm": "Are you sure you want to close this Legal Case? Any records on legal hold will be released upon this case being closed.",
    "main.rm.close.legal.case.special": "There are Legal Holds that need released before being able to close the Legal Case.",
    "main.rm.delete.legal.case.confirm": "Are you sure you want to delete this Legal Case?",
    "main.rm.release.legal.holds.confirm": "Are you sure you want to release all Legal Holds?",
    "rm.load.next.queue.confirm": "The disposition queue you are working on has unsaved changes. Would you like to save changes?",
    "main.rm.doc.legalHold": "Place On Legal Hold",
    "main.rm.legalHold.release.count": "Release {0} Records from Legal Hold",
    "main.rm.legalHold.release.count.conditional.1": "Release Record from Legal Hold",
    "main.rm.legalHold.release.count.conditional.0": "Release Records from Legal Hold",
    "main.rm.legalHold.release": "Release from Legal Hold",
    "main.rm.legalHold.release.all": "Release All Records from Legal Holds",
    "main.rm.legalHold.release.and.close": "Release and close",
    "bad.record.ids": "One or more records have been reindexed by another user and thus removed from this disposition queue.",

    "main.rm.retain": "Retain",
    "main.rm.custodians": "Custodians",
    "main.rm.custodians.unit": "custodians",
    "main.rm.custodians.unit.conditional.1": "custodian",
    "main.rm.document.content": "Document content",
    "main.rm.action.approval": "approval",
    "main.rm.action.approval.plural": "approvals",
    "main.rm.retain.permanent": "permanent",
    "main.rm.retain.permanently": "permanently",
    "main.rm.retain.FILE_CREATED_DATE": "date file created",
    "main.rm.retain.DOCUMENT_CREATED_DATE": "date document created",
    "main.rm.retain.DOCUMENT_INDEXED_DATE": "date indexed",
    "main.rm.retain.DOCUMENT_LAST_VIEWED_DATE": "date last viewed",
    "main.rm.retain.separator": "; ",
    "main.rm.retain.renditions.store": "store renditions",
    "main.rm.retain.renditions.nostore": "do not store renditions",
    "main.rm.retentionPolicy.assign": "Assign Retention Policy",
    "main.rm.retentionPolicy.assign.type": "Assignment Type:",
    "main.rm.retentionPolicy.assign.type.doc.auto": "Inherit from Document Type",
    "main.rm.retentionPolicy.assign.type.folder.auto": "Inherit from Folder Type",
    "main.rm.retentionPolicy.assign.type.override": "Manually Set Retention Policy",
    "rm.assign.retentionPolicy.error": "Retention policy assignment failed with errors.",
    "rm.assign.all.retention.policy": "Assign All Records to a Retention Policy",
    "rm.assign.all.legal.hold": "Place All Records on Legal Hold",
    "main.rm.records.assign": "Records Assignments",
    "main.rm.assign.records": "Assign Records",
    "main.rm.disposition.schedule": "Disposition Schedule",
    "main.rm.renditions": "Renditions",
    "main.rm.renditions.description": "Create PDF/A renditions of records",
    "main.rm.renditions.create": "A background process will immediately start creating renditions",
    "main.rm.renditions.delete": "A background process will immediately start deleting renditions",
    "main.rm.require.approval": "Require approval from",
    "main.rm.approval.process": "Approval process",
    "main.rm.retain.for": "Retain for",
    "main.rm.legalHold.confirm": "Are you sure you want to place {0} records on legal hold?",
    "main.rm.legalHold.confirm.conditional.1": "Are you sure you want to place this record on legal hold?",
    "main.rm.legalHold.confirm.conditional.all": "Are you sure you want to place all records on legal hold?",
    "main.rm.legalHold.confirm.title": "Confirm Legal Hold",
    "main.rm.retain.template": "{0}; {1}",
    "set.disposition.date": "Set Disposition Date",
    "set.disposition.date.launch": "Set Disposition Date...",
    "retain.until": "Retain until",
    "until.when": "Until {0}",
    "rm.approve.disposition": "Approve {0} Records for Disposition",
    "rm.approve.disposition.conditional.1": "Approve 1 Record for Disposition",
    "rm.approve.disposition.conditional.0": "Approve Disposition",
    "rm.postpone.disposition": "Postpone {0} Records from Disposition",
    "rm.postpone.disposition.conditional.1": "Postpone 1 Record from Disposition",
    "rm.postpone.disposition.conditional.0": "Postpone Disposition",
    "rm.commit.review": "Commit Review",
    "rm.commit.review.count": "Commit the review of {0} out of {1} records",
    "rm.return.queue": "Return Queue",
    "rm.approved": "approved",
    "rm.postponed": "postponed",
    "rm.not.reviewed": "not yet reviewed",

    "rm.legal.release.desc": "Select the Legal Case with which this record should no longer be associated.",
    "rm.legal.release.doc.success": "Document(s) successfully released from hold.",
    "rm.legal.release.folder.success": "Folder successfully released from hold.",
    "rm.legal.release.success": "The records were successfully released from legal hold.",
    "rm.legal.release.none": "You must be a custodian of the Legal Case to be able to release these records from legal hold.",
    "rm.legal.add.desc": "Select the Legal Case with which this record should be associated. Records that are on Legal Hold cannot be purged.",
    "rm.legal.add.success": "Document(s) successfully placed on hold.",
    "rm.legal.add.folder.success": "Folder(s) successfully placed on hold.",
    "rm.legal.add.folderAndDocs.success": "Folder(s) and document(s) successfully placed on hold.",
    "rm.legal.add.processing": "A legal hold for your selected document(s) is processing. Once it is complete, you will receive a system message.",
    "rm.legal.create.docHistory": "Legal Hold - Create",
    "rm.legal.release.docHistory": "Legal Hold - Release",

    "place.folder.on.legal.hold.launch": "Place Folder on Legal Hold...",

    "action.keep": "keep",
    "action.delete": "delete",
    "action.purge": "purge",
    "action.start": "start",
    "approval.count": "{0} approvals",
    "approval.count.conditional.1": "{0} approval",
    "start.item": "start {0}",
    "keep.folder.keep.documents": "keep folder and keep documents",
    "purge.folder.keep.documents": "purge folder and keep documents",
    "purge.folder.delete.documents": "purge folder and delete documents",
    "purge.folder.purge.documents": "purge folder and purge documents",


    "see.more": "See more...",
    "custodian.unique": "Custodians must be unique.",

    "retain.permanently": "retain permanently",
    "queued": "queued",
    "projected.date": "projected {0}",
    "deleted.date": "deleted {0} by {1}",
    "assigned.date": "Assigned: {0}",
    "assigned.by": "Assigned: {0} by {1}",
    "projected.between": "projected between now and",

    "file.colon.created": "File: Created",

    "noUserSearches": "No searches available. An administrator can assign searches to you.",
    "urlapi.search.missing": "The searchId parameter is required for the search operation.",
    "urlapi.search.bad": "The provided search cannot be run.",
    "urlapi.search.invalidPrompts": "The provided search cannot be run because not all prompt values are valid.",
    "urlapi.jobqueue.notDistributed": "This job was not distributed to you, so you do not have access to check it out.",
    "urlapi.forms.bad": "The provided form can not be opened.",
    "folder.panel": "Folder Panel",

    "none.selected": "[ none selected ]",
    "any": "any",
    "by": "by",
    "held.on": "Held on",
    "recordSeries": "Record Series",
    "legalHold": "Legal Hold",
    "disposition": "Disposition",
    "disposition.review": "Disposition Review",
    "actions": "Actions",
    "record.series.per.job": "Record series per job",
    "200.record.series.per.job": "200 record series per job",
    "all.the.record.series.in.one.job": "All the record series in one job",

    "main.attendance.absences": "Absences",
    "main.attendance.desc": "Choose a start and end date, and mark users absent or present for the selected days.",
    "main.attendance.desc.self": "Choose a start and end date, and mark yourself absent or present for the selected days.",
    "main.attendance.redistribute": "Redistribute user's current jobs for today",
    "main.attendance.redistribute.self": "Redistribute my current jobs for today",
    "main.attendance.absent": "Mark absent",
    "main.attendance.present": "Mark present",
    "main.attendance.no.absences": "No users are absent on the selected days.",
    "main.attendance.no.absences.self": "You are not absent on the selected days.",

    "main.documentInfo.viewVersion": "View Version",
    "main.documentInfo.viewPrev.context": "View This Version",
    "main.documentInfo.revertToPrev": "Revert to Previous Version",
    "main.documentInfo.revertToThis": "Revert to This Version",
    "main.documentInfo.revertToPrev.iconText": "Revert",
    "document.history": "Document History",
    "main.reverted.comment": "reverted to Version: ",
    "main.reverted.success": "Document reverted successfully.",
    "main.documentInfo.create.upload": "Create - Upload",
    "main.documentInfo.create.pointer": "Create - Pointer",
    "main.documentInfo.create.scanTo": "Create - ScanTo",
    "main.documentInfo.version.initial": "Initial",

    "export.document.history": "Export Document History to Spreadsheet",
    "export.notes": "Export Notes to PDF",
    "export.notes.title": "Export Notes",
    "export.documents.count": "Export {0} Documents",
    "export.documents.count.conditional.1": "Export Document",
    "export.documents.count.conditional.0": "Export Documents",
    "main.rm.place.on.legal.hold.count": "Place {0} Records on Legal Hold",
    "main.rm.place.on.legal.hold.count.conditional.1": "Place Record on Legal Hold",
    "main.rm.place.on.legal.hold.count.conditional.0": "Place Records on Legal Hold",
    "main.rm.add.retention.policy": "Add Retention Policy",
    "main.rm.edit.retention.policy": "Edit Retention Policy",
    "main.rm.delete.retention.policy": "Delete Retention Policy",
    "main.rm.schedule.disposition": "Schedule Disposition",
    "main.rm.schedule.disposition.all": "Schedule Disposition for All Policies",
    "main.rm.schedule.disposition.all.confirm": "This new schedule will replace the current schedules for all the retention policies in your system.",
    "main.rm.open.new.legal.case": "Open New Legal Case",
    "main.rm.edit.legal.case": "Edit Legal Case",
    "main.rm.close.legal.case": "Close Legal Case",
    "main.rm.delete.legal.case": "Delete Legal Case",
    "policy.type": "Policy Type",
    "purge.folder": "Purge Folder",
    "keep.folder": "Keep Folder",
    "keep.documents": "Keep Documents",
    "purge.documents": "Purge Documents",
    "delete.documents": "Delete Documents",
    "action.on.contents": "Action on contents",
    "timeframe.folder": "Time frame to retain folder",
    "timeframe.folder.and.docs": "Time frame to retain folder and documents",
    "all.contents.are.disposed": "all contents are disposed",
    "specified.date": "specified date",

    "main.fax": "Fax Documents",
    "main.fax.description": "Select a fax service and set the options for this fax job.  After being sent, your fax jobs are listed in the My Desktop panel. Fields marked with an * are required.",
    "main.fax.none.available": "None available.  An administrator can assign fax devices to you.",
    "main.fax.service": "Fax Service",
    "main.fax.number": "Fax number",
    "main.fax.recipient": "Recipient's name",
    "main.fax.sender": "Sender's name",
    "main.fax.markup.description": "Whether to include redactions and markup on faxed documents.  Changes to these options require specific Security Access permissions to take effect on the fax.",
    "main.fax.redactions": "include redactions",
    "main.fax.markup": "include markup",
    "main.fax.button": "Fax",
    "main.fax.partial": "{0} out of {1} documents cannot be faxed. They are either missing the necessary security to fax or are not documents.",

    "print.success": "Documents were successfully submitted for printing.",
    "fax.success": "Documents were successfully submitted for faxing.",

    "email.success": "Documents were successfully emailed.",
    "main.email.title": "Email Document(s)",
    "main.email.description": "Enter the email information and choose the method for sending documents. Forms, Checklists, and any documents that exceed the maximum file size can only be sent as links (and not as attachments). Changes to the default format settings require specific Feature Rights and Security Access permissions to take affect on documents sent as attachments. Fields marked with an * are required.",
    "main.email.folders.desc": "Enter the email information and choose the method for sending the folder. Form documents, checklist documents, and any folder that exceeds maximum file size can only be sent as links. Fields marked with an * are required.",
    "main.email.prompt": "Enter email addresses, separated by commas...",
    "main.email.cc": "CC",
    "main.email.bcc": "BCC",
    "main.email.subject": "Subject",
    "message": "Message",
    "attach": "Attach",
    "main.email.sendAs": "Send documents as",
    "main.email.folders.sendAs": "Send folders as",
    "main.email.sendAs.links": "links",
    "attachments": "attachments",
    "Attachments": "Attachments",
    "Links": "Links",
    "main.email.attachment.type": "Attachment file type",
    "main.email.attachment.include": "Include in attachment",
    "main.email.links.help": "To view in DocFinity, click the following link(s) or copy and paste the URL(s) into your browser (Mobile device compatible):",
    "main.email.partial": "{0} out of {1} documents cannot be emailed. They are missing the necessary security to email.",

    "main.export.description": "Enter a name for this export job and choose one Export Profile. After being sent to the server for rendering and compression, your export jobs are listed in the My Desktop panel; you will also receive a message when the job is finished processing and the output is available.  Fields marked with an * are required.",
    "main.export.jobName": "Export job name",
    "main.export.jobName.default": "Export-{0}",
    "main.export.profile": "Export Profile",
    "main.export.none.available": "None available.  An administrator can assign export profiles to you.",
    "main.export.partial": "{0} out of {1} documents cannot be exported. They are missing the necessary security to export.",

    "refresh.now": "Refresh Now",
    "automatically.refresh": "Automatically Refresh",
    "automatically.refresh.iconText": "Auto-refresh",
    "set.refresh.interval": "Set Refresh Interval...",
    "set.refresh.interval.title": "Set Refresh Interval",
    "set.refresh.interval.desc": "Set how often this list refreshes. Fields marked with an * are required.",
    "refresh.frequency": "Refresh frequency",
    "set.interval.success": "Refresh interval successfully set.",
    "refresh.pause": "Pause Refresh",
    "refresh.resume": "Resume Refresh",
    "refresh.batches.pause": "Pause Batches Refresh",
    "refresh.batches.resume": "Resume Batches Refresh",
    "refresh.batches": "Refresh Batches",
    "refresh.jobs.pause": "Pause Jobs Refresh",
    "refresh.jobs.resume": "Resume Jobs Refresh",
    "refresh.jobs": "Refresh Jobs",

    "get.jobQueue": "Get Job Queue",
    "jobViews.empty": "None available.  An administrator can assign job views to you.",
    "jobViews.description": "Select a Job View in the grid below to view the Job Queue.",
    "jobView.error": "There was an error loading this job view.  Please contact an administrator.",
    "jobView.missingPrompts": "Please fill out all Job View prompts.",

    "main.replace.title": "Replace Document - {0}",
    "main.replace.description": "Replace a document with the specified file. If versioning is enabled for this Document Type, a new version of the document will be created. If versioning is not enabled for this Document Type, the new file will overwrite the old document. Fields marked with an * are required.",
    "main.replace.comments": "Comments",
    "main.replace.dropTarget": "Drop the file here...",
    "main.replace.tooLarge": "This file is too large to be uploaded.",

    "main.no.document.information": "Choose a document to load its information.",
    "main.no.info.doc.folder": "Choose a document or open a folder to see its information.",
    "main.no.info.folder": "Open a folder to see its information.",

    "new.doc.conditional.0": "New Document",
    "new.doc.with.pages.count": "New Document From {0} Pages",
    "new.doc.with.pages.count.conditional.1": "New Document From Page",
    "new.doc.with.pages.count.conditional.0": "New Document From Pages",
    "scanned.doc.conditional.0": "Scanned Document",
    "scanned.doc": "Scanned Document {0}",
    "new.doc.delete": "Are you sure you wish to delete this new document?",
    "new.doc": "New Document {0}",
    "docType.new.doc": "{1} (New Document {0})",
    "docType.new.doc.conditional.0": "{1} (New Document)",
    "doc.no.delete": "You do not have permission to delete the following documents: {0}",
    "edit.doc.native": "Edit Document in Native Application",
    "edit.doc.native.short": "Edit in Native Application",
    "open.doc.native": "Open Document in Native Application",
    "download.to.edit": "Download Document To Edit",
    "download.to.edit.short": "Download To Edit",
    "replace.doc": "Replace Document",
    "replace": "Replace",
    "replace.doc.success": "Document replaced successfully.",
    "lock.cancel.warning": "The following edit locks have been cancelled by another user: {0}",
    "commit.doc.failure": "Not all documents could be committed.",
    "after.page.inc": "after every custom number of pages",
    "cover.sheet.preview": "Cover sheet preview",
    "cover.page.pattern": "Enter a page number or range.",
    "set.cover.sheet": "Set cover sheet",
    "beginning.doc": "beginning of document",
    "at.page": "at page",
    "end.doc": "end of document",
    "cover.sheet.where": "Where should the cover sheet appear?",
    "next.document": "Next Document",
    "previous.document": "Previous Document",

    "cut.pages": "Cut Page(s)",
    "cut.pages.count": "Cut {0} Pages",
    "cut.pages.count.conditional.1": "Cut Page",
    "cut.pages.count.conditional.0": "Cut Pages",
    "copy.pages": "Copy Page(s)",
    "copy.pages.count": "Copy {0} Pages",
    "copy.pages.count.conditional.1": "Copy Page",
    "copy.pages.count.conditional.0": "Copy Pages",
    "paste.pages": "Paste Page(s)",
    "paste.pages.count": "Paste {0} Pages",
    "paste.pages.count.conditional.1": "Paste Page",
    "paste.pages.count.conditional.0": "Paste Pages",
    "next.page": "Next Page",
    "next.page.go": "Go to Next Page",
    "prev.page": "Previous Page",
    "prev.page.go": "Go to Previous Page",
    "zoom.in": "Zoom In",
    "zoom.out": "Zoom Out",
    "zoom.to.fit": "Zoom to fit",
    "zoom.to.75": "Zoom to 75%",
    "zoom.to.100": "Zoom to 100%",
    "zoom.to.150": "Zoom to 150%",
    "zoom.adjust": "Adjust Zoom",
    "first.page": "First Page",
    "first.page.go": "Go to First Page",
    "last.page": "Last Page",
    "last.page.go": "Go to Last Page",

    "Scanner": "Scanner",
    "Paper.source": "Paper source",
    "ADF": "ADF",
    "Flatbed": "Flatbed",
    "Scanner.interface": "Display Scanner Interface",
    "Blank.pages": "Delete Blank Pages",
    "Scanning.progress": "Scanning progress",
    "Back.to.scanner": "Scanner Settings",

    "print.barcode.page": "Print Barcode Page",

    "my.messages": "My Messages",
    "my.messages.desc": "Messages related to your tasks.",
    "my.messages.view": "View Message",
    "my.messages.delete": "Delete Message",
    "my.messages.delete.multiple": "Delete {0} Messages",
    "my.messages.copy": "Copy Row",
    "my.messages.copy.multiple": "Copy {0} Rows",
    "server.messages": "Server Messages",
    "server.messages.desc": "Messages related to server tasks. Deleting these messages deletes them from the system and for everyone who receives them.",
    "error.messages": "Gateway Error Reports",
    "error.messages.desc": "These messages are received from users who experienced an error in a Gateway.",
    "error.messages.type": "Error Type",
    "error.messages.type.js": "JavaScript Error",
    "error.messages.type.server": "Server Error",
    "error.messages.type.value": "Error Type: {0}",
    "error.messages.code": "Error Code",
    "error.messages.code.value": "Error Code: {0}",
    "print.queue": "Print Queue",
    "printfax.queue.desc": "Pending Print Jobs and Fax Jobs.",
    "print.queue.desc": "Pending Print Jobs.",
    "printfax.queue": "Print/Fax Queue",
    "export.queue": "Export Queue",
    "export.queue.desc": "Export jobs that have been sent to the server for rendering and compression; when processing is complete, jobs are ready for download and available until the expiration date.",
    "export.queue.delete": "Delete Job",
    "editing.queue": "Editing Queue",
    "export.job": "Export Job",
    "editing.queue.desc": "Documents you have checked out for editing. When you are finished editing a document, chieck it in by replacing it, committing the edit, sending it to a batch or adding it to a package.",
    "download.ready": "ready for download",
    "ready.with.warnings": "Ready, with warnings",
    "processing.status": "processing",
    "Submitted": "Date Submitted",
    "Expiration": "Expiration",
    "Date.Received": "Date Received",
    "date.received.value": "Date Received: {0}",
    "Priority": "Priority",
    "warning.lower": "warning",
    "messages.pref": "Messages Preferences",
    "cancelled": "cancelled",
    "enqueued": "enqueued",
    "Device": "Device",
    "print": "print",
    "fax": "fax",
    "cancel.print": "Cancel Print Job",
    "cancel.job": "Cancel job",
    "print.cancel.done": "Print job was cancelled.",
    "export.delete.done": "Export job deleted successfully.",
    "message.delete.done": "Message deleted successfully.",
    "delete.all": "Delete All",
    "delete.all.messages": "Delete All Messages",
    "system.message.delete": "Are you sure you want to delete these messages? Deleting Server messages deletes them for everyone who receives them.",
    "system.message.all": "Are you sure you want to delete all messages?",

    "full.screen": "Full Screen",
    "restore.screen": "Restore to original size",
    "Popout": "Open in a new window",
    "Popin": "Return panel to main window.",

    "copy.selected.rows": "Copy Rows",
    "copy.successful": "Rows successfully copied.",
    "copy.instructions": "Your browser does not support copying text automatically.  Please copy the text below.",
    "priority.conditional.ERROR": "Priority: error",
    "priority.conditional.WARNING": "Priority: warning",
    "priority.conditional.INFO": "Priority: message",
    "origin.display": "Origin: {0}",
    "serverMessage.display": "Server Message: {0}",
    "userMessage.display": "User Message: {0}",
    "date.display": "Date: {0}",

    "delete.pages": "Delete Page(s)",
    "delete.pages.count": "Delete {0} Pages",
    "delete.pages.count.conditional.1": "Delete Page",
    "delete.pages.count.conditional.0": "Delete Pages",
    "add.pages": "Add Page(s)",
    "add.pages.title": "Add Page(s) - {0}",
    "add.pages.description": "Add pages to the document. The uploaded pages will be added after the selected page. This action uploads only one file. Fields marked with an * are required.",
    "rotate.clockwise": "Rotate CW",
    "rotate.clockwise.page.count": "Rotate {0} Pages CW",
    "rotate.clockwise.page.count.conditional.1": "Rotate Page CW",
    "rotate.clockwise.page.count.conditional.0": "Rotate Pages CW",
    "rotate.counterClockwise": "Rotate CCW",
    "rotate.counterClockwise.page.count": "Rotate {0} Pages CCW",
    "rotate.counterClockwise.page.count.conditional.1": "Rotate Page CCW",
    "rotate.counterClockwise.page.count.conditional.0": "Rotate Pages CCW",
    "rotate.doc.clockwise.count": "Rotate {0} Documents CW",
    "rotate.doc.clockwise.count.conditional.1": "Rotate Document CW",
    "rotate.doc.clockwise.count.conditional.0": "Rotate Documents CW",
    "rotate.doc.counterClockwise.count": "Rotate {0} Documents CCW",
    "rotate.doc.counterClockwise.count.conditional.1": "Rotate Document CCW",
    "rotate.doc.counterClockwise.count.conditional.0": "Rotate Documents CCW",
    "page.num": "Page {0}",
    "editQueue.empty": "Your edit queue is empty.",
    "view.edit": "View Edit Queue",
    "scan.documents": "Scan Documents",
    "view.native": "View in Native Application",
    "view.related.attachments": "View related attachments",
    "edit.cancel.success": "Edits cancelled successfully.",
    "cancel.all.edit": "Discard Queue",
    "confirm.discard": "Confirm Discard",
    "discard.edits": "Discard from Editing",
    "yes.discard": "Discard",
    "save.doc.count": "Save {0} Documents",
    "save.doc.count.conditional.1": "Save Document",
    "save.all.docs": "Save All Documents",
    "save.all": "Save All",
    "commit.edit.count": "Commit {0} Edits",
    "commit.edit.count.conditional.1": "Commit Edit",
    "commit.edit.count.conditional.0": "Commit Edits",
    "commit.edit.win.description": "Committing edits creates a new version for documents of types that have versioning enabled.",
    "Commit": "Commit",
    "commit.nowPending": "Document(s) successfully sent to server for processing.",
    "cancel.all.edit.confirm": "Discarding your queue will discard all changes that have been made and any new documents brought in. Do you wish to continue?",
    "cancel.some.edit.confirm": "This will discard all changes you have made to the selected documents.  Do you wish to continue?",
    "commit.document": "Commit Document",
    "commit.documents": "Commit Documents",
    "commit.all.indexing": "Commit All Indexing",
    "confirm.cancel": "Confirm Cancel",
    "move.pages": "Move Page(s)",
    "move.pages.count": "Move {0} Pages",
    "move.pages.count.conditional.1": "Move Page",
    "move.pages.count.conditional.0": "Move Pages",
    "move.all.pages": "Move All Pages...",
    "move.doc.up": "Move Document Up",
    "move.doc.down": "Move Document Down",
    "Source": "Source",
    "Destination": "Destination",
    "after.page": "After page",
    "split.document": "Split Document...",
    "split": "Split",
    "split.label": "Split document:",
    "split.document.title": "Split Document",
    "split.document.description": "Split Document allows you to split a document into two or more documents and optionally set a cover sheet for the split documents.",
    "combine": "Combine",
    "combine.documents.count": "Combine {0} Documents",
    "combine.documents.count.conditional.0": "Combine Documents",
    "combine.documents.count.conditional.1": "Combine Document",
    "combine.documents.pdf": "Combine Documents into PDF",
    "every": "every",
    "pages.unit": "pages",
    "before.pages": "before pages",
    "pages.unit.conditional.1": "page",
    "split.pages.instructions": "Enter page numbers separated by commas",
    "page.count": "{0} pages",
    "page.count.conditional.1": "1 page",
    "downloaded.to.edit": "Downloaded to edit",
    "editing.in.native": "Editing in native application",
    "unsupported": "Unsupported",
    "unsupported.error": "This file type is unsupported. To edit the document, please download or edit it in its native application.",
    "editing.in.native.error": "This document is being edited in its native application.",
    "no.pages.error": "This document does not have any pages.",
    "downloaded.to.edit.error": "This document has been downloaded to edit.",
    "editing.outofsync": "Operation failed because editing queue was out of date. Please try again.",

    "Pages": "Pages",

    "docfinity.viewer": "Markup Viewer",
    "tab.failed": "A new window could not be opened.  Please configure your popup blocker to allow popups on this page.",

    "show.toolbar": "Show Toolbar",

    "send.to.no.rights": "You do not have sufficient rights to send documents to DocFinity. . Please contact an administrator.",

    "download": "Download",
    "download.pdf": "Download PDF",
    "tips.hotkeys.context": "Tip: Press [{0}] to {1}.",
    "tips.hotkeys.nextDocument": "Tip: Press [ctrl+d] to move to the next document.",
    "tips.hotkeys.previousDocument": "Tip: Press [ctrl+shift+d] to move to the previous document.",
    "tips.hotkeys.returnJob": "Tip: Press [ctrl + j] to return a job.",
    "tips.hotkeys.completeJob": "Tip: Press [ctrl + k] to complete your next job.",
    "tips.hotkeys.commitBatch": "Tip: Press [ctrl + b ] to commit your batch.",
    "tips.hotkeys.saveBatch": "Tip: Press [ctrl + s] to save your batch.",

    "main.batches.upload": "Upload Files...",
    "main.batches.create": "Create New Batch...",
    "main.batches.create.new": "New batch",
    "main.batches.scan": "Scan New Batch",
    "main.batches.checkOut": "Check Out Batch",
    "main.batches.checkIn": "Check In Batch",
    "main.batches.checkIn.unsaved": "There are unsaved changes in this batch. Would you like to save these changes?",
    "main.batches.commit": "Commit Batch",
    "main.batches.delete": "Delete Batch",
    "main.batches.thumbs": "View Thumbnails",
    "main.batches.preferences": "Indexing Preferences...",
    "main.batches.available": "Available Batches (filtered)",
    "main.batches.available.conditional.0": "Available Batches",
    "main.batches.available.description": "Batches contain documents that are not yet searchable.  Check out a batch to index documents; a batch can only be checked out by one user at a time.",
    "main.batches.checkedOut": "Checked Out Batch: {0}",
    "main.batches.checkedOut.conditional.UPLOADS": "Checked Out Batch: My Uploads",
    "main.batches.checkedOut.description": "Index the documents in this batch. Check in the batch to return it and save progress. Commit the batch so that fully indexed documents will be searchable.",
    "main.batches.progress": "Progress",
    "main.batches.progress.done": "all required",
    "main.batches.progress.incomplete": "incomplete",
    "main.batches.progress.invalid": "INVALID",
    "main.batches.missing": "You have insufficient security rights to view {0} documents in this batch.",
    "main.batches.missing.conditional.1": "You have insufficient security rights to view {0} document in this batch.",
    "main.batches.missing.paged": "You may only view {0} uploaded documents at a time.",
    "main.batches.missing.filter": "You no longer have security access to index {0} documents in this batch.",
    "main.batches.missing.filter.conditional.1": "You no longer have security access to index {0} document in this batch.",
    "main.batches.missing.filter.all": "You no longer have security access to index any documents in this batch, it has been automatically checked in.",
    "main.batches.taken": "This batch has been checked in by an administrator.  Any data you were indexing has been discarded.",
    "main.batches.uploads": "My Uploads",
    "main.batches.uploads.count": "{0} Documents",
    "main.batches.uploads.delete": "Delete uploaded documents",
    "main.batches.none": "There are no batches assigned to you.",
    "main.batches.delete.uploads": "Are you sure you want to delete all of the documents in My Uploads?",
    "available": "Available",
    "checked.out": "Checked out",
    "main.batches.documents.none": "There are no documents in the selected batch.",
    "main.batches.api.invalid": "The specified batch no longer exists, or you do not have access to it.",
    "main.batches.api.taken": "The specified batch is checked out by {0} ({1} {2}).",
    "main.batches.api.multiple": "You currently have a batch checked out, it has been loaded instead of the requested batch.",
    "main.batches.commit.message": "{0} of {1} documents in the batch have all required metadata.  Committing the batch will make these {0} documents searchable.",
    "main.batches.commit.message.conditional.0": "{0} of {1} documents in the batch have all required metadata.",
    "main.batches.commit.message.conditional.1": "{0} of {1} documents in the batch have all required metadata.  Committing the batch will make this document searchable. The other documents will remain in the batch.",
    "main.batches.commit.complete": "The batch was completely indexed.",
    "main.batches.commit.partial": "{0} of {1} documents were successfully committed.  The batch has been checked out again automatically.",
    "main.batches.create.docHistory": "Add to batch",
    "main.batches.delete.docHistory": "Remove from batch",
    "main.batches.name.preview": "Batch Name Preview",
    "main.batches.name.customize": "Customize Batch Name",

    "indexing.docs.commit": "{0} documents were successfully committed.",
    "indexing.docs.commit.conditional.1": "1 document was successfully committed.",

    "main.upload.title": "Upload Files",
    "main.upload.description": "Add files by browsing or dragging and dropping them, then upload to add them to DocFinity.  Uploaded files are added to your My Uploads batch.",
    "main.upload.discard": "There are {0} files remaining to be uploaded.  Do you want to close?",
    "main.upload.total": "Files to upload: {0}",
    "main.upload.success": "{0} uploaded file(s) added to My Uploads.",
    "upload.choose": "Choose a file to upload",
    "Files": "Files",

    "main.createBatch.title": "Create New Batch",
    "main.createBatch.description": "Create a new batch from selected documents. Fields marked with an * are required.",
    "main.createBatch.groupsRequired": "You must check at least one group to assign access to the new batch.",

    "main.index.reindex.description": "Edit and then save metadata values for this document. Fields marked with an * are required.",
    "main.index.pointer.description": "A pointer is a document that shares its file with other Pointers, which may be indexed differently.  Edit and save the metadata values to create a Pointer. Fields marked with an * are required.",
    "main.index.rest": "Index Rest",
    "main.index.rest.context": "Index Remaining Documents in Batch",
    "main.index.all": "Index All",
    "main.index.all.context": "Index All Documents in Batch",
    "main.index.clear": "Clear Document Metadata",
    "main.index.clear.prompt": "Do you want to delete all current metadata for this document and start over?",
    "main.index.reset": "Reset to Saved Values",
    "main.index.reset.context": "Reset Metadata to Saved Values",
    "main.index.validation.error": "An error occurred validating this document.  Contact your administrator.",
    "main.index.pointer.closed": "This document was not fully indexed. It will be available in your My Uploads.",
    "main.index.blindEntry.error": "{0} values must be the same.",
    "main.index.batch.invalid": "{0} documents in the batch have invalid data and cannot be saved.  Correct the invalid data and try again.",
    "main.index.batch.invalid.conditional.1": "{0} document in the batch has invalid data and cannot be saved.  Correct the invalid data and try again.",
    "main.index.api.complete": "Your document has been indexed and will appear in DocFinity results shortly. You may now close this window.",
    "main.index.api.partial": "Your document has been partially indexed and will appear in your My Uploads.  You may now close this window.",
    "main.index.noViewSecurity": "You do not have permission to index this document.",
    "main.index.noData": "Choose a document to index.",
    "main.index.api.documentType.invalid": "The specific Document Type is invalid.",
    "clear.when.empty": "This value will be cleared if it is left empty",

    "main.index.plugin.listening": "The following indexing plugins are running: {0}",
    "main.index.plugin.syncing": "Indexing plugins are syncing data with the server, wait to trigger hot key...",
    "main.index.plugin.updating": "The {0} indexing plugin is updating data...",
    "main.index.plugin.completed": "The {0} indexing plugin has completed.",
    "main.index.plugin.desktop.off": "DocFinity Desktop is not running.",
    "main.index.plugin.off": "The following indexing plugins are not running: {0}.",

    "validator.invalid": "This field is invalid.",
    "select.all": "Select all...",
    "selectAll": "Select All",

    "folders": "Folders",
    "folder.add": "Add Folder",
    "new.folder": "New Folder",
    "choose.folder": "Choose Folder",
    "folder.name": "Folder Name",
    "folder.id": "Folder ID",
    "rename.folder": "Rename Folder",
    "rename.folder.launch": "Rename Folder...",
    "folders.email.launch.conditional.0": "Email Folders...",
    "folders.email.launch.conditional.1": "Email Folder...",
    "folders.email.launch": "Email {0} Folders...",
    "folders.email.launch.nocount": "Email Folder(s)...",
    "folders.email.conditional.1": "Email Folder",
    "folders.email": "Email {0} Folders",
    "folder.email.success": "{0} folder was successfully emailed.",
    "folders.email.success": "The folders were successfully emailed.",
    "folder.email.fail.size": "{0} folder could not be emailed because it exceeded the maximum size of attachments. Please email the folder as a link or as individual files.",
    "folders.email.fail.size": "The folders could not be emailed because they exceeded the maximum size of attachments. Please email the folders as links or as individual files.",
    "folders.delete.launch.conditional.0": "Delete Folders...",
    "folders.delete.launch.conditional.1": "Delete Folder...",
    "folders.delete.launch": "Delete {0} Folders...",
    "folders.delete.launch.nocount": "Delete Folder(s)...",
    "folders.delete.conditional.1": "Delete Folder",
    "folders.delete": "Delete {0} Folders",
    "folders.delete.documents.label": "Delete documents with folder",
    "folders.delete.documents.queued": "The folder and all its documents are being deleted.  You will receive a message in My Messages when this is complete.",
    "folders.delete.documents.failed": "{0} folder could not be deleted. Go to My Messages to see more details.",
    "add.folder.launch": "Add Folder...",
    "add.docs.to.folder.launch.conditional.1": "Add Document to Folder...",
    "add.docs.to.folder.launch": "Add {0} Documents to Folder...",
    "add.all.docs.to.folder.launch": "Add All Documents to Folder...",
    "add.docs.to.folder.conditional.1": "Add Document to Folder",
    "add.docs.to.folder": "Add {0} Documents to Folder",
    "add.all.docs.to.folder": "Add All Documents to Folder",
    "add.to.folder": "Add to Folder",
    "add.to.folder.launch": "Add Documents(s) to Folder...",
    "add.to.folder.success": "{0} Documents successfully added to folder.",
    "add.to.folder.success.conditional.1": "Document successfully added to folder.",
    "add.all.processing": "All documents are being added to the folder. You will receive a message in My Messages when this is complete.",
    "add.folder.audit": "Folder - Add",
    "folder.audit.remove": "Folder - Remove",
    "folder.types": "Folder Types",
    "folder.type": "Folder Type",
    "folderTypes.addFirst": "Add First Folder Type",
    "folders.admin.desc": "Create, edit, and delete Folder Types.  Manage simple folders.",
    "folderType.snapshot": "Folder Type Snapshot",
    "folderType.unique": "Folder Type name must be unique.",
    "open.folder": "Open Folder",
    "shared.with": "Shared with",
    "shared.date": "Shared Date",
    "folder.shared.with.context": "{0} is given {1} access to this folder.",
    "folder.shared.with.context.via": "{0} is given {1} access to this folder via {2}.",
    "folder.share.desc": "Share the folder with groups and users by selecting them below.",
    "delete.all.documents": "Delete All Documents...",
    "folder.delete.all.documents": "Delete All Documents in Folder...",
    "folder.delete.all.documents.confirm": "Are you sure you want to delete all documents from {0} folder?",
    "folder.delete.all.documents.queued": "All documents in the folder are being deleted. You will receive a message in My Messages when this is complete.",
    "remove.document": "Remove Document",
    "folder.remove.documents.conditional.0": "Remove Documents From Folder",
    "folder.remove.documents.conditional.1": "Remove Document From Folder",
    "folder.remove.documents": "Remove {0} Documents From Folder",
    "folder.remove.documents.nocount": "Remove Document(s) From Folder",
    "remove.all.documents": "Remove All Documents...",
    "folder.remove.confirm": "Are you sure you want to remove all the documents from {0} folder?",
    "folder.remove.queued": "All documents in the folder are being removed. You will receive a message in My Messages when this is complete.",
    "folder.metadata.unique": "This Metadata Object is used in a different Folder Type.",
    "folder.simple": "Simple Folders",
    "folder.owner": "Owner",
    "folder.owner.label": "Owner:",
    "folder.owner.assign": "Assign Owner",
    "folders.my": "My Folders",
    "folders.shared": "Shared Folders",
    "folders.my.none": "Create your first folder to group documents together.",
    "folder.empty": "This folder is currently empty.",
    "folder.email.check.count": "Some documents cannot be emailed as attachments. We will email what we can, otherwise please email the folder as a link.",
    "folder.email.check.size": "The folder is likely too large to send as an attachment.  We recommend emailing the folder as a link or emailing just a few documents at a time.",
    "folder.smart.doc.manual.flag.pref": "documents manually added to smart folders",
    "folder.smart.doc.manual": "Document manually added to folder.",
    "folder.actions": "Folder Actions",
    "find.smart.folder": "Find Smart Folder",
    "folder.details": "Folder Details",
    "detail": "Detail",
    "add.folder.detail": "Add Folder Detail",
    "key.metadata": "Key Metadata",
    "details.error": "Error retrieving details. Please contact an administrator.",
    "folder.naming.structure": "Folder Naming Structure",
    "folder.naming.structure.clean": "This detail was used in Folder Naming. We deleted that corresponding configuration for you as well.",
    "copied.into.folder.conditional.1": "{0} document added to {1} folder.",
    "copied.into.folder": "{0} documents added to {1} folder.",
    "view.all.doc.notes": "View All Documents' Notes",
    "folders.recent": "Recent Folders",
    "folder.smart": "Smart Folder",
    "smart.folders": "Smart Folders",
    "folder.simple.list": "Simple Folder List",
    "folder.email.access": "Send my folder with",
    "details.config.none": "No details configured",
    "folder.details.show": "Show folder details",
    "folder.type.define": "Folder Type - {0}",
    "folder.types.none": "There are no available Folder Types.  An administrator can assign Folder Types to you.",

    "designer.open.version": "Open Version",
    "designer.open.version.popup": "Open Version...",
    "designer.open.version.overwrite": "Your current working copy will be overwritten with this version.",
    "designer.form.open.version.desc": "Open a specific version of this form design. You may view the version in readonly mode or overwrite the working draft to open it for editing.",
    "designer.bpm.open.version.desc": "Open a specific version of this process model. You may view the version in readonly mode or overwrite the working draft to open it for editing.",
    "designer.view.readOnly": "View Read-Only",
    "designer.readOnly": "Read-Only",
    "designer.readOnly.name": "{0} (Read-Only)",
    "designer.checkedOutBy": "In Use",
    "designer.name.illegal.chars": "The design name cannot include the following characters: /\\*?\"<>|:;",
    "new": "New",
    "open.popup": "Open...",
    "validate": "Validate",
    "designer.pageSetup": "Page Setup...",
    "print.popup": "Print...",
    "designer.guides": "Enable Guides",
    "designer.grid": "Show Grid",
    "designer.grid.snap": "Snap to Grid",
    "designer.page": "Show Page Borders",
    "designer.autoConnect": "Auto-link Nodes",
    "designer.workingCopy": "working copy",
    "designer.edit": "Edit {0}",
    "designer.valid": "Configuration is valid.",
    "designer.invalid": "Configuration is invalid.",
    "designer.invalid.errors": "Validation Errors",
    "designer.saveComplete": "Design is successfully saved.",
    "designer.valid.now": "No more validation errors",
    "bpmDesigner.invalid.desc": "Please fix these errors below in order to activate your Process Model. Clicking on each will take you to the node with the error. After correcting the error, revalidate to ensure it is fixed.",
    "bpmDesigner.invalid.itemErrors": "Process Model Errors",
    "formDesigner.invalid.desc": "Please fix these errors below in order to activate your Form Design. Clicking on each will take you to the form control with the error. After correcting the error, revalidate to ensure it is fixed.",
    "download.png": "Download as PNG image",
    "space": "Space",
    "theme": "Theme",
    "loop.settings": "Loop Settings",
    "loop.activity": "Loop this activity",
    "loop.collection": "Collection to loop",

    "designer.active": "\"{0}\" has been activated as version {1}.",
    "designer.noVersion.active": "{0} is successfully activated.",
    "designer.failActivate": "\"{0}\" has failed to activate.",
    "designer.close": "Close {0}",

    "designer.version": "Version: {0}",
    "designer.version.conditional.-1": "Version: Working Copy",

    "designer.saveAs.desc": "Save your design by giving it a unique name.",

    "formDesigner.empty": "No Form Designs exist. Click Add New to create a new Form Design.",
    "bpmDesigner.empty": "No Process Models exist. Click Add New to create a new Process Model.",
    "designer.unsavedName": "New Design",
    "bpmDesigner.subprocess.activateError": "This process is used as a subprocess in the processes: {0}. Activating it may affect these processes. Do you want to continue?",

    "designer.toolbox": "Toolbox",
    "formDesigner.toolbox.basic": "Basic Components",
    "formDesigner.toolbox.controls": "Entry Controls",
    "formDesigner.button": "Button",
    "formDesigner.hline": "Horizontal Line",
    "formDesigner.image": "Image",
    "text": "Text",
    "formDesigner.vline": "Vertical Line",
    "formDesigner.checkbox": "Checkbox",
    "formDesigner.dateField": "Date Field",
    "formDesigner.dropDown": "Drop-down List",
    "dropDown.userInput": "Drop-down List with user input",
    "formDesigner.list": "List Box",
    "table": "Table",
    "formDesigner.textArea": "Text Area",
    "formDesigner.textField": "Text Field",
    "formDesigner.numericField": "Numeric Field",
    "formDesigner.fileUpload": "File Upload",
    "formDesigner.link": "Link",

    "formDesigner.tooltip": "Tooltip",
    "formDesigner.tabIndex": "Tab index",
    "formDesigner.hidden": "Hidden",
    "formDesigner.always": "Always",
    "formDesigner.optional": "Optional",
    "formDesigner.define": "Define",
    "formDesigner.enabled": "Enabled",
    "formDesigner.visible": "Visible",
    "formDesigner.defineCondition": "Define Condition: {0}",
    "formDesigner.conditions.discardBasic": "You have made changes to the macro that cannot be translated into the basic view.  Continuing will remove all existing basic configuration items.",

    "formDesigner.basicConfigTitle": "Basic Config Dialog",
    "formDesigner.basicConfigType": "{0} if:",

    "formDesigner.referencedBy": "Referenced by",

    "formDesigner.whenToggle": "When",
    "formDesigner.controls.delete.confirm": "Are you sure you want to delete the selected form control?",
    "formDesigner.controls.delete.confirm.plural": "Are you sure you want to delete the selected form controls?",

    "formDesigner.configuration": "{0} Configuration",

    "formDesigner.table.setColumnWidths": "Set Column Widths",

    "formDesigner.step.add": "Add Step",
    "formDesigner.step.copy": "Copy Step",
    "formDesigner.step.delete": "Delete Step",
    "formDesigner.step.rename": "Rename Step",
    "formDesigner.step.delete.confirm": "Are you sure you want to delete the {0} step? This will remove all controls and actions for the step. If a control exists only on this step, this will remove it from the form.",

    "formDesigner.addStep.desc": "Add a step to the form, and optionally duplicate controls from another step.",
    "formDesigner.addStep.unique": "Form step names must be unique.",
    "formDesigner.addStep.copyFrom": "Duplicate form fields from step",

    "formDesigner.addACondition": "Add a Condition",
    "formDesigner.when": "When...",

    "formDesigner.duplicate.title": "Duplicate Control",
    "formDesigner.duplicate.desc": "Select the step to which this control should be duplicated.",
    "formDesigner.steps": "Steps",
    "formDesigner.steps.scroll.left": "Scroll steps left",
    "formDesigner.steps.scroll.right": "Scroll steps right",

    "formDesigner.opacity.open": "Opacity...",
    "formDesigner.opacity.title": "Opacity Setting",

    "formDesigner.assign.desc": "Assign groups that are able to access this form.",
    "bpmDesigner.assign.desc": "Assign groups that are able to start this Business Process.",

    "formDesigner.export.unsaved": "The form has unsaved changes which must be saved before you can export.",
    "bpmDesigner.export.unsaved": "The process model has unsaved changes which must be saved before you can export.",

    "formDesigner.external.view": "allow public view access",
    "formDesigner.external.edit": "allow public edit access",
    "formDesigner.external.activate": "You must save your form to configure this section.",
    "formDesigner.external.link": "Share Links",

    "formDesigner.background.color": "Background color",
    "formDesigner.background.image": "Background image",
    "formDesigner.background.opacity": "Background opacity",
    "formDesigner.border.size": "Border size",
    "formDesigner.border.color": "Border color",
    "formDesigner.default.styles": "Default Styles",

    "formDesigner.font.arial": "Arial",
    "formDesigner.font.verdana": "Verdana",
    "formDesigner.font.times": "Times New Roman",

    "formDesigner.button.default": "Default submit button",
    "formDesigner.button.bypass": "Bypass required validation",
    "formDesigner.upload.buttonLabel": "Instructions",

    "formDesigner.actions": "Submit Actions",
    "formDesigner.actions.none": "No submit actions have been configured.",
    "formDesigner.actions.assigned": "Assigned actions",
    "formDesigner.action.select": "Add a submit action...",
    "formDesigner.action.delete": "Are you sure you want to delete this submit action?",
    "formDesigner.action.delete.pdfDependencies": "This submit action is being referenced in other submit actions. Deleting this submit action will remove the references in the following actions: {0}",
    "formDesigner.action.edit": "Edit Submit Action",

    "formDesigner.action.goToStep.desc": "Choose a step where the form will move next.",
    "formDesigner.action.goToStep.close": "Close form",
    "formDesigner.action.goToStep.next": "Next step",

    "formDesigner.action.completeForm.desc": "After a form is complete, it can no longer be edited. The final step defines how the form is viewed.",
    "formDesigner.action.completeForm.step": "Final step",
    "formDesigner.action.completeTask.desc": "This submit action can be used in conjunction with a business process. The button will complete the Open Form user task when clicked.",

    "formDesigner.action.import.desc": "Import this form or files attached into DocFinity. Set the Category, Document Type and map values to be indexed as metadata.",
    "formDesigner.action.import.items": "Items",

    "formDesigner.action.createPDF.desc": "To create a PDF copy of this form, choose from form steps or a stored PDF template that matches the Form Design.",
    "formDesigner.action.createPDF.layout": "Base page layout on",
    "formDesigner.action.createPDF.layout.all": "All completed steps",
    "formDesigner.action.createPDF.layout.step": "Step",
    "formDesigner.action.createPDF.layout.template": "PDF Template",
    "formDesigner.action.createPDF.templateUpload": "Drop a PDF file here...",

    "formDesigner.action.feedback.desc": "Enter the message users will see after successful or unsuccessful form submission.",
    "formDesigner.action.feedback.success": "Successful message",
    "formDesigner.action.feedback.failure": "Unsuccessful message",

    "formDesigner.action.loadForm.desc": "Choose another DocFinity form to run.",

    "formDesigner.action.loadUrl.desc": "Enter the URL to load; optionally, variables can be used in the URL.",

    "formDesigner.action.runSP.desc": "Select a Dynamic SQL Datasource to store form data; then choose form controls whose values will be used to populate the query parameters.",

    "formDesigner.action.sendEmail.desc": "This action sends an email. Enter the email information and optionally choose how to include the form. To include an external form, external access must be allowed in the design. To include a PDF, a create PDF action must be configured prior to this action.",
    "formDesigner.action.sendEmail.replyTo": "Reply To",
    "formDesigner.action.sendEmail.linkTo": "Link to",
    "formDesigner.action.sendEmail.linkToPDF": "Link to PDF",
    "formDesigner.action.sendEmail.attachPDF": "PDF as attachment",
    "formDesigner.action.sendEmail.linkType.view": "view internal form",
    "formDesigner.action.sendEmail.linkType.edit": "edit internal form",
    "formDesigner.action.sendEmail.linkType.view.external": "view external form",
    "formDesigner.action.sendEmail.linkType.edit.external": "edit external form",

    "formDesigner.action.startProcess.desc": "Set a Process Model to start. Choose which formats of the form are sent to the process and whether to include form data as variables.",
    "formDesigner.action.startProcess.variableTypes": "Send form fields as variables",
    "formDesigner.action.startProcess.addForm": "Add form to package",
    "formDesigner.action.startProcess.addPDF": "Add PDF to package",
    "formDesigner.action.startProcess.control": "Form control",
    "formDesigner.actions.startProcess.addFirst": "Add a process instance variable by clicking Add.",
    "formDesigner.actions.startProcess.formControls": "Form fields",

    "formDesigner.action.writeToTable.desc": "Choose a Datastore to write form data to a third-party database.",

    "formDesigner.upload.single": "Single file",
    "formDesigner.upload.multi": "Multiple files",
    "formDesigner.upload.extensions": "File types allowed",
    "formDesigner.upload.placeholder": "Select file types allowed...",
    "formDesigner.upload.imageDescription": "Add an image by browsing or dragging and dropping it. It will be rendered in the control on the canvas once this dialog is closed.",
    "formDesigner.upload.imageTitle": "Upload Image",

    "formDesigner.defaultSubmitChange.title": "Change Default Submit Button",
    "formDesigner.defaultSubmitChange.desc": "{0} is currently configured to be the default submit button.  Do you want this button to be the default instead?",

    "formDesigner.control.missing": "Could not find form control. Please validate again.",
    "formDesigner.step.missing": "Could not find step. Please validate again.",

    "formDesigner.writeToTable.storeKey": "Store auto-increment key in",

    "formDesigner.writeToTable.selectDatastore": "Select a datastore...",

    "formDesigner.listBox.singleSelect": "Single selection",
    "formDesigner.listBox.multiSelect": "Multiple selection",

    "formDesigner.config.noValidators": "No Validators are configured for this form control.",
    "formDesigner.config.validatorExists": "The selected Validator is already applied to this form control.",
    "formDesigner.config.incompatibleValidator": "The selected Validator is incompatible with one or more configured for this form control.",

    "formDesigner.config.addValidator": "Add Validator",
    "formDesigner.external.reminder": "Reminder: The form must be activated before using external links.",

    "formDesigner.metadata.notSet": "(not set)",
    "formDesigner.metadata.required": "(Required)",

    "formDesigner.createPDF.uploadNew": "Upload New PDF Template",
    "formDesigner.legacy.image": "Selected image(s) cannot be copied.",

    "formDesigner.config.responsive.header": "Responsive Settings",
    "formDesigner.config.responsive.description": "Enable responsive behavior. This changes the form layout and control sizes based on screen size.",
    "formDesigner.config.responsive.expand": "Allow form elements to expand to fit the screen.",
    "formDesigner.config.responsive.confirm.title": "Changes to the Form",
    "formDesigner.config.responsive.confirm.button": "Make Form Responsive",
    "formDesigner.config.responsive.confirm.description": "Changing the form to be responsive will delete vertical lines and remove the tab index on all form elements. Are you sure you want to continue?",

    "formDesigner.config.responsive.spaceBetweenElements": "Space between form elements",
    "formDesigner.preview": "Preview {0}",
    "formDesigner.preview.description": "Use this preview as a guide for what a person will see as they fill out the form. Change sizes and hide or show elements to see how the form behaves. Datasources and submit actions are not available in the preview.",
    "formDesigner.preview.hideShow": "Show Conditional Controls",
    "formDesigner.preview.width.phone.small": "Small Phone (320px)",
    "formDesigner.preview.width.phone.large": "Large Phone (640px)",
    "formDesigner.preview.width.tablet.small": "Small Tablet (720px)",
    "formDesigner.preview.width.tablet.large": "Large Tablet (1080px)",
    "formDesigner.preview.width.desktop": "Desktop (1920px)",

    "formDesigner.controlIsResponsiveProblem": "Move this element to its own line for a good responsive experience.",
    "display.in.forms.panel": "display in Forms panel",

    "setAsDefault.button": "Set as Default",

    "bpmDesigner.node": "Node",
    "bpmDesigner.events": "Events",
    "bpmDesigner.activity": "Activity",
    "bpmDesigner.activities": "Activities",
    "bpmDesigner.activities.hold": "Hold",
    "bpmDesigner.activities.hold.props": "Hold Properties",
    "bpmDesigner.activities.subprocess": "Subprocess",
    "bpmDesigner.activities.subprocess.props": "Subprocess Properties",
    "bpmDesigner.activities.user.props": "User Properties",
    "bpmDesigner.activities.server.props": "Server Properties",
    "bpmDesigner.gateways": "Gateways",
    "bpmDesigner.gateways.decision": "Decision",
    "bpmDesigner.gateways.decision.props": "Decision Properties",
    "bpmDesigner.gateways.fork": "Fork",
    "bpmDesigner.gateways.join": "Gather Join",
    "bpmDesigner.annos": "Annotations",
    "bpmDesigner.anno": "Annotation",
    "bpmDesigner.config.none": "There are no additional configuration options for this node.",
    "bpm.library.add": "Save to Library",
    "bpm.library.label.desc": "Saving this task to the library will allow for easy reuse of the task. Enter a name for the library item. ",
    "bpmDesigner.node.missing": "Could not find node. Please validate again.",
    "bpmDesigner.config.feedback.success": "Success message",

    "bpmDesigner.dueDate": "Due Date",
    "bpmDesigner.dueDate.time": "time of day",
    "bpmDesigner.dueDate.day": "On a day of the month",
    "bpmDesigner.dueDate.date": "On a day of the year",
    "bpmDesigner.dueDate.complete": "an exact date",

    "bpmDesigner.elapsedTime": "Elapsed Time",
    "elapsedTime.hours": "business hours",
    "elapsedTime.days": "calendar days",

    "bpm.vars": "Process Variables",
    "bpm.vars.none": "No variables defined",
    "bpm.vars.add": "Add Process Instance Variable",
    "bpm.vars.desc": "Declare a variable that can be used throughout this process.",

    "bpm.prompts.desc": "Configure a prompt that is shown to the end user before starting the process. Prompt values are stored in process instance variables, and can be used to implement ad-hoc processes.",
    "bpm.promptTask.desc": "Configure the prompt form and prompts that display to the user. Set any conditions for running this task; enter the title, task description, and instructions displayed on the user prompt.",
    "bpm.prompts.add": "Add a prompt",
    "bpm.prompts.none": "No prompts defined",
    "bpm.prompts.text": "Read-only text",

    "prompt.type.multi": "Multi select",
    "prompt.var": "Variable name from value",

    "bpmDesigner.tasks.enter": "On Enter Tasks",
    "bpmDesigner.tasks.leave": "On Leave Tasks",
    "bpmDesigner.hold.settings": "Hold Settings",
    "bpmDesigner.hold.setting": "the hold setting",
    "bpmDesigner.hold.setting.date": "When to release hold",
    "bpmDesigner.server.tasks": "Service Tasks",
    "bpmDesigner.server.tasks.none": "No service tasks defined",
    "bpmDesigner.server.tasks.select": "Add a service task...",
    "bpmDesigner.server.tasks.library": "Service Task Library",
    "bpmDesigner.server.tasks.library.menu": "Service Task Library...",
    "bpmDesigner.server.tasks.library.desc": "Edit and delete your saved service tasks here.",
    "bpmDesigner.server.tasks.doesNotExist": "The plugin for this service task is not on the system.",
    "bpmDesigner.tasks.note.varName": "Variable to store Note ID",
    "bpmDesigner.server.tasks.note.delete.error.handle": "If error occurs, process should",
    "note.id": "Note ID",
    "edit.service.task": "Edit Service Task",
    "add.pi.instance": "Add Package Item to an instance",
    "bpmDesigner.tasks.rerun": "When should this Service Task run?",
    "bpmDesigner.tasks.rerun.label": "Reruns",
    "bpmDesigner.tasks.rerun.always": "Every distribution",
    "bpmDesigner.tasks.rerun.initial": "Initial distribution",
    "bpmDesigner.tasks.rerun.move": "Only on redistribution",
    "disposition.date.folder.set": "Set Folder Disposition Date",
    "disposition.date.folder.set.desc": "Choose a smart folder and set date to dispose of it.",
    "disposition.date": "Disposition Date",
    "disposition.date.desc": "Choose a date for which this folder should be disposed",
    "disposition.approve.all": "Approve All for Disposition",
    "disposition.approve.all.caution": "This action will approve and commit all {0} records in this disposition queue.",
    "disposition.postpone.all": "Postpone All from Disposition",
    "disposition.postpone.all.caution": "This action will postpone and commit all {0} records in this disposition queue.",

    "no.change": "(no change)",

    "datasource.summary.single": "name: {0}; single selection",
    "datasource.summary.multiple": "name: {0}; multiple selection",
    "datasource.summary.basic": "name: {0}",
    "datasource.summary.combo": "name: {0}; allow user input",
    "datasource.array": "Return an array of all items from datasource",

    "service.note.desc": "This task adds a new note by the user designated to the specified document.",
    "service.addPackage.desc": "This task sets the properties for the named Package Item and adds it to the designated Process Instance's package.",
    "service.repo.desc": "This task moves the specified document to the specified repository.",
    "service.repo.title": "Change Repository",
    "move.document.id": "Move document ID",
    "to.repo": "To repository",
    "service.checklist.title": "Create Checklist",
    "service.checklist.desc": "Enter the name of a variable to store a document ID, the checklist search name, and any prompt values to pass in.",
    "var.to.store.doc.id": "Variable to store Document ID",
    "var.to.store.doc.ids": "Variable to store Document IDs",
    "variable.result": "Variable name for results returned",
    "variable.error.result": "Variable name if error code returned",
    "service.url.title": "Run URL",
    "service.url.desc": "Enter the URL to be run, which can include a variable or macro as a parameter. Enter the variable names to store a returned value: either the URL result or an error code.",
    "service.deleteDoc.desc": "This task deletes, and optionally purges, the specified document.",
    "service.addDocToFolder.desc": "Specify the document and folder to continue this task.",
    "service.replaceDoc.desc": "This service task will replace an existing DocFinity document.",
    "purge.deleted.doc": "Purge deleted document",
    "purge.deleted.docs": "Purge deleted documents",
    "if.error.process": "If an error occurs process should",
    "variable.name": "Variable name",
    "variable.value": "Variable value",
    "service.exec.title": "Run Executable",
    "service.exec.desc": "Enter the full command path for the executable to start, any arguments to pass, and any additional settings needed.",
    "Command": "Command",
    "working.directory": "Working Directory",
    "output.processor": "Output Processor",
    "env.variables": "Environment Variables",
    "capture.event.title": "Capture Event",
    "capture.event.desc": "This task inserts a row in the CapturedBPMEvents table each time it runs, capturing data for reporting purposes.",
    "create.pointer.desc": "This task creates a pointer document based on another document.",
    "event.name": "Event name",
    "event.value": "Event value",
    "variable.for.docid": "Variable name for new Document ID",
    "import.to.docfinity": "Import to DocFinity",
    "import.service.desc": "Enter a file path or package item to import and set the variable to store the Document ID.",
    "item.to.import": "Item to Import",
    "copy.metadata.from.doc": "Copy metadata from existing document",
    "email.service.title": "Send Email",
    "email.service.desc": "Enter the address information and message for the email to be generated by the server. These fields can reference variables.",
    "email.service.attach.warn": "To ensure proper document security is applied, we recommend emailing folders and documents as links. Please note that a checklist cannot be sent as an attachment.",
    "sp.service.title": "Run Stored Procedure",
    "sp.service.desc": "Enter a description, select the database connection where the stored procedure exists, and the stored procedure to be run.",
    "output.variable": "Output variable",
    "index.service.title": "Index Metadata",
    "index.service.desc": "Enter a variable to reference the Document ID to be indexed and the metadata to be indexed.",
    "validate.indexing": "Validate indexing values",
    "ws.service.title": "Run SOAP Web Service",
    "ws.service.desc": "Select the SOAP web service connection and the method to be called. Provide input and map output.",
    "ws.type": "Web Service Type",
    "ws.df": "DocFinity Web Service",
    "result.name": "Result Name",
    "result.formatting": "Result Formatting",
    "custom.formatting": "Custom Formatting",
    "pip.service.title": "Set Package Item Properties",
    "pip.service.desc": "Set the Package Item name for a document or item expected in the process model, then set its property(s) by referencing a variable, macro, or static value.",
    "var.service.title": "Set Variable",
    "var.service.desc": "Enter a declared or default variable's name and the value to set.",
    "submit.form": "Submit Form",
    "submit.form.desc": "Set the form instance ID (referencing a form package item variable) to submit.",
    "delete.form.desc": "Set the form instance ID (referencing a form package item variable) to delete.",
    "create.form": "Create Form",
    "create.form.desc": "This task creates a new form instance of the specified design using any configured input values.",
    "st.deleteNote.desc": "This task deletes a single note added during the process, a specific type of note, or all notes on a document or folder.",
    "smartFolder.st.title": "Get Smart Folder",
    "smartFolder.st.desc": "Choose a smart folder to be used in the process.",
    "smartFolder.st.variable": "Variable to store Folder ID",
    "removeDoc.st.desc": "This service task removes a specified document from a specific folder.",
    "delete.folder.st.desc": "Specify the folder you wish to delete via this service task.",
    "simpleFolder.st.title": "Create Simple Folder",
    "simpleFolder.st.desc": "Create a simple folder to be used in the process.",
    "folder.st.addToPkg": "Add folder as package item to current instance",
    "store.form.submit.url": "Store Form Submit URL",
    "store.form.submit.url.desc": "This task stores the target URL for the #GetFormSubmitUrl() macro in the given form instance.",
    "service.combine.desc": "This task takes a list of document IDs, combines them into one new PDF document, and returns a single document ID.",
    "combine.array.document.ids": "Array of Document IDs to combine",
    "combine.variable.name": "Variable to store combined document ID",
    "service.pdfa.desc": "This task takes a DocFinity PDF document and creates a new PDF/A document from it.",
    "service.pdfa.var": "Variable to store PDF/A document ID",

    "bpmDesigner.hold.manual": "Manual Release",

    "bpmDesigner.hold.checklist.pkg": "Checklist Package Item",
    "bpmDesigner.hold.checklist.results": "Checklist results",
    "bpmDesigner.hold.checklist.help": "Configure the sub-searches in a Checklist Search that must be fulfilled before the hold is released.",
    "bpmDesigner.hold.checklist.empty": "There are no package items defined that could be checklist documents. Define the package item in the Start Node.",
    "bpmDesigner.hold.checklist.pollTime": "Time to begin polling",
    "bpmDesigner.hold.checklist.subSearches": "Sub-Searches to Fulfill",
    "bpmDesigner.hold.checklist.number": "Number to Fulfill",

    "bpm.pkg.none": "No package items defined",
    "bpm.pkg.add": "Add Package Item",
    "bpm.pkg.edit": "Edit Package Item",
    "bpm.pkg.view": "View Package Item",
    "bpm.pkg.desc": "Declare a Package Item that can be used throughout this process.",
    "bpm.pkg.required": "required to begin new Process Instances",
    "bpm.pkg.req.multiple": "You have an existing required package item configured. For more required package items, the process will require custom code. Do you want to continue saving or cancel the package item?",

    "dueDate.time": "On a time of day",
    "dueDate.day": "On a day of month",
    "dueDate.day.label": "Day of month",
    "dueDate.date": "On a day of year",
    "dueDate.complete": "On an exact date",

    "time.elapsed": "Time period",

    "bpm.subprocess.sent": "Items sent to Subprocess",
    "bpm.subprocess.returned": "Items returned from Subprocess",
    "bpm.subprocess.returnSent.desc": "Variables sent to the subprocess will be returned.",
    "bpm.subprocess.async": "Complete subprocess before continuing parent process",
    "bpm.subprocess.include": "Included variables",

    "bpm.user.tasks": "User Tasks",
    "bpm.user.tasks.select": "Add a user task...",
    "bpm.user.tasks.none": "No user tasks defined",
    "bpm.user.tasks.library": "User Task Library",
    "bpm.user.tasks.library.menu": "User Task Library...",
    "bpm.user.tasks.library.desc": "Edit or delete your saved user tasks here.",
    "bpm.user.tasks.edit": "Edit User Task - {0}",
    "bpm.user.tasks.view": "View User Task - {0}",
    "bpm.user.tasks.help": "User instructions",
    "bpm.user.tasks.redo": "Allow redo",
    "bpm.user.tasks.undo": "Allow undo and redo",
    "bpm.user.tasks.autoFirst": "Run automatically on first check out",
    "bpm.user.tasks.doesNotExist": "The plugin for this user task is not on the system.",
    "manual": "manually",
    "bpm.user.tasks.auto.first": "automatically on first check out",
    "bpm.user.tasks.auto.always": "automatically on every check out",
    "bpm.user.tasks.refreshPanels": "Open document and refresh relevant panels",
    "bpm.user.tasks.folder.refreshPanels": "Open folder",
    "bpm.user.tasks.notes.add": "Open notes in add mode",
    "bpm.user.tasks.docId.error": "ID of the document is missing. Task can not be completed.",
    "bpm.user.tasks.folderId.error": "ID of the folder is missing. Task can not be completed.",
    "bpm.user.tasks.formId.error": "ID of the form is missing. Task can not be completed.",
    "bpm.user.tasks.records.pi": "Records Package Item",
    "bpm.user.tasks.prompt.title": "Prompt window title",
    "bpm.user.tasks.form.varId": "Variable to store Form Instance ID",
    "bpm.task.complete.when": "Complete task on",
    "form.instance.id": "Form Instance ID",
    "form.mode": "Initial Form mode",
    "url.winName": "Named browser window",

    "bpm.user.job.desc": "Job description",
    "bpm.user.priority": "Job priority",
    "bpm.user.autocomplete": "When to auto-complete job",
    "bpm.user.auto.last": "Last task",
    "bpm.user.auto.required": "Last required task",
    "bpm.user.auto.none": "Don't auto-complete",
    "complete.task.button": "Complete Task Button",
    "complete.task.save.submit": "Save, Submit, or any Form Button",
    "complete.task.submit": "Submit or any Form Button",

    "bpmDesigner.userTasks.dueDate.desc": "This task lets the user change the date for completing this job. To use this User Task, a due date must be configured for this User Activity.",
    "bpmDesigner.userTasks.moveToQ.desc": "This task moves the job into the Personal Queue of the user who completes the task.",
    "bpmDesigner.userTasks.notes.desc": "This task opens the specified document or folder's notes. It can be configured to open in add mode for the user to easily add a note.",
    "bpmDesigner.userTasks.existingForm.desc": "This task opens the specified instance of an existing form",
    "bpmDesigner.userTasks.newForm.desc": "This task opens a new form instance of the specified design using any configured input values.",
    "bpmDesigner.userTasks.prompt.desc": "This task is a customized prompt form that displays to the user when they select the task.",
    "bpmDesigner.userTasks.reindex.desc": "This task opens the Index panel so the specified document's metadata can be edited.",
    "bpmDesigner.userTasks.records.desc": "This task lets users review records that have been queued for disposition. To use this task, at least one Records Package Item must be defined.",
    "bpmDesigner.userTasks.search.desc": "This task lets users run a pre-assigned search.",
    "bpmDesigner.userTasks.url.desc": "This task lets a user open the specified URL in a new browser window.",
    "bpmDesigner.userTasks.standard.desc": "A standard task gives instructions to a user to complete a task.",
    "bpmDesigner.userTasks.viewDoc.desc": "This task lets you configure a specified DocFinity document to open in the Viewer.",
    "bpmDesigner.userTasks.openFolder.desc": "This user task opens the specified folder in Results.",
    "bpmDesigner.userTasks.notes.type": "View notes on",
    "bpmDesigner.userTasks.quickIndex.desc": "This user task opens the Upload and Index dialog to let your user upload a document and index it during the process.",

    "bpmDesigner.decision.settings": "Decisions",

    "months.0": "January",
    "months.1": "February",
    "months.2": "March",
    "months.3": "April",
    "months.4": "May",
    "months.5": "June",
    "months.6": "July",
    "months.7": "August",
    "months.8": "September",
    "months.9": "October",
    "months.10": "November",
    "months.11": "December",

    "bpm.dist.type": "Distribution method",
    "bpm.dist.common": "Common Queue",
    "bpm.dist.broadcast": "Broadcast",
    "bpm.dist.least": "Least Load",
    "bpm.dist.prop": "Proportional",
    "bpm.dist.prop.label": "Proportion",
    "bpm.dist.prop.btn": "Assign Proportions...",
    "bpm.dist.prop.title": "Assign Proportions",
    "bpm.dist.prop.desc": "Assign group members to receive jobs.  Users with a higher proportion count will receive jobs at a higher rate than those with lower proportion counts.  Members not configured below will not receive any jobs.",
    "bpm.dist.prop.groupMissing": "A group with the configured name no longer exists.",
    "bpm.dist.prop.groupMembersMissing": "Group membership has been modified.  One or more users who were assigned proportions are removed from the group.  Please review the configuration below to ensure it is correct.",
    "bpm.dist.role": "Role-based",
    "bpm.dist.round": "Round Robin",
    "bpm.dist.person": "Specific Person",
    "bpm.dist.table": "Table-based",

    "bpm.dist.notify": "Notify user",
    "bpm.dist.email": "Edit Email...",
    "bpm.dist.email.ro": "View Email",
    "bpm.dist.email.title": "Email Notification",
    "bpm.dist.email.link": "include link to check out job",
    "bpm.dist.email.subject": "A DocFinity job has been distributed to you",
    "bpm.dist.email.message": "Please go to your DocFinity job queue to check out the job.",

    "bpm.dist.shifts": "Use shifts",
    "bpm.dist.attendance": "Use attendance",

    "role": "Role",

    "condition": "Condition",
    "default.set": "Set default",
    "condition.set": "Set condition",
    "conditions.none": "Create sequence flows from the decision node to configure decisions.",

    "security": "Security",

    "format.date": "Format: {0}",

    "variableFormat": "${{0}}",


    /**
     * Error page
     */
    "we.are.sorry": "We are sorry",
    "login.to.docfinity": "Login to DocFinity",
    "view.docfinity.help": "View DocFinity Help",
    "visit.docfinity.website": "Visit DocFinity's website",
    "error.status": "{0}: An unrecognized error occurred. Please contact your system administrator for assistance.",
    "error.status.conditional.404": "The content you are looking for could not be found. Please check the URL.",
    "error.status.conditional.403": "You do not have access to the content requested. Please contact your system administrator for assistance.",
    "error.status.conditional.503": "The DocFinity License is missing, invalid, or has expired. Please contact your system administrator for assistance.",
    "error.copy.1": "Copyright\u00A9 {0} Companion Data Services, LLC. All rights to possess, use, and permissions to use reserved.",
    "error.copy.2": "CONFIDENTIAL PROPERTY: The software making up the DocFinity\u00AE product family and its documentation (or any portion thereof) may not be sublicensed, transferred, copied, or re-distributed in any form or by any method without the prior written consent of Companion Data Services, LLC.",
    "error.copy.3": "DocFinity\u00AE is a registered trademark of Companion Data Services, LLC.",


    /**
     * ******************* Gateway and Gateway Designer **********************
     */

    "gateway.designer.title": "Gateway Designer",
    "gateway.name": "Gateway Name",
    "gateway.name.value": "Gateway Name: {0}",
    "gateway.page": "Gateway Page",
    "gateway.page.value": "Gateway Page: {0}",
    "gateway.page.path": "Path to the Gateway Page",
    "gateway.title": "Gateway Title",
    "gateway.designer.empty": "No Self-Service Gateways exist. Click Add New to create a new Self-Service Gateway.",
    "gateway.properties": "Gateway Properties",
    "gateway.properties.menu": "Gateway Properties...",
    "gateway.activate.success.concurrency": "The {0} gateway is successfully activated with the latest changes made by {1}.",
    "gateway.deactivate.success": "The {0} gateway is successfully deactivated.",
    "gateway.deactivate": "Deactivating will take this gateway 'offline'.  Users will no longer be able to access this gateway until you activate it. Do you want to continue?",
    "gateway.revert": "Reverting will discard all of the working copy changes and revert this Gateway to the configuration of the activated version. Do you want to continue?",
    "gateway.delete.confirm": "Gateway must be deactivated first before deleting.",
    "gateway.export.title": "Export Gateway",
    "gateway.export.desc": "This Gateway references the DocFinity components below. Please ensure the destination system has all components for a successful import of the Gateway.",
    "gateway.export.logo": "Export the Gateway logo with the Gateway",
    "gateway.export.favicon": "Export the Gateway favicon with the Gateway",
    "gateway.activating": "Activating Gateway...",
    "gateway.activate.on.import": "Activate on import",

    "header.desc.add": "Add header and description",
    "gateway.link.gateway": "Link to Gateway",
    "gateway.link.page": "Link to Page",
    "gateway.link.external": "Link to External URL",
    "gateway.link.add": "Add a Link",
    "gateway.link.edit": "Edit Link",
    "gateway.link.label": "Link Label",
    "gateway.link.type": "What do you want to link to?",
    "gateway.link.groups.label": "Who should see this link?",
    "gateway.link.paste.removed": "Some links referenced pages that do not exist in this Gateway. We've removed these links.",
    "gateway.auth": "Who should be allowed into the Gateway?",
    "users.internal": "Internal DocFinity Users",
    "public.access": "Public Access",
    "public.access.group": "Public Access Group",
    "gateway.logo": "Gateway Logo",
    "gateway.logo.none": "No Logo",
    "gateway.logo.manage": "Manage Logos",
    "gateway.logo.manage.title": "Manage Gateway Logos",
    "gateway.logo.manage.desc": "Add and delete Gateway logos. These logos are shared across all Gateways in the system.",
    "gateway.logo.manage.add": "Add New Logo",
    "gateway.logo.dropText": "Drop png or jpg files here to upload",
    "gateway.favicon": "Gateway Favicon",
    "gateway.favicon.none": "No Favicon",
    "gateway.favicon.manage": "Manage Favicons",
    "gateway.favicon.manage.title": "Manage Gateway Favicons",
    "gateway.favicon.manage.desc": "Add and delete Gateway favicons. These favicons are shared across all Gateways in the system.",
    "gateway.favicon.manage.add": "Add New Favicon",
    "gateway.favicon.dropText": "Drop png or ico files here to upload",
    "gateway.doc.embed.test.warning": "More than 1 document returned",
    "gateway.doc.embed.test.error": "0 documents returned",
    "gateway.doc.embed.test.success": "1 document returned",
    "gateway.doc.embed.noAccess": "Please use our Test Working Copy feature to ensure the configuration of this document is working properly.",

    "gateway.pageMissing": "Page Missing",
    "gateway.pageMissingDescription": "You have landed on a page that either has been removed or does not exist.",
    "gateway.notfound": "Gateway Does Not Exist",
    "gateway.forbiddenPage": "Sorry, you do not have permission to access this page.",

    "gateway.breadcrumbArrow": "Breadcrumb Arrow",
    "form.actions": "Form Actions",

    "page.delete.causes": "Deleting this page also removed {0} links and references to this page.",
    "page.root": "Home Page",
    "home": "Home",
    "home.switch": "Make This the Home Page",
    "home.switch.success": "Home page was successfully replaced by {0}.",
    "page.add": "+ Add a Page",
    "page.title": "Page Title",
    "page.properties": "Page Properties",
    "page.existing": "Existing Page",
    "page.new": "New Page",
    "page.layout": "Page Layout",
    "page.layout.top": "Inserted content top",
    "page.layout.bottom": "Inserted content bottom",
    "page.layout.left": "Inserted content left",
    "page.layout.right": "Inserted content right",
    "page.create": "Create a Page",
    "page.add.title": "Add a Page",

    "section.add": "+ Add a Section",
    "section.add.basic": "Add a Section",

    "quick.nav": "Quick Nav",

    "header": "Header",
    "headers": "Headers",
    "header.delete": "Delete Header",
    "header.auth.bearer": "Bearer Authorization Header",
    "header.override": "Override Header",

    "page.embed.label": "Insert Content",
    "page.embed.add": "Add Inserted Content",
    "page.embed.edit": "Edit Inserted Content",
    "page.embed.type": "What do you want to insert?",
    "gateway.doc.test": "Test Document Configuration",
    "gateway.test.banner.text": "You are testing {0}.  All functionality is fully enabled.",

    "empty.canvas": "Nothing here yet!",
    "gateway.empty.canvas.desc": "You haven't added anything to the page yet. Get started by linking to DocFinity content. You can also display a document, Form, Search, or Business Process prompts right on the page.",
    "gateway.link.add.desc": "Section with a link to content",
    "gateway.section.add.desc": "Header, text, and links",
    "gateway.insert.options": "Document, Folder, Form, Search, Start Business Process",
    "gateway.error.code": "Error Code: {0} Please contact your administrator to fix this issue.",
    "gateway.error.nocode": "Oops...Something went wrong. Please contact your administrator to fix this issue.",
    "gateway.error.init": "Error loading the Gateway",
    "gateway.error": "Gateway Error",
    "gateway.searchExecuting": "Search Executing...",
    "gateway.promptsResetting": "Prompts Resetting...",
    "sort.by": "Sort by: ",
    "support.contact.assign": "Assign as a support contact",
    "download.allow.native": "Allow Download as Native",
    "download.allow.pdf": "Allow Download as PDF",
    "replace.allow": "Allow Replace",
    "button.text": "Button Text",
    "url.launch": "Launch URL",
    "action.type": "Action Type",
    "action.add": "Add Document Action",
    "gateway.doc.actions.show": "Show Document Actions",
    "gateway.doc.actions.hide": "Hide Document Actions",
    "gateway.folder.actions.show": "Show Folder Actions",
    "gateway.folder.actions.hide": "Hide Folder Actions",
    "gateway.url": "Activated Gateway Link",
    "gateway.url.inactive.warning": "Your Gateway is not currently activated, you must activate the Gateway before this link will work.",
    "gateway.test.link": "Test Working Copy Link",
    "gateway.url.test.inactive.warning": "Testing mode is currently disabled, you must enable it before this link will work.",
    "include.notes": "Include notes",
    "notes.all": "All Notes",
    "notes.one": "Single Note",
    "notes.byType": "By Note Type",

    "gateway.test": "Test Working Copy",
    "gateway.test.on": "Enable Testing Working Copy",
    "gateway.test.url": "Test Working Copy URL",
    "gateway.test.desc": "Test Working Copy allows users to access the working copy of a Gateway and test its functionality. All content and actions within the working copy of the Gateway will be fully functioning.",
    "gateway.test.ended": "The Test Working Copy functionality has been disabled.",
    "gateway.test.toggle": "{0} Test Mode",

    "gateway.process.starting": "Submitting {0}...",

    "gateway.searchResults.loadMore": "Load More Results",
    "gateway.searchResults.endOfResults": "End of results",

    "copy.section": "Copy Section",
    "paste.section": "Paste Section",
    "copy.embed": "Copy Inserted Content",
    "paste.embed": "Paste inserted content",

    "undo": "Undo",
    "redo": "Redo",
    "json": "JSON",
    "json.path": "JSON path",
    "raw": "Raw",
    "output.column.delete": "Delete Output Column",
    "http.method.get": "GET",
    "http.method.post": "POST",
    "http.method.put": "PUT",
    "http.method.delete": "DELETE",
    "macro.json": "Macro/JSON",
    "json.preview": "Preview JSON",
    "json.preview.link": "Preview the JSON output",
    "json.preview.help": "to help construct your JSON Path",
    "json.path.key": "JSON path for key",

    "file.removed": "File removed",

    "optional.variables": "Optional Variables",
    "date.by": "By Date",
    "error.by": "By Error",
    "docType.by": "By Document Type",
    "fileType.by": "By File Type",
    "integrations": "Integrations",
    "integrations.desc": "Set up DocFinity with third party integrations.",
    "integrations.365": "Microsoft 365",
    "integrations.365.desc": "The manifest file specifies how our add-ins integrate with Microsoft 365 products. The Documents add-in can be used in Word, Excel, and PowerPoint. Once downloaded, it can be uploaded in the admin center of Microsoft 365.",
    "integrations.365.outlook.download": "Manifest for Outlook Add-In",
    "integrations.365.documents.download": "Manifest for Documents Add-In",
    "integrations.exchange.online": "Exchange Online",
    "integrations.exchange.online.ms": "Microsoft Exchange Online",
    "integrations.exchange.online.description": "Configure properties to allow DocFinity to connect to Microsoft Exchange Online. A working configuration is required to use some parts of DocFinity like importers that use Microsoft Exchange Online.",
    "integrations.exchange.online.appId": "Application (client) ID",
    "integrations.exchange.online.directoryId": "Directory (tenant) ID",
    "integrations.exchange.online.importer.info": "Microsoft Exchange Online must be configured on the Integrations screen."
});
